//#region \0rolldown/runtime.js
var e = Object.create, t = Object.defineProperty, n = Object.getOwnPropertyDescriptor, r = Object.getOwnPropertyNames, i = Object.getPrototypeOf, a = Object.prototype.hasOwnProperty, o = (e, t) => () => (e && (t = e(e = 0)), t), s = (e, t) => () => (t || (e((t = { exports: {} }).exports, t), e = null), t.exports), c = (e, n) => {
	let r = {};
	for (var i in e) t(r, i, {
		get: e[i],
		enumerable: !0
	});
	return n || t(r, Symbol.toStringTag, { value: "Module" }), r;
}, l = (e, i, o, s) => {
	if (i && typeof i == "object" || typeof i == "function") for (var c = r(i), l = 0, u = c.length, d; l < u; l++) d = c[l], !a.call(e, d) && d !== o && t(e, d, {
		get: ((e) => i[e]).bind(null, d),
		enumerable: !(s = n(i, d)) || s.enumerable
	});
	return e;
}, u = (n, r, a) => (a = n == null ? {} : e(i(n)), l(r || !n || !n.__esModule ? t(a, "default", {
	value: n,
	enumerable: !0
}) : a, n)), d = (e) => a.call(e, "module.exports") ? e["module.exports"] : l(t({}, "__esModule", { value: !0 }), e);
//#endregion
//#region ../../node_modules/xstate/dist/xstate-dev.esm.js
function f() {
	if (typeof globalThis < "u") return globalThis;
	if (typeof self < "u") return self;
	if (typeof window < "u") return window;
	if (typeof global < "u") return global;
}
function p() {
	let e = f();
	if (e.__xstate__) return e.__xstate__;
}
var m = (e) => {
	if (typeof window > "u") return;
	let t = p();
	t && t.register(e);
}, h = class {
	constructor(e) {
		this._process = e, this._active = !1, this._current = null, this._last = null;
	}
	start() {
		this._active = !0, this.flush();
	}
	clear() {
		this._current && (this._current.next = null, this._last = this._current);
	}
	enqueue(e) {
		let t = {
			value: e,
			next: null
		};
		if (this._current) {
			this._last.next = t, this._last = t;
			return;
		}
		this._current = t, this._last = t, this._active && this.flush();
	}
	flush() {
		for (; this._current;) {
			let e = this._current;
			this._process(e.value), this._current = e.next;
		}
		this._last = null;
	}
}, g = "", _ = "#", v = "*", y = "xstate.init", b = "xstate.stop";
function x(e, t) {
	return { type: `xstate.after.${e}.${t}` };
}
function S(e, t) {
	return {
		type: `xstate.done.state.${e}`,
		output: t
	};
}
function C(e, t) {
	return {
		type: `xstate.done.actor.${e}`,
		output: t,
		actorId: e
	};
}
function w(e, t) {
	return {
		type: `xstate.error.actor.${e}`,
		error: t,
		actorId: e
	};
}
function T(e) {
	return {
		type: y,
		input: e
	};
}
function E(e) {
	setTimeout(() => {
		throw e;
	});
}
var D = typeof Symbol == "function" && Symbol.observable || "@@observable";
function O(e, t) {
	let n = A(e), r = A(t);
	return typeof r == "string" ? typeof n == "string" ? r === n : !1 : typeof n == "string" ? n in r : Object.keys(n).every((e) => e in r ? O(n[e], r[e]) : !1);
}
function k(e) {
	if (F(e)) return e;
	let t = [], n = "";
	for (let r = 0; r < e.length; r++) {
		switch (e.charCodeAt(r)) {
			case 92:
				n += e[r + 1], r++;
				continue;
			case 46:
				t.push(n), n = "";
				continue;
		}
		n += e[r];
	}
	return t.push(n), t;
}
function A(e) {
	return vt(e) ? e.value : typeof e == "string" ? j(k(e)) : e;
}
function j(e) {
	if (e.length === 1) return e[0];
	let t = {}, n = t;
	for (let t = 0; t < e.length - 1; t++) if (t === e.length - 2) n[e[t]] = e[t + 1];
	else {
		let r = n;
		n = {}, r[e[t]] = n;
	}
	return t;
}
function M(e, t) {
	let n = {}, r = Object.keys(e);
	for (let i = 0; i < r.length; i++) {
		let a = r[i];
		n[a] = t(e[a], a, e, i);
	}
	return n;
}
function N(e) {
	return F(e) ? e : [e];
}
function P(e) {
	return e === void 0 ? [] : N(e);
}
function ee(e, t, n, r) {
	return typeof e == "function" ? e({
		context: t,
		event: n,
		self: r
	}) : e;
}
function F(e) {
	return Array.isArray(e);
}
function te(e) {
	return e.type.startsWith("xstate.error.actor");
}
function I(e) {
	return N(e).map((e) => e === void 0 || typeof e == "string" ? { target: e } : e);
}
function L(e) {
	if (!(e === void 0 || e === g)) return P(e);
}
function R(e, t, n) {
	let r = typeof e == "object", i = r ? e : void 0;
	return {
		next: (r ? e.next : e)?.bind(i),
		error: (r ? e.error : t)?.bind(i),
		complete: (r ? e.complete : n)?.bind(i)
	};
}
function z(e, t) {
	return `${t}.${e}`;
}
function ne(e, t) {
	let n = t.match(/^xstate\.invoke\.(\d+)\.(.*)/);
	if (!n) return e.implementations.actors[t];
	let [, r, i] = n, a = e.getStateNodeById(i).config.invoke;
	return (Array.isArray(a) ? a[r] : a).src;
}
function re(e, t) {
	if (t === e || t === v) return !0;
	if (!t.endsWith(".*")) return !1;
	let n = t.split("."), r = e.split(".");
	for (let e = 0; e < n.length; e++) {
		let t = n[e], i = r[e];
		if (t === "*") return e === n.length - 1;
		if (t !== i) return !1;
	}
	return !0;
}
function B(e, t) {
	return `${e.sessionId}.${t}`;
}
var ie = 0;
function V(e, t) {
	let n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new WeakMap(), a = /* @__PURE__ */ new Set(), o = {}, { clock: s, logger: c } = t, l = {
		schedule: (e, t, n, r, i = Math.random().toString(36).slice(2)) => {
			let a = {
				source: e,
				target: t,
				event: n,
				delay: r,
				id: i,
				startedAt: Date.now()
			}, c = B(e, i);
			u._snapshot._scheduledEvents[c] = a, o[c] = s.setTimeout(() => {
				delete o[c], delete u._snapshot._scheduledEvents[c], u._relay(e, t, n);
			}, r);
		},
		cancel: (e, t) => {
			let n = B(e, t), r = o[n];
			delete o[n], delete u._snapshot._scheduledEvents[n], r !== void 0 && s.clearTimeout(r);
		},
		cancelAll: (e) => {
			for (let t in u._snapshot._scheduledEvents) {
				let n = u._snapshot._scheduledEvents[t];
				n.source === e && l.cancel(e, n.id);
			}
		}
	}, u = {
		_snapshot: { _scheduledEvents: (t?.snapshot && t.snapshot.scheduler) ?? {} },
		_bookId: () => `x:${ie++}`,
		_register: (e, t) => (n.set(e, t), e),
		_unregister: (e) => {
			n.delete(e.sessionId);
			let t = i.get(e);
			t !== void 0 && (r.delete(t), i.delete(e));
		},
		get: (e) => r.get(e),
		getAll: () => Object.fromEntries(r.entries()),
		_set: (e, t) => {
			let n = r.get(e);
			if (n && n !== t) throw Error(`Actor with system ID '${e}' already exists.`);
			r.set(e, t), i.set(t, e);
		},
		inspect: (e) => {
			let t = R(e);
			return a.add(t), { unsubscribe() {
				a.delete(t);
			} };
		},
		_sendInspectionEvent: (t) => {
			if (!a.size) return;
			let n = {
				...t,
				rootId: e.sessionId
			};
			a.forEach((e) => e.next?.(n));
		},
		_relay: (e, t, n) => {
			u._sendInspectionEvent({
				type: "@xstate.event",
				sourceRef: e,
				actorRef: t,
				event: n
			}), t._send(n);
		},
		scheduler: l,
		getSnapshot: () => ({ _scheduledEvents: { ...u._snapshot._scheduledEvents } }),
		start: () => {
			let e = u._snapshot._scheduledEvents;
			u._snapshot._scheduledEvents = {};
			for (let t in e) {
				let { source: n, target: r, event: i, delay: a, id: o } = e[t];
				l.schedule(n, r, i, a, o);
			}
		},
		_clock: s,
		_logger: c
	};
	return u;
}
var ae = !1, H = /* @__PURE__ */ function(e) {
	return e[e.NotStarted = 0] = "NotStarted", e[e.Running = 1] = "Running", e[e.Stopped = 2] = "Stopped", e;
}({}), oe = {
	clock: {
		setTimeout: (e, t) => setTimeout(e, t),
		clearTimeout: (e) => clearTimeout(e)
	},
	logger: console.log.bind(console),
	devTools: !1
}, se = class {
	constructor(e, t) {
		this.logic = e, this._snapshot = void 0, this.clock = void 0, this.options = void 0, this.id = void 0, this.mailbox = new h(this._process.bind(this)), this.observers = /* @__PURE__ */ new Set(), this.eventListeners = /* @__PURE__ */ new Map(), this.logger = void 0, this._processingStatus = H.NotStarted, this._parent = void 0, this._syncSnapshot = void 0, this.ref = void 0, this._actorScope = void 0, this.systemId = void 0, this.sessionId = void 0, this.system = void 0, this._doneEvent = void 0, this.src = void 0, this._deferred = [];
		let n = {
			...oe,
			...t
		}, { clock: r, logger: i, parent: a, syncSnapshot: o, id: s, systemId: c, inspect: l } = n;
		this.system = a ? a.system : V(this, {
			clock: r,
			logger: i
		}), l && !a && this.system.inspect(R(l)), this.sessionId = this.system._bookId(), this.id = s ?? this.sessionId, this.logger = t?.logger ?? this.system._logger, this.clock = t?.clock ?? this.system._clock, this._parent = a, this._syncSnapshot = o, this.options = n, this.src = n.src ?? e, this.ref = this, this._actorScope = {
			self: this,
			id: this.id,
			sessionId: this.sessionId,
			logger: this.logger,
			defer: (e) => {
				this._deferred.push(e);
			},
			system: this.system,
			stopChild: (e) => {
				if (e._parent !== this) throw Error(`Cannot stop child actor ${e.id} of ${this.id} because it is not a child`);
				e._stop();
			},
			emit: (e) => {
				let t = this.eventListeners.get(e.type), n = this.eventListeners.get("*");
				if (!t && !n) return;
				let r = [...t ? t.values() : [], ...n ? n.values() : []];
				for (let t of r) try {
					t(e);
				} catch (e) {
					E(e);
				}
			},
			actionExecutor: (e) => {
				let t = () => {
					if (this._actorScope.system._sendInspectionEvent({
						type: "@xstate.action",
						actorRef: this,
						action: {
							type: e.type,
							params: e.params
						}
					}), !e.exec) return;
					let t = ae;
					try {
						ae = !0, e.exec(e.info, e.params);
					} finally {
						ae = t;
					}
				};
				this._processingStatus === H.Running ? t() : this._deferred.push(t);
			}
		}, this.send = this.send.bind(this), this.system._sendInspectionEvent({
			type: "@xstate.actor",
			actorRef: this
		}), c && (this.systemId = c, this.system._set(c, this)), this._initState(t?.snapshot ?? t?.state), c && this._snapshot.status !== "active" && this.system._unregister(this);
	}
	_initState(e) {
		try {
			this._snapshot = e ? this.logic.restoreSnapshot ? this.logic.restoreSnapshot(e, this._actorScope) : e : this.logic.getInitialSnapshot(this._actorScope, this.options?.input);
		} catch (e) {
			this._snapshot = {
				status: "error",
				output: void 0,
				error: e
			};
		}
	}
	update(e, t) {
		this._snapshot = e;
		let n;
		for (; n = this._deferred.shift();) try {
			n();
		} catch (t) {
			this._deferred.length = 0, this._snapshot = {
				...e,
				status: "error",
				error: t
			};
		}
		switch (this._snapshot.status) {
			case "active":
				for (let t of this.observers) try {
					t.next?.(e);
				} catch (e) {
					E(e);
				}
				break;
			case "done":
				for (let t of this.observers) try {
					t.next?.(e);
				} catch (e) {
					E(e);
				}
				this._stopProcedure(), this._complete(), this._doneEvent = C(this.id, this._snapshot.output), this._parent && this.system._relay(this, this._parent, this._doneEvent);
				break;
			case "error":
				this._error(this._snapshot.error);
				break;
		}
		this.system._sendInspectionEvent({
			type: "@xstate.snapshot",
			actorRef: this,
			event: t,
			snapshot: e
		});
	}
	subscribe(e, t, n) {
		let r = R(e, t, n);
		if (this._processingStatus !== H.Stopped) this.observers.add(r);
		else switch (this._snapshot.status) {
			case "done":
				try {
					r.complete?.();
				} catch (e) {
					E(e);
				}
				break;
			case "error": {
				let e = this._snapshot.error;
				if (!r.error) E(e);
				else try {
					r.error(e);
				} catch (e) {
					E(e);
				}
				break;
			}
		}
		return { unsubscribe: () => {
			this.observers.delete(r);
		} };
	}
	on(e, t) {
		let n = this.eventListeners.get(e);
		n || (n = /* @__PURE__ */ new Set(), this.eventListeners.set(e, n));
		let r = t.bind(void 0);
		return n.add(r), { unsubscribe: () => {
			n.delete(r);
		} };
	}
	select(e, t = Object.is) {
		return {
			subscribe: (n) => {
				let r = R(n), i = e(this.getSnapshot());
				return this.subscribe((n) => {
					let a = e(n);
					t(i, a) || (i = a, r.next?.(a));
				});
			},
			get: () => e(this.getSnapshot())
		};
	}
	start() {
		if (this._processingStatus === H.Running) return this;
		this._syncSnapshot && this.subscribe({
			next: (e) => {
				e.status === "active" && this.system._relay(this, this._parent, {
					type: `xstate.snapshot.${this.id}`,
					snapshot: e
				});
			},
			error: () => {}
		}), this.system._register(this.sessionId, this), this.systemId && this.system._set(this.systemId, this), this._processingStatus = H.Running;
		let e = T(this.options.input);
		switch (this.system._sendInspectionEvent({
			type: "@xstate.event",
			sourceRef: this._parent,
			actorRef: this,
			event: e
		}), this._snapshot.status) {
			case "done": return this.update(this._snapshot, e), this;
			case "error": return this._error(this._snapshot.error), this;
		}
		if (this._parent || this.system.start(), this.logic.start) try {
			this.logic.start(this._snapshot, this._actorScope);
		} catch (e) {
			return this._snapshot = {
				...this._snapshot,
				status: "error",
				error: e
			}, this._error(e), this;
		}
		return this.update(this._snapshot, e), this.options.devTools && this.attachDevTools(), this.mailbox.start(), this;
	}
	_process(e) {
		let t, n;
		try {
			t = this.logic.transition(this._snapshot, e, this._actorScope);
		} catch (e) {
			n = { err: e };
		}
		if (n) {
			let { err: e } = n;
			this._snapshot = {
				...this._snapshot,
				status: "error",
				error: e
			}, this._error(e);
			return;
		}
		this.update(t, e), e.type === "xstate.stop" && (this._stopProcedure(), this._complete());
	}
	_stop() {
		return this._processingStatus === H.Stopped ? this : (this.mailbox.clear(), this._processingStatus === H.NotStarted ? (this._processingStatus = H.Stopped, this) : (this.mailbox.enqueue({ type: b }), this));
	}
	stop() {
		if (this._parent) throw Error("A non-root actor cannot be stopped directly.");
		return this._stop();
	}
	_complete() {
		for (let e of this.observers) try {
			e.complete?.();
		} catch (e) {
			E(e);
		}
		this.observers.clear(), this.eventListeners.clear();
	}
	_reportError(e) {
		if (!this.observers.size) {
			this._parent || E(e), this.eventListeners.clear();
			return;
		}
		let t = !1;
		for (let n of this.observers) {
			let r = n.error;
			t ||= !r;
			try {
				r?.(e);
			} catch (e) {
				E(e);
			}
		}
		this.observers.clear(), this.eventListeners.clear(), t && E(e);
	}
	_error(e) {
		this._stopProcedure(), this._reportError(e), this._parent && this.system._relay(this, this._parent, w(this.id, e));
	}
	_stopProcedure() {
		return this._processingStatus === H.Running ? (this.system.scheduler.cancelAll(this), this.mailbox.clear(), this.mailbox = new h(this._process.bind(this)), this._processingStatus = H.Stopped, this.system._unregister(this), this) : this;
	}
	_send(e) {
		this._processingStatus !== H.Stopped && this.mailbox.enqueue(e);
	}
	send(e) {
		this.system._relay(void 0, this, e);
	}
	attachDevTools() {
		let { devTools: e } = this.options;
		e && (typeof e == "function" ? e : m)(this);
	}
	toJSON() {
		return {
			xstate$$type: 1,
			id: this.id
		};
	}
	getPersistedSnapshot(e) {
		return this.logic.getPersistedSnapshot(this._snapshot, e);
	}
	[D]() {
		return this;
	}
	getSnapshot() {
		return this._snapshot;
	}
};
function ce(e, ...[t]) {
	return new se(e, t);
}
function le(e, t, n, r, { sendId: i }) {
	return [
		t,
		{ sendId: typeof i == "function" ? i(n, r) : i },
		void 0
	];
}
function ue(e, t) {
	e.defer(() => {
		e.system.scheduler.cancel(e.self, t.sendId);
	});
}
function de(e) {
	function t(e, t) {}
	return t.type = "xstate.cancel", t.sendId = e, t.resolve = le, t.execute = ue, t;
}
function fe(e, t, n, r, { id: i, systemId: a, src: o, input: s, syncSnapshot: c }) {
	let l = typeof o == "string" ? ne(t.machine, o) : o, u = typeof i == "function" ? i(n) : i, d, f;
	return l && (f = typeof s == "function" ? s({
		context: t.context,
		event: n.event,
		self: e.self
	}) : s, d = ce(l, {
		id: u,
		src: o,
		parent: e.self,
		syncSnapshot: c,
		systemId: a,
		input: f
	})), [
		Tt(t, { children: {
			...t.children,
			[u]: d
		} }),
		{
			id: i,
			systemId: a,
			actorRef: d,
			src: o,
			input: f
		},
		void 0
	];
}
function pe(e, { actorRef: t }) {
	t && e.defer(() => {
		t._processingStatus !== H.Stopped && t.start();
	});
}
function me(...[e, { id: t, systemId: n, input: r, syncSnapshot: i = !1 } = {}]) {
	function a(e, t) {}
	return a.type = "xstate.spawnChild", a.id = t, a.systemId = n, a.src = e, a.input = r, a.syncSnapshot = i, a.resolve = fe, a.execute = pe, a;
}
function he(e, t, n, r, { actorRef: i }) {
	let a = typeof i == "function" ? i(n, r) : i, o = typeof a == "string" ? t.children[a] : a, s = t.children;
	return o && (s = { ...s }, delete s[o.id]), [
		Tt(t, { children: s }),
		o,
		void 0
	];
}
function ge(e, t) {
	let n = t.getSnapshot();
	if (n && "children" in n) for (let t of Object.values(n.children)) ge(e, t);
	e.system._unregister(t);
}
function _e(e, t) {
	if (t) {
		if (ge(e, t), t._processingStatus !== H.Running) {
			e.stopChild(t);
			return;
		}
		e.defer(() => {
			e.stopChild(t);
		});
	}
}
function ve(e) {
	function t(e, t) {}
	return t.type = "xstate.stopChild", t.actorRef = e, t.resolve = he, t.execute = _e, t;
}
function ye(e, { context: t, event: n }, { guards: r }) {
	return r.every((r) => xe(r, t, n, e));
}
function be(e) {
	function t(e, t) {
		return !1;
	}
	return t.check = ye, t.guards = e, t;
}
function xe(e, t, n, r) {
	let { machine: i } = r, a = typeof e == "function", o = a ? e : i.implementations.guards[typeof e == "string" ? e : e.type];
	if (!a && !o) throw Error(`Guard '${typeof e == "string" ? e : e.type}' is not implemented.'.`);
	if (typeof o != "function") return xe(o, t, n, r);
	let s = {
		context: t,
		event: n
	}, c = a || typeof e == "string" ? void 0 : "params" in e ? typeof e.params == "function" ? e.params({
		context: t,
		event: n
	}) : e.params : void 0;
	return "check" in o ? o.check(r, s, o) : o(s, c);
}
function Se(e) {
	return e.type === "atomic" || e.type === "final";
}
function U(e) {
	return Object.values(e.states).filter((e) => e.type !== "history");
}
function Ce(e, t) {
	let n = [];
	if (t === e) return n;
	let r = e.parent;
	for (; r && r !== t;) n.push(r), r = r.parent;
	return n;
}
function we(e) {
	let t = new Set(e), n = Ee(t);
	for (let e of t) if (e.type === "compound" && (!n.get(e) || !n.get(e).length)) ze(e).forEach((e) => t.add(e));
	else if (e.type === "parallel") {
		for (let n of U(e)) if (n.type !== "history" && !t.has(n)) {
			let e = ze(n);
			for (let n of e) t.add(n);
		}
	}
	for (let e of t) {
		let n = e.parent;
		for (; n;) t.add(n), n = n.parent;
	}
	return t;
}
function Te(e, t) {
	let n = t.get(e);
	if (!n) return {};
	if (e.type === "compound") {
		let e = n[0];
		if (e) {
			if (Se(e)) return e.key;
		} else return {};
	}
	let r = {};
	for (let e of n) r[e.key] = Te(e, t);
	return r;
}
function Ee(e) {
	let t = /* @__PURE__ */ new Map();
	for (let n of e) t.has(n) || t.set(n, []), n.parent && (t.has(n.parent) || t.set(n.parent, []), t.get(n.parent).push(n));
	return t;
}
function De(e, t) {
	return Te(e, Ee(we(t)));
}
function Oe(e, t) {
	return t.type === "compound" ? U(t).some((t) => t.type === "final" && e.has(t)) : t.type === "parallel" ? U(t).every((t) => Oe(e, t)) : t.type === "final";
}
var ke = (e) => e[0] === _;
function Ae(e, t) {
	let n = e.transitions.get(t), r = [...e.transitions.keys()].filter((e) => e !== t && re(t, e)).sort((e, t) => t.length - e.length).flatMap((t) => e.transitions.get(t));
	return n ? [...n, ...r] : r;
}
function je(e) {
	let t = e.config.after;
	if (!t) return [];
	let n = (t) => {
		let n = x(t, e.id), r = n.type;
		return e.entry.push(jt(n, {
			id: r,
			delay: t
		})), e.exit.push(de(r)), r;
	};
	return Object.keys(t).flatMap((e) => {
		let r = t[e], i = typeof r == "string" ? { target: r } : r, a = Number.isNaN(+e) ? e : +e, o = n(a);
		return P(i).map((e) => ({
			...e,
			event: o,
			delay: a
		}));
	}).map((t) => {
		let { delay: n } = t;
		return {
			...Me(e, t.event, t),
			delay: n
		};
	});
}
function Me(e, t, n) {
	let r = L(n.target), i = n.reenter ?? !1, a = Ie(e, r), o = {
		...n,
		actions: P(n.actions),
		guard: n.guard,
		target: a,
		source: e,
		reenter: i,
		eventType: t,
		toJSON: () => ({
			...o,
			source: `#${e.id}`,
			target: a ? a.map((e) => `#${e.id}`) : void 0
		})
	};
	return o;
}
function Ne(e) {
	let t = /* @__PURE__ */ new Map();
	if (e.config.on) for (let n of Object.keys(e.config.on)) {
		if (n === "") throw Error("Null events (\"\") cannot be specified as a transition key. Use `always: { ... }` instead.");
		let r = e.config.on[n];
		t.set(n, I(r).map((t) => Me(e, n, t)));
	}
	if (e.config.onDone) {
		let n = `xstate.done.state.${e.id}`;
		t.set(n, I(e.config.onDone).map((t) => Me(e, n, t)));
	}
	for (let n of e.invoke) {
		if (n.onDone) {
			let r = `xstate.done.actor.${n.id}`;
			t.set(r, I(n.onDone).map((t) => Me(e, r, t)));
		}
		if (n.onError) {
			let r = `xstate.error.actor.${n.id}`;
			t.set(r, I(n.onError).map((t) => Me(e, r, t)));
		}
		if (n.onSnapshot) {
			let r = `xstate.snapshot.${n.id}`;
			t.set(r, I(n.onSnapshot).map((t) => Me(e, r, t)));
		}
	}
	for (let n of e.after) {
		let e = t.get(n.eventType);
		e || (e = [], t.set(n.eventType, e)), e.push(n);
	}
	return t;
}
function Pe(e) {
	let t = [], n = (r) => {
		Object.values(r).forEach((r) => {
			if (r.config.route && r.config.id) {
				let n = r.config.id, i = r.config.route.guard, a = ({ event: e }) => e.to === `#${n}`, o = {
					...r.config.route,
					guard: i ? be([a, i]) : a,
					target: `#${n}`
				};
				t.push(Me(e, "xstate.route", o));
			}
			r.states && n(r.states);
		});
	};
	n(e.states), t.length > 0 && e.transitions.set("xstate.route", t);
}
function Fe(e, t) {
	let n = typeof t == "string" ? e.states[t] : t ? e.states[t.target] : void 0;
	if (!n && t) throw Error(`Initial state node "${t}" not found on parent state node #${e.id}`);
	let r = {
		source: e,
		actions: !t || typeof t == "string" ? [] : P(t.actions),
		eventType: null,
		reenter: !1,
		target: n ? [n] : [],
		toJSON: () => ({
			...r,
			source: `#${e.id}`,
			target: n ? [`#${n.id}`] : []
		})
	};
	return r;
}
function Ie(e, t) {
	if (t !== void 0) return t.map((t) => {
		if (typeof t != "string") return t;
		if (ke(t)) return e.machine.getStateNodeById(t);
		let n = t[0] === ".";
		if (n && !e.parent) return He(e, t.slice(1));
		let r = n ? e.key + t : t;
		if (e.parent) try {
			return He(e.parent, r);
		} catch (t) {
			throw Error(`Invalid transition definition for state node '${e.id}':\n${t.message}`);
		}
		else throw Error(`Invalid target: "${t}" is not a valid target from the root node. Did you mean ".${t}"?`);
	});
}
function Le(e) {
	let t = L(e.config.target);
	return t ? { target: t.map((t) => typeof t == "string" ? He(e.parent, t) : t) } : e.parent.type === "parallel" ? { target: [e.parent] } : e.parent.initial;
}
function Re(e) {
	return e.type === "history";
}
function ze(e) {
	let t = Be(e);
	for (let n of t) for (let r of Ce(n, e)) t.add(r);
	return t;
}
function Be(e) {
	let t = /* @__PURE__ */ new Set();
	function n(e) {
		if (!t.has(e)) {
			if (t.add(e), e.type === "compound") n(e.initial.target[0]);
			else if (e.type === "parallel") for (let t of U(e)) n(t);
		}
	}
	return n(e), t;
}
function Ve(e, t) {
	if (ke(t)) return e.machine.getStateNodeById(t);
	if (!e.states) throw Error(`Unable to retrieve child state '${t}' from '${e.id}'; no child states exist.`);
	let n = e.states[t];
	if (!n) throw Error(`Child state '${t}' does not exist on '${e.id}'`);
	return n;
}
function He(e, t) {
	if (typeof t == "string" && ke(t)) try {
		return e.machine.getStateNodeById(t);
	} catch {}
	let n = k(t).slice(), r = e;
	for (; n.length;) {
		let e = n.shift();
		if (!e.length) break;
		r = Ve(r, e);
	}
	return r;
}
function Ue(e, t) {
	if (typeof t == "string") {
		let n = e.states[t];
		if (!n) throw Error(`State '${t}' does not exist on '${e.id}'`);
		return [e, n];
	}
	let n = Object.keys(t), r = n.map((t) => Ve(e, t)).filter(Boolean);
	return [e.machine.root, e].concat(r, n.reduce((n, r) => {
		let i = Ve(e, r);
		if (!i) return n;
		let a = Ue(i, t[r]);
		return n.concat(a);
	}, []));
}
function We(e, t, n, r) {
	let i = Ve(e, t).next(n, r);
	return !i || !i.length ? e.next(n, r) : i;
}
function Ge(e, t, n, r) {
	let i = Object.keys(t), a = qe(Ve(e, i[0]), t[i[0]], n, r);
	return !a || !a.length ? e.next(n, r) : a;
}
function Ke(e, t, n, r) {
	let i = [];
	for (let a of Object.keys(t)) {
		let o = t[a];
		if (!o) continue;
		let s = qe(Ve(e, a), o, n, r);
		s && i.push(...s);
	}
	return i.length ? i : e.next(n, r);
}
function qe(e, t, n, r) {
	return typeof t == "string" ? We(e, t, n, r) : Object.keys(t).length === 1 ? Ge(e, t, n, r) : Ke(e, t, n, r);
}
function Je(e) {
	return Object.keys(e.states).map((t) => e.states[t]).filter((e) => e.type === "history");
}
function Ye(e, t) {
	let n = e;
	for (; n.parent && n.parent !== t;) n = n.parent;
	return n.parent === t;
}
function Xe(e, t) {
	let n = new Set(e), r = new Set(t);
	for (let e of n) if (r.has(e)) return !0;
	for (let e of r) if (n.has(e)) return !0;
	return !1;
}
function Ze(e, t, n) {
	let r = /* @__PURE__ */ new Set();
	for (let i of e) {
		let e = !1, a = /* @__PURE__ */ new Set();
		for (let o of r) if (Xe(et([i], t, n), et([o], t, n))) if (Ye(i.source, o.source)) a.add(o);
		else {
			e = !0;
			break;
		}
		if (!e) {
			for (let e of a) r.delete(e);
			r.add(i);
		}
	}
	return Array.from(r);
}
function Qe(e) {
	let [t, ...n] = e;
	for (let e of Ce(t, void 0)) if (n.every((t) => Ye(t, e))) return e;
}
function $e(e, t) {
	if (!e.target) return [];
	let n = /* @__PURE__ */ new Set();
	for (let r of e.target) if (Re(r)) if (t[r.id]) for (let e of t[r.id]) n.add(e);
	else for (let e of $e(Le(r), t)) n.add(e);
	else n.add(r);
	return [...n];
}
function W(e, t) {
	let n = $e(e, t);
	if (!n) return;
	if (!e.reenter && n.every((t) => t === e.source || Ye(t, e.source))) return e.source;
	let r = Qe(n.concat(e.source));
	if (r) return r;
	if (!e.reenter) return e.source.machine.root;
}
function et(e, t, n) {
	let r = /* @__PURE__ */ new Set();
	for (let i of e) if (i.target?.length) {
		let e = W(i, n);
		i.reenter && i.source === e && r.add(e);
		for (let n of t) Ye(n, e) && r.add(n);
	}
	return [...r];
}
function tt(e, t) {
	if (e.length !== t.size) return !1;
	for (let n of e) if (!t.has(n)) return !1;
	return !0;
}
function nt(e, t, n, r, i) {
	return rt([{
		target: [...Be(e)],
		source: e,
		reenter: !0,
		actions: [],
		eventType: null,
		toJSON: null
	}], t, n, r, !0, i);
}
function rt(e, t, n, r, i, a) {
	let o = [];
	if (!e.length) return [t, o];
	let s = n.actionExecutor;
	n.actionExecutor = (e) => {
		o.push(e), s(e);
	};
	try {
		let s = new Set(t._nodes), c = t.historyValue, l = Ze(e, s, c), u = t;
		i || ([u, c] = ut(u, r, n, l, s, c, a, n.actionExecutor)), u = pt(u, r, n, l.flatMap((e) => e.actions), a, void 0), u = at(u, r, n, l, s, a, c, i);
		let d = [...s];
		u.status === "done" && (u = pt(u, r, n, d.sort((e, t) => t.order - e.order).flatMap((e) => e.exit), a, void 0));
		try {
			return c === t.historyValue && tt(t._nodes, s) ? [u, o] : [Tt(u, {
				_nodes: d,
				historyValue: c
			}), o];
		} catch (e) {
			throw e;
		}
	} finally {
		n.actionExecutor = s;
	}
}
function it(e, t, n, r, i) {
	if (r.output === void 0) return;
	let a = S(i.id, i.output !== void 0 && i.parent ? ee(i.output, e.context, t, n.self) : void 0);
	return ee(r.output, e.context, a, n.self);
}
function at(e, t, n, r, i, a, o, s) {
	let c = e, l = /* @__PURE__ */ new Set(), u = /* @__PURE__ */ new Set();
	ot(r, o, u, l), s && u.add(e.machine.root);
	let d = /* @__PURE__ */ new Set();
	for (let e of [...l].sort((e, t) => e.order - t.order)) {
		i.add(e);
		let r = [];
		r.push(...e.entry);
		for (let t of e.invoke) r.push(me(t.src, {
			...t,
			syncSnapshot: !!t.onSnapshot
		}));
		if (u.has(e)) {
			let t = e.initial.actions;
			r.push(...t);
		}
		if (c = pt(c, t, n, r, a, e.invoke.map((e) => e.id)), e.type === "final") {
			let r = e.parent, o = r?.type === "parallel" ? r : r?.parent, s = o || e;
			for (r?.type === "compound" && a.push(S(r.id, e.output === void 0 ? void 0 : ee(e.output, c.context, t, n.self))); o?.type === "parallel" && !d.has(o) && Oe(i, o);) d.add(o), a.push(S(o.id)), s = o, o = o.parent;
			if (o) continue;
			c = Tt(c, {
				status: "done",
				output: it(c, t, n, c.machine.root, s)
			});
		}
	}
	return c;
}
function ot(e, t, n, r) {
	for (let i of e) {
		let e = W(i, t);
		for (let a of i.target || []) !Re(a) && (i.source !== a || i.source !== e || i.reenter) && (r.add(a), n.add(a)), st(a, t, n, r);
		let a = $e(i, t);
		for (let o of a) {
			let a = Ce(o, e);
			e?.type === "parallel" && a.push(e), ct(r, t, n, a, !i.source.parent && i.reenter ? void 0 : e);
		}
	}
}
function st(e, t, n, r) {
	if (Re(e)) if (t[e.id]) {
		let i = t[e.id];
		for (let e of i) r.add(e), st(e, t, n, r);
		for (let a of i) lt(a, e.parent, r, t, n);
	} else {
		let i = Le(e);
		for (let a of i.target) r.add(a), i === e.parent?.initial && n.add(e.parent), st(a, t, n, r);
		for (let a of i.target) lt(a, e.parent, r, t, n);
	}
	else if (e.type === "compound") {
		let [i] = e.initial.target;
		Re(i) || (r.add(i), n.add(i)), st(i, t, n, r), lt(i, e, r, t, n);
	} else if (e.type === "parallel") for (let i of U(e).filter((e) => !Re(e))) [...r].some((e) => Ye(e, i)) || (Re(i) || (r.add(i), n.add(i)), st(i, t, n, r));
}
function ct(e, t, n, r, i) {
	for (let a of r) if ((!i || Ye(a, i)) && e.add(a), a.type === "parallel") for (let r of U(a).filter((e) => !Re(e))) [...e].some((e) => Ye(e, r)) || (e.add(r), st(r, t, n, e));
}
function lt(e, t, n, r, i) {
	ct(n, r, i, Ce(e, t));
}
function ut(e, t, n, r, i, a, o, s) {
	let c = e, l = et(r, i, a);
	l.sort((e, t) => t.order - e.order);
	let u;
	for (let e of l) for (let t of Je(e)) {
		let n;
		n = t.history === "deep" ? (t) => Se(t) && Ye(t, e) : (t) => t.parent === e, u ??= { ...a }, u[t.id] = Array.from(i).filter(n);
	}
	for (let e of l) c = pt(c, t, n, [...e.exit, ...e.invoke.map((e) => ve(e.id))], o, void 0), i.delete(e);
	return [c, u || a];
}
function dt(e, t) {
	return e.implementations.actions[t];
}
function ft(e, t, n, r, i, a) {
	let { machine: o } = e, s = e;
	for (let e of r) {
		let r = typeof e == "function", c = r ? e : dt(o, typeof e == "string" ? e : e.type), l = {
			context: s.context,
			event: t,
			self: n.self,
			system: n.system
		}, u = r || typeof e == "string" ? void 0 : "params" in e ? typeof e.params == "function" ? e.params({
			context: s.context,
			event: t
		}) : e.params : void 0;
		if (!c || !("resolve" in c)) {
			n.actionExecutor({
				type: typeof e == "string" ? e : typeof e == "object" ? e.type : e.name || "(anonymous)",
				info: l,
				params: u,
				exec: c
			});
			continue;
		}
		let d = c, [f, p, m] = d.resolve(n, s, l, u, c, i);
		s = f, "retryResolve" in d && a?.push([d, p]), "execute" in d && n.actionExecutor({
			type: d.type,
			info: l,
			params: p,
			exec: d.execute.bind(null, n, p)
		}), m && (s = ft(s, t, n, m, i, a));
	}
	return s;
}
function pt(e, t, n, r, i, a) {
	let o = a ? [] : void 0, s = ft(e, t, n, r, {
		internalQueue: i,
		deferredActorIds: a
	}, o);
	return o?.forEach(([e, t]) => {
		e.retryResolve(n, s, t);
	}), s;
}
function G(e, t, n, r) {
	let i = e, a = [];
	function o(e, t, r) {
		n.system._sendInspectionEvent({
			type: "@xstate.microstep",
			actorRef: n.self,
			event: t,
			snapshot: e[0],
			_transitions: r
		}), a.push(e);
	}
	if (t.type === "xstate.stop") return i = Tt(mt(i, t, n), { status: "stopped" }), o([i, []], t, []), {
		snapshot: i,
		microsteps: a
	};
	let s = t;
	if (s.type !== y) {
		let t = s, c = te(t), l = ht(t, i);
		if (c && !l.length) return i = Tt(e, {
			status: "error",
			error: t.error
		}), o([i, []], t, []), {
			snapshot: i,
			microsteps: a
		};
		let u = rt(l, e, n, s, !1, r);
		i = u[0], o(u, t, l);
	}
	let c = !0, l = e.machine.options?.maxIterations ?? Infinity, u = 0;
	for (; i.status === "active";) {
		if (u++, u > l) throw Error(`Infinite loop detected: the machine has processed more than ${l} microsteps without reaching a stable state. This usually happens when there's a cycle of transitions (e.g., eventless transitions or raised events causing state A -> B -> C -> A).`);
		let e = c ? gt(i, s) : [], t = e.length ? i : void 0;
		if (!e.length) {
			if (!r.length) break;
			s = r.shift(), e = ht(s, i);
		}
		let a = rt(e, i, n, s, !1, r);
		i = a[0], c = i !== t, o(a, s, e);
	}
	return i.status !== "active" && mt(i, s, n), {
		snapshot: i,
		microsteps: a
	};
}
function mt(e, t, n) {
	return pt(e, t, n, Object.values(e.children).map((e) => ve(e)), [], void 0);
}
function ht(e, t) {
	return t.machine.getTransitionData(t, e);
}
function gt(e, t) {
	let n = /* @__PURE__ */ new Set(), r = e._nodes.filter(Se);
	for (let i of r) loop: for (let r of [i].concat(Ce(i, void 0))) if (r.always) {
		for (let i of r.always) if (i.guard === void 0 || xe(i.guard, e.context, t, e)) {
			n.add(i);
			break loop;
		}
	}
	return Ze(Array.from(n), new Set(e._nodes), e.historyValue);
}
function _t(e, t) {
	return De(e, [...we(Ue(e, t))]);
}
function vt(e) {
	return !!e && typeof e == "object" && "machine" in e && "value" in e;
}
var yt = function(e) {
	return O(e, this.value);
}, bt = function(e) {
	return this.tags.has(e);
}, xt = function(e) {
	let t = this.machine.getTransitionData(this, e);
	return !!t?.length && t.some((e) => e.target !== void 0 || e.actions.length);
}, St = function() {
	let { _nodes: e, tags: t, machine: n, getMeta: r, toJSON: i, can: a, hasTag: o, matches: s, ...c } = this;
	return {
		...c,
		tags: Array.from(t)
	};
}, Ct = function() {
	return this._nodes.reduce((e, t) => (t.meta !== void 0 && (e[t.id] = t.meta), e), {});
};
function wt(e, t) {
	return {
		status: e.status,
		output: e.output,
		error: e.error,
		machine: t,
		context: e.context,
		_nodes: e._nodes,
		value: De(t.root, e._nodes),
		tags: new Set(e._nodes.flatMap((e) => e.tags)),
		children: e.children,
		historyValue: e.historyValue || {},
		matches: yt,
		hasTag: bt,
		can: xt,
		getMeta: Ct,
		toJSON: St
	};
}
function Tt(e, t = {}) {
	return wt({
		...e,
		...t
	}, e.machine);
}
function Et(e) {
	if (typeof e != "object" || !e) return {};
	let t = {};
	for (let n in e) {
		let r = e[n];
		Array.isArray(r) && (t[n] = r.map((e) => ({ id: e.id })));
	}
	return t;
}
function Dt(e, t) {
	let { _nodes: n, tags: r, machine: i, children: a, context: o, can: s, hasTag: c, matches: l, getMeta: u, toJSON: d, ...f } = e, p = {};
	for (let e in a) {
		let n = a[e];
		p[e] = {
			snapshot: n.getPersistedSnapshot(t),
			src: n.src,
			systemId: n.systemId,
			syncSnapshot: n._syncSnapshot
		};
	}
	return {
		...f,
		context: Ot(o),
		children: p,
		historyValue: Et(f.historyValue)
	};
}
function Ot(e) {
	let t;
	for (let n in e) {
		let r = e[n];
		if (r && typeof r == "object") if ("sessionId" in r && "send" in r && "ref" in r) t ??= Array.isArray(e) ? e.slice() : { ...e }, t[n] = {
			xstate$$type: 1,
			id: r.id
		};
		else {
			let i = Ot(r);
			i !== r && (t ??= Array.isArray(e) ? e.slice() : { ...e }, t[n] = i);
		}
	}
	return t ?? e;
}
function kt(e, t, n, r, { event: i, id: a, delay: o }, { internalQueue: s }) {
	let c = t.machine.implementations.delays;
	if (typeof i == "string") throw Error(`Only event objects may be used with raise; use raise({ type: "${i}" }) instead`);
	let l = typeof i == "function" ? i(n, r) : i, u;
	if (typeof o == "string") {
		let e = c && c[o];
		u = typeof e == "function" ? e(n, r) : e;
	} else u = typeof o == "function" ? o(n, r) : o;
	return typeof u != "number" && s.push(l), [
		t,
		{
			event: l,
			id: a,
			delay: u
		},
		void 0
	];
}
function At(e, t) {
	let { event: n, delay: r, id: i } = t;
	if (typeof r == "number") {
		e.defer(() => {
			let t = e.self;
			e.system.scheduler.schedule(t, t, n, r, i);
		});
		return;
	}
}
function jt(e, t) {
	function n(e, t) {}
	return n.type = "xstate.raise", n.event = e, n.id = t?.id, n.delay = t?.delay, n.resolve = kt, n.execute = At, n;
}
var Mt = /* @__PURE__ */ new WeakMap();
function Nt(e) {
	return {
		config: e,
		start: (t, n) => {
			let { self: r, system: i, emit: a } = n, o = {
				receivers: void 0,
				dispose: void 0
			};
			Mt.set(r, o), o.dispose = e({
				input: t.input,
				system: i,
				self: r,
				sendBack: (e) => {
					r.getSnapshot().status !== "stopped" && r._parent && i._relay(r, r._parent, e);
				},
				receive: (e) => {
					o.receivers ??= /* @__PURE__ */ new Set(), o.receivers.add(e);
				},
				emit: a
			});
		},
		transition: (e, t, n) => {
			let r = Mt.get(n.self);
			return t.type === "xstate.stop" ? (e = {
				...e,
				status: "stopped",
				error: void 0
			}, Mt.delete(n.self), r.receivers?.clear(), r.dispose?.(), e) : (r.receivers?.forEach((e) => e(t)), e);
		},
		getInitialSnapshot: (e, t) => ({
			status: "active",
			output: void 0,
			error: void 0,
			input: t
		}),
		getPersistedSnapshot: (e) => e,
		restoreSnapshot: (e) => e
	};
}
var Pt = "xstate.promise.resolve", Ft = "xstate.promise.reject", It = /* @__PURE__ */ new WeakMap();
function Lt(e) {
	return {
		config: e,
		transition: (e, t, n) => {
			if (e.status !== "active") return e;
			switch (t.type) {
				case Pt: {
					let n = t.data;
					return {
						...e,
						status: "done",
						output: n,
						input: void 0
					};
				}
				case Ft: return {
					...e,
					status: "error",
					error: t.data,
					input: void 0
				};
				case b: return It.get(n.self)?.abort(), It.delete(n.self), {
					...e,
					status: "stopped",
					input: void 0
				};
				default: return e;
			}
		},
		start: (t, { self: n, system: r, emit: i }) => {
			if (t.status !== "active") return;
			let a = new AbortController();
			It.set(n, a), Promise.resolve(e({
				input: t.input,
				system: r,
				self: n,
				signal: a.signal,
				emit: i
			})).then((e) => {
				n.getSnapshot().status === "active" && (It.delete(n), r._relay(n, n, {
					type: Pt,
					data: e
				}));
			}, (e) => {
				n.getSnapshot().status === "active" && (It.delete(n), r._relay(n, n, {
					type: Ft,
					data: e
				}));
			});
		},
		getInitialSnapshot: (e, t) => ({
			status: "active",
			output: void 0,
			error: void 0,
			input: t
		}),
		getPersistedSnapshot: (e) => e,
		restoreSnapshot: (e) => e
	};
}
//#endregion
//#region ../../node_modules/xstate/dist/assign-29f23f4d.esm.js
function Rt(e, { machine: t, context: n }, r, i) {
	let a = (a, o) => {
		if (typeof a == "string") {
			let s = ne(t, a);
			if (!s) throw Error(`Actor logic '${a}' not implemented in machine '${t.id}'`);
			let c = ce(s, {
				id: o?.id,
				parent: e.self,
				syncSnapshot: o?.syncSnapshot,
				input: typeof o?.input == "function" ? o.input({
					context: n,
					event: r,
					self: e.self
				}) : o?.input,
				src: a,
				systemId: o?.systemId
			});
			return i[c.id] = c, c;
		} else return ce(a, {
			id: o?.id,
			parent: e.self,
			syncSnapshot: o?.syncSnapshot,
			input: o?.input,
			src: a,
			systemId: o?.systemId
		});
	};
	return (t, n) => {
		let r = a(t, n);
		return i[r.id] = r, e.defer(() => {
			r._processingStatus !== H.Stopped && r.start();
		}), r;
	};
}
function zt(e, t, n, r, { assignment: i }) {
	if (!t.context) throw Error("Cannot assign to undefined `context`. Ensure that `context` is defined in the machine config.");
	let a = {}, o = {
		context: t.context,
		event: n.event,
		spawn: Rt(e, t, n.event, a),
		self: e.self,
		system: e.system
	}, s = {};
	if (typeof i == "function") s = i(o, r);
	else for (let e of Object.keys(i)) {
		let t = i[e];
		s[e] = typeof t == "function" ? t(o, r) : t;
	}
	return [
		Tt(t, {
			context: Object.assign({}, t.context, s),
			children: Object.keys(a).length ? {
				...t.children,
				...a
			} : t.children
		}),
		void 0,
		void 0
	];
}
function K(e) {
	function t(e, t) {}
	return t.type = "xstate.assign", t.assignment = e, t.resolve = zt, t;
}
//#endregion
//#region ../../node_modules/xstate/dist/StateMachine-5f345bba.esm.js
var Bt = /* @__PURE__ */ new WeakMap();
function Vt(e, t, n) {
	let r = Bt.get(e);
	return r ? t in r || (r[t] = n()) : (r = { [t]: n() }, Bt.set(e, r)), r[t];
}
var Ht = {}, Ut = (e) => typeof e == "string" ? { type: e } : typeof e == "function" ? "resolve" in e ? { type: e.type } : { type: e.name } : e, Wt = class e {
	constructor(t, n) {
		if (this.config = t, this.key = void 0, this.id = void 0, this.type = void 0, this.path = void 0, this.states = void 0, this.history = void 0, this.entry = void 0, this.exit = void 0, this.parent = void 0, this.machine = void 0, this.meta = void 0, this.output = void 0, this.order = -1, this.description = void 0, this.tags = [], this.transitions = void 0, this.always = void 0, this.parent = n._parent, this.key = n._key, this.machine = n._machine, this.path = this.parent ? this.parent.path.concat(this.key) : [], this.id = this.config.id || [this.machine.id, ...this.path].join("."), this.type = this.config.type || (this.config.states && Object.keys(this.config.states).length ? "compound" : this.config.history ? "history" : "atomic"), this.description = this.config.description, this.order = this.machine.idMap.size, this.machine.idMap.set(this.id, this), this.states = this.config.states ? M(this.config.states, (t, n) => new e(t, {
			_parent: this,
			_key: n,
			_machine: this.machine
		})) : Ht, this.type === "compound" && !this.config.initial) throw Error(`No initial state specified for compound state node "#${this.id}". Try adding { initial: "${Object.keys(this.states)[0]}" } to the state config.`);
		this.history = this.config.history === !0 ? "shallow" : this.config.history || !1, this.entry = P(this.config.entry).slice(), this.exit = P(this.config.exit).slice(), this.meta = this.config.meta, this.output = this.type === "final" || !this.parent ? this.config.output : void 0, this.tags = P(t.tags).slice();
	}
	_initialize() {
		this.transitions = Ne(this), this.config.always && (this.always = I(this.config.always).map((e) => Me(this, "", e))), Object.keys(this.states).forEach((e) => {
			this.states[e]._initialize();
		});
	}
	get definition() {
		return {
			id: this.id,
			key: this.key,
			version: this.machine.version,
			type: this.type,
			initial: this.initial ? {
				target: this.initial.target,
				source: this,
				actions: this.initial.actions.map(Ut),
				eventType: null,
				reenter: !1,
				toJSON: () => ({
					target: this.initial.target.map((e) => `#${e.id}`),
					source: `#${this.id}`,
					actions: this.initial.actions.map(Ut),
					eventType: null
				})
			} : void 0,
			history: this.history,
			states: M(this.states, (e) => e.definition),
			on: this.on,
			transitions: [...this.transitions.values()].flat().map((e) => ({
				...e,
				actions: e.actions.map(Ut)
			})),
			entry: this.entry.map(Ut),
			exit: this.exit.map(Ut),
			meta: this.meta,
			order: this.order || -1,
			output: this.output,
			invoke: this.invoke,
			description: this.description,
			tags: this.tags
		};
	}
	toJSON() {
		return this.definition;
	}
	get invoke() {
		return Vt(this, "invoke", () => P(this.config.invoke).map((e, t) => {
			let { src: n, systemId: r } = e, i = e.id ?? z(this.id, t), a = typeof n == "string" ? n : `xstate.invoke.${z(this.id, t)}`;
			return {
				...e,
				src: a,
				id: i,
				systemId: r,
				toJSON() {
					let { onDone: t, onError: n, ...r } = e;
					return {
						...r,
						type: "xstate.invoke",
						src: a,
						id: i
					};
				}
			};
		}));
	}
	get on() {
		return Vt(this, "on", () => [...this.transitions].flatMap(([e, t]) => t.map((t) => [e, t])).reduce((e, [t, n]) => (e[t] = e[t] || [], e[t].push(n), e), {}));
	}
	get after() {
		return Vt(this, "delayedTransitions", () => je(this));
	}
	get initial() {
		return Vt(this, "initial", () => Fe(this, this.config.initial));
	}
	next(e, t) {
		let n = t.type, r = [], i, a = Vt(this, `candidates-${n}`, () => Ae(this, n));
		for (let o of a) {
			let { guard: a } = o, s = e.context, c = !1;
			try {
				c = !a || xe(a, s, t, e);
			} catch (e) {
				let t = typeof a == "string" ? a : typeof a == "object" ? a.type : void 0;
				throw Error(`Unable to evaluate guard ${t ? `'${t}' ` : ""}in transition for event '${n}' in state node '${this.id}':\n${e.message}`);
			}
			if (c) {
				r.push(...o.actions), i = o;
				break;
			}
		}
		return i ? [i] : void 0;
	}
	get events() {
		return Vt(this, "events", () => {
			let { states: e } = this, t = new Set(this.ownEvents);
			if (e) for (let n of Object.keys(e)) {
				let r = e[n];
				if (r.states) for (let e of r.events) t.add(`${e}`);
			}
			return Array.from(t);
		});
	}
	get ownEvents() {
		let e = Object.keys(Object.fromEntries(this.transitions)), t = new Set(e.filter((e) => this.transitions.get(e).some((e) => !(!e.target && !e.actions.length && !e.reenter))));
		return Array.from(t);
	}
}, Gt = class e {
	constructor(e, t) {
		this.config = e, this.version = void 0, this.schemas = void 0, this.implementations = void 0, this.options = void 0, this.__xstatenode = !0, this.idMap = /* @__PURE__ */ new Map(), this.root = void 0, this.id = void 0, this.states = void 0, this.events = void 0, this.id = e.id || "(machine)", this.implementations = {
			actors: t?.actors ?? {},
			actions: t?.actions ?? {},
			delays: t?.delays ?? {},
			guards: t?.guards ?? {}
		}, this.version = this.config.version, this.schemas = this.config.schemas, this.options = {
			maxIterations: Infinity,
			...this.config.options
		}, this.transition = this.transition.bind(this), this.getInitialSnapshot = this.getInitialSnapshot.bind(this), this.getPersistedSnapshot = this.getPersistedSnapshot.bind(this), this.restoreSnapshot = this.restoreSnapshot.bind(this), this.start = this.start.bind(this), this.root = new Wt(e, {
			_key: this.id,
			_machine: this
		}), this.root._initialize(), Pe(this.root), this.states = this.root.states, this.events = this.root.events;
	}
	provide(t) {
		let { actions: n, guards: r, actors: i, delays: a } = this.implementations;
		return new e(this.config, {
			actions: {
				...n,
				...t.actions
			},
			guards: {
				...r,
				...t.guards
			},
			actors: {
				...i,
				...t.actors
			},
			delays: {
				...a,
				...t.delays
			}
		});
	}
	resolveState(e) {
		let t = _t(this.root, e.value), n = we(Ue(this.root, t));
		return wt({
			_nodes: [...n],
			context: e.context || {},
			children: {},
			status: Oe(n, this.root) ? "done" : e.status || "active",
			output: e.output,
			error: e.error,
			historyValue: e.historyValue
		}, this);
	}
	transition(e, t, n) {
		return G(e, t, n, []).snapshot;
	}
	microstep(e, t, n) {
		return G(e, t, n, []).microsteps.map(([e]) => e);
	}
	getTransitionData(e, t) {
		return qe(this.root, e.value, e, t) || [];
	}
	_getPreInitialState(e, t, n) {
		let { context: r } = this.config, i = wt({
			context: typeof r != "function" && r ? r : {},
			_nodes: [this.root],
			children: {},
			status: "active"
		}, this);
		return typeof r == "function" ? pt(i, t, e, [K(({ spawn: e, event: t, self: n }) => r({
			spawn: e,
			input: t.input,
			self: n
		}))], n, void 0) : i;
	}
	getInitialSnapshot(e, t) {
		let n = T(t), r = [], i = this._getPreInitialState(e, n, r), [a] = nt(this.root, i, e, n, r), { snapshot: o } = G(a, n, e, r);
		return o;
	}
	start(e) {
		Object.values(e.children).forEach((e) => {
			e.getSnapshot().status === "active" && e.start();
		});
	}
	getStateNodeById(e) {
		let t = k(e), n = t.slice(1), r = ke(t[0]) ? t[0].slice(1) : t[0], i = this.idMap.get(r);
		if (!i) throw Error(`Child state node '#${r}' does not exist on machine '${this.id}'`);
		return He(i, n);
	}
	get definition() {
		return this.root.definition;
	}
	toJSON() {
		return this.definition;
	}
	getPersistedSnapshot(e, t) {
		return Dt(e, t);
	}
	restoreSnapshot(e, t) {
		let n = {}, r = e.children;
		Object.keys(r).forEach((e) => {
			let i = r[e], a = i.snapshot, o = i.src, s = typeof o == "string" ? ne(this, o) : o;
			s && (n[e] = ce(s, {
				id: e,
				parent: t.self,
				syncSnapshot: i.syncSnapshot,
				snapshot: a,
				src: o,
				systemId: i.systemId
			}));
		});
		function i(e, t) {
			if (t instanceof Wt) return t;
			try {
				return e.machine.getStateNodeById(t.id);
			} catch {}
		}
		function a(e, t) {
			if (!t || typeof t != "object") return {};
			let n = {};
			for (let r in t) {
				let a = t[r];
				for (let t of a) {
					let a = i(e, t);
					a && (n[r] ??= [], n[r].push(a));
				}
			}
			return n;
		}
		let o = a(this.root, e.historyValue), s = wt({
			...e,
			children: n,
			_nodes: Array.from(we(Ue(this.root, e.value))),
			historyValue: o
		}, this), c = /* @__PURE__ */ new Set();
		function l(e, t) {
			if (!c.has(e)) {
				c.add(e);
				for (let n in e) {
					let r = e[n];
					if (r && typeof r == "object") {
						if ("xstate$$type" in r && r.xstate$$type === 1) {
							e[n] = t[r.id];
							continue;
						}
						l(r, t);
					}
				}
			}
		}
		return l(s.context, n), s;
	}
};
//#endregion
//#region ../../node_modules/xstate/dist/log-79409d72.esm.js
function Kt(e, t, n, r, { event: i }) {
	return [
		t,
		{ event: typeof i == "function" ? i(n, r) : i },
		void 0
	];
}
function qt(e, { event: t }) {
	e.defer(() => e.emit(t));
}
function Jt(e) {
	function t(e, t) {}
	return t.type = "xstate.emit", t.event = e, t.resolve = Kt, t.execute = qt, t;
}
var Yt = /* @__PURE__ */ function(e) {
	return e.Parent = "#_parent", e.Internal = "#_internal", e;
}({});
function Xt(e, t, n, r, { to: i, event: a, id: o, delay: s }, c) {
	let l = t.machine.implementations.delays;
	if (typeof a == "string") throw Error(`Only event objects may be used with sendTo; use sendTo({ type: "${a}" }) instead`);
	let u = typeof a == "function" ? a(n, r) : a, d;
	if (typeof s == "string") {
		let e = l && l[s];
		d = typeof e == "function" ? e(n, r) : e;
	} else d = typeof s == "function" ? s(n, r) : s;
	let f = typeof i == "function" ? i(n, r) : i, p;
	if (typeof f == "string") {
		if (p = f === Yt.Parent ? e.self._parent : f === Yt.Internal ? e.self : f.startsWith("#_") ? t.children[f.slice(2)] : c.deferredActorIds?.includes(f) ? f : t.children[f], !p) throw Error(`Unable to send event to actor '${f}' from machine '${t.machine.id}'.`);
	} else p = f || e.self;
	return [
		t,
		{
			to: p,
			targetId: typeof f == "string" ? f : void 0,
			event: u,
			id: o,
			delay: d
		},
		void 0
	];
}
function Zt(e, t, n) {
	typeof n.to == "string" && (n.to = t.children[n.to]);
}
function Qt(e, t) {
	e.defer(() => {
		let { to: n, event: r, delay: i, id: a } = t;
		if (typeof i == "number") {
			e.system.scheduler.schedule(e.self, n, r, i, a);
			return;
		}
		e.system._relay(e.self, n, r.type === "xstate.error" ? w(e.self.id, r.data) : r);
	});
}
function $t(e, t, n) {
	function r(e, t) {}
	return r.type = "xstate.sendTo", r.to = e, r.event = t, r.id = n?.id, r.delay = n?.delay, r.resolve = Xt, r.retryResolve = Zt, r.execute = Qt, r;
}
function q(e, t) {
	return $t(Yt.Parent, e, t);
}
function en(e, t) {
	return $t(e, ({ event: e }) => e, t);
}
function tn(e, t, n, r, { collect: i }) {
	let a = [], o = function(e) {
		a.push(e);
	};
	return o.assign = (...e) => {
		a.push(K(...e));
	}, o.cancel = (...e) => {
		a.push(de(...e));
	}, o.raise = (...e) => {
		a.push(jt(...e));
	}, o.sendTo = (...e) => {
		a.push($t(...e));
	}, o.sendParent = (...e) => {
		a.push(q(...e));
	}, o.spawnChild = (...e) => {
		a.push(me(...e));
	}, o.stopChild = (...e) => {
		a.push(ve(...e));
	}, o.emit = (...e) => {
		a.push(Jt(...e));
	}, i({
		context: n.context,
		event: n.event,
		enqueue: o,
		check: (e) => xe(e, t.context, n.event, t),
		self: e.self,
		system: e.system
	}, r), [
		t,
		void 0,
		a
	];
}
function nn(e) {
	function t(e, t) {}
	return t.type = "xstate.enqueueActions", t.collect = e, t.resolve = tn, t;
}
//#endregion
//#region ../../node_modules/xstate/dist/xstate.esm.js
function rn(e, t) {
	return new Gt(e, t);
}
//#endregion
//#region ../../node_modules/is-plain-object/dist/is-plain-object.mjs
function an(e) {
	return Object.prototype.toString.call(e) === "[object Object]";
}
function on(e) {
	var t, n;
	return an(e) === !1 ? !1 : (t = e.constructor, t === void 0 ? !0 : (n = t.prototype, !(an(n) === !1 || n.hasOwnProperty("isPrototypeOf") === !1)));
}
//#endregion
//#region ../../node_modules/object-path-immutable/esm/object-path-immutable.js
var sn = /* @__PURE__ */ u((/* @__PURE__ */ s(((e, t) => {
	(function(e, n) {
		/*istanbul ignore next:cant test*/
		typeof t == "object" && typeof t.exports == "object" ? t.exports = n() : e.objectPath = n();
	})(e, function() {
		var e = Object.prototype.toString;
		function t(e, t) {
			return e == null ? !1 : Object.prototype.hasOwnProperty.call(e, t);
		}
		function n(e) {
			if (!e || a(e) && e.length === 0) return !0;
			if (typeof e != "string") {
				for (var n in e) if (t(e, n)) return !1;
				return !0;
			}
			return !1;
		}
		function r(t) {
			return e.call(t);
		}
		function i(e) {
			return typeof e == "object" && r(e) === "[object Object]";
		}
		var a = Array.isArray || function(t) {
			/*istanbul ignore next:cant test*/
			return e.call(t) === "[object Array]";
		};
		function o(e) {
			return typeof e == "boolean" || r(e) === "[object Boolean]";
		}
		function s(e) {
			var t = parseInt(e);
			return t.toString() === e ? t : e;
		}
		function c(e) {
			e ||= {};
			var r = function(e) {
				return Object.keys(r).reduce(function(t, n) {
					return n === "create" || typeof r[n] == "function" && (t[n] = r[n].bind(r, e)), t;
				}, {});
			}, c = e.includeInheritedProps ? function() {
				return !0;
			} : function(e, n) {
				return typeof n == "number" && Array.isArray(e) || t(e, n);
			};
			function l(e, t) {
				if (c(e, t)) return e[t];
			}
			var u = e.includeInheritedProps ? function(e, t) {
				typeof t != "string" && typeof t != "number" && (t = String(t));
				var n = l(e, t);
				if (t === "__proto__" || t === "prototype" || t === "constructor" && typeof n == "function") throw Error("For security reasons, object's magic properties cannot be set");
				return n;
			} : function(e, t) {
				return l(e, t);
			};
			function d(e, t, n, r) {
				if (typeof t == "number" && (t = [t]), !t || t.length === 0) return e;
				if (typeof t == "string") return d(e, t.split(".").map(s), n, r);
				var i = t[0], a = u(e, i);
				return t.length === 1 ? ((a === void 0 || !r) && (e[i] = n), a) : (a === void 0 && (typeof t[1] == "number" ? e[i] = [] : e[i] = {}), d(e[i], t.slice(1), n, r));
			}
			return r.has = function(n, r) {
				if (typeof r == "number" ? r = [r] : typeof r == "string" && (r = r.split(".")), !r || r.length === 0) return !!n;
				for (var i = 0; i < r.length; i++) {
					var o = s(r[i]);
					if (typeof o == "number" && a(n) && o < n.length || (e.includeInheritedProps ? o in Object(n) : t(n, o))) n = n[o];
					else return !1;
				}
				return !0;
			}, r.ensureExists = function(e, t, n) {
				return d(e, t, n, !0);
			}, r.set = function(e, t, n, r) {
				return d(e, t, n, r);
			}, r.insert = function(e, t, n, i) {
				var o = r.get(e, t);
				i = ~~i, a(o) || (o = [], r.set(e, t, o)), o.splice(i, 0, n);
			}, r.empty = function(e, t) {
				if (!n(t) && e != null) {
					var s, l;
					if (s = r.get(e, t)) {
						if (typeof s == "string") return r.set(e, t, "");
						if (o(s)) return r.set(e, t, !1);
						if (typeof s == "number") return r.set(e, t, 0);
						if (a(s)) s.length = 0;
						else if (i(s)) for (l in s) c(s, l) && delete s[l];
						else return r.set(e, t, null);
					}
				}
			}, r.push = function(e, t) {
				var n = r.get(e, t);
				a(n) || (n = [], r.set(e, t, n)), n.push.apply(n, Array.prototype.slice.call(arguments, 2));
			}, r.coalesce = function(e, t, n) {
				for (var i, a = 0, o = t.length; a < o; a++) if ((i = r.get(e, t[a])) !== void 0) return i;
				return n;
			}, r.get = function(e, t, n) {
				if (typeof t == "number" && (t = [t]), !t || t.length === 0) return e;
				if (e == null) return n;
				if (typeof t == "string") return r.get(e, t.split("."), n);
				var i = s(t[0]), a = u(e, i);
				return a === void 0 ? n : t.length === 1 ? a : r.get(e[i], t.slice(1), n);
			}, r.del = function(e, t) {
				if (typeof t == "number" && (t = [t]), e == null || n(t)) return e;
				if (typeof t == "string") return r.del(e, t.split("."));
				var i = s(t[0]);
				if (u(e, i), !c(e, i)) return e;
				if (t.length === 1) a(e) ? e.splice(i, 1) : delete e[i];
				else return r.del(e[i], t.slice(1));
				return e;
			}, r;
		}
		var l = c();
		return l.create = c, l.withInheritedProps = c({ includeInheritedProps: !0 }), l;
	});
})))()), cn = Object.prototype.hasOwnProperty;
function ln(e) {
	if (un(e)) return !1;
	if (!e || fn(e) && e.length === 0) return !0;
	if (!dn(e)) {
		for (var t in e) if (cn.call(e, t)) return !1;
		return !0;
	}
	return !1;
}
function un(e) {
	return typeof e == "number";
}
function dn(e) {
	return typeof e == "string";
}
function fn(e) {
	return Array.isArray(e);
}
function pn(e, t) {
	for (var n in t) cn.call(t, n) && (e[n] = t[n]);
	return e;
}
function mn(e) {
	var t = parseInt(e);
	return t.toString() === e ? t : e;
}
function hn(e, t, n) {
	return e == null ? t ? n ? [] : {} : e : fn(e) ? e.slice() : pn({}, e);
}
function gn(e, t) {
	if (e !== t && on(e) && on(t)) {
		var n = {};
		for (var r in e) cn.call(e, r) && (cn.call(t, r) ? n[r] = gn(e[r], t[r]) : n[r] = e[r]);
		for (r in t) cn.call(t, r) && (n[r] = gn(e[r], t[r]));
		return n;
	}
	return t;
}
function _n(e, t, n, r) {
	if (un(n) && (n = [n]), ln(n)) return t;
	if (dn(n)) return _n(e, t, n.split(".").map(mn), r);
	var i = n[0];
	return (!e || e === t) && (e = hn(t, !0, un(i))), n.length === 1 ? r(e, i) : (t != null && (t = t[i]), e[i] = _n(e[i], t, n.slice(1), r), e);
}
var J = {};
J.set = function(e, t, n, r) {
	return ln(n) ? r : _n(e, t, n, function(e, t) {
		return e[t] = r, e;
	});
}, J.update = function(e, t, n, r) {
	return ln(n) ? r(hn(t)) : _n(e, t, n, function(e, t) {
		return e[t] = r(e[t]), e;
	});
}, J.push = function(e, t, n) {
	var r = Array.prototype.slice.call(arguments, 3);
	return ln(n) ? fn(t) ? t.concat(r) : r : _n(e, t, n, function(e, t) {
		return fn(e[t]) ? e[t] = e[t].concat(r) : e[t] = r, e;
	});
}, J.insert = function(e, t, n, r, i) {
	if (i = ~~i, ln(n)) {
		if (!fn(t)) return [r];
		var a = t.slice(0, i);
		return a.push(r), a.concat(t.slice(i));
	}
	return _n(e, t, n, function(e, t) {
		var a = e[t];
		if (!fn(a)) {
			if (a != null && a !== void 0) throw Error("Expected " + n + "to be an array. Instead got " + typeof n);
			a = [];
		}
		var o = a.slice(0, i);
		return o.push(r), e[t] = o.concat(a.slice(i)), e;
	});
}, J.del = function(e, t, n) {
	if (!ln(n)) return _n(e, t, n, function(e, t) {
		return Array.isArray(e) ? e[t] !== void 0 && e.splice(t, 1) : cn.call(e, t) && delete e[t], e;
	});
}, J.assign = function(e, t, n, r) {
	return ln(n) ? ln(r) ? t : pn(hn(t), r) : _n(e, t, n, function(e, t) {
		r = Object(r);
		var n = hn(e[t], !0);
		return pn(n, r), e[t] = n, e;
	});
}, J.merge = function(e, t, n, r) {
	return ln(n) ? ln(r) ? t : gn(t, r) : _n(e, t, n, function(e, t) {
		return r = Object(r), e[t] = gn(e[t], r), e;
	});
};
var vn = J.set.bind(null, null), yn = J.update.bind(null, null);
J.push.bind(null, null), J.insert.bind(null, null), J.del.bind(null, null), J.assign.bind(null, null), J.merge.bind(null, null);
var bn = sn.default.get, Y = [];
for (let e = 0; e < 256; ++e) Y.push((e + 256).toString(16).slice(1));
function xn(e, t = 0) {
	return (Y[e[t + 0]] + Y[e[t + 1]] + Y[e[t + 2]] + Y[e[t + 3]] + "-" + Y[e[t + 4]] + Y[e[t + 5]] + "-" + Y[e[t + 6]] + Y[e[t + 7]] + "-" + Y[e[t + 8]] + Y[e[t + 9]] + "-" + Y[e[t + 10]] + Y[e[t + 11]] + Y[e[t + 12]] + Y[e[t + 13]] + Y[e[t + 14]] + Y[e[t + 15]]).toLowerCase();
}
//#endregion
//#region ../../node_modules/uuid/dist/rng.js
var Sn = new Uint8Array(16);
function Cn() {
	return crypto.getRandomValues(Sn);
}
//#endregion
//#region ../../node_modules/uuid/dist/v4.js
function wn(e, t, n) {
	return !t && !e && crypto.randomUUID ? crypto.randomUUID() : Tn(e, t, n);
}
function Tn(e, t, n) {
	e ||= {};
	let r = e.random ?? e.rng?.() ?? Cn();
	if (r.length < 16) throw Error("Random bytes length must be >= 16");
	if (r[6] = r[6] & 15 | 64, r[8] = r[8] & 63 | 128, t) {
		if (n ||= 0, n < 0 || n + 16 > t.length) throw RangeError(`UUID byte range ${n}:${n + 15} is out of buffer bounds`);
		for (let e = 0; e < 16; ++e) t[n + e] = r[e];
		return t;
	}
	return xn(r);
}
//#endregion
//#region src/core/constants.js
var En = /* @__PURE__ */ u((/* @__PURE__ */ s(((e, t) => {
	var n = 200, r = "__lodash_hash_undefined__", i = 1, a = 2, o = 9007199254740991, s = "[object Arguments]", c = "[object Array]", l = "[object AsyncFunction]", u = "[object Boolean]", d = "[object Date]", f = "[object Error]", p = "[object Function]", m = "[object GeneratorFunction]", h = "[object Map]", g = "[object Number]", _ = "[object Null]", v = "[object Object]", y = "[object Promise]", b = "[object Proxy]", x = "[object RegExp]", S = "[object Set]", C = "[object String]", w = "[object Symbol]", T = "[object Undefined]", E = "[object WeakMap]", D = "[object ArrayBuffer]", O = "[object DataView]", k = "[object Float32Array]", A = "[object Float64Array]", j = "[object Int8Array]", M = "[object Int16Array]", N = "[object Int32Array]", P = "[object Uint8Array]", ee = "[object Uint8ClampedArray]", F = "[object Uint16Array]", te = "[object Uint32Array]", I = /[\\^$.*+?()[\]{}|]/g, L = /^\[object .+?Constructor\]$/, R = /^(?:0|[1-9]\d*)$/, z = {};
	z[k] = z[A] = z[j] = z[M] = z[N] = z[P] = z[ee] = z[F] = z[te] = !0, z[s] = z[c] = z[D] = z[u] = z[O] = z[d] = z[f] = z[p] = z[h] = z[g] = z[v] = z[x] = z[S] = z[C] = z[E] = !1;
	var ne = typeof global == "object" && global && global.Object === Object && global, re = typeof self == "object" && self && self.Object === Object && self, B = ne || re || Function("return this")(), ie = typeof e == "object" && e && !e.nodeType && e, V = ie && typeof t == "object" && t && !t.nodeType && t, ae = V && V.exports === ie, H = ae && ne.process, oe = function() {
		try {
			return H && H.binding && H.binding("util");
		} catch {}
	}(), se = oe && oe.isTypedArray;
	function ce(e, t) {
		for (var n = -1, r = e == null ? 0 : e.length, i = 0, a = []; ++n < r;) {
			var o = e[n];
			t(o, n, e) && (a[i++] = o);
		}
		return a;
	}
	function le(e, t) {
		for (var n = -1, r = t.length, i = e.length; ++n < r;) e[i + n] = t[n];
		return e;
	}
	function ue(e, t) {
		for (var n = -1, r = e == null ? 0 : e.length; ++n < r;) if (t(e[n], n, e)) return !0;
		return !1;
	}
	function de(e, t) {
		for (var n = -1, r = Array(e); ++n < e;) r[n] = t(n);
		return r;
	}
	function fe(e) {
		return function(t) {
			return e(t);
		};
	}
	function pe(e, t) {
		return e.has(t);
	}
	function me(e, t) {
		return e?.[t];
	}
	function he(e) {
		var t = -1, n = Array(e.size);
		return e.forEach(function(e, r) {
			n[++t] = [r, e];
		}), n;
	}
	function ge(e, t) {
		return function(n) {
			return e(t(n));
		};
	}
	function _e(e) {
		var t = -1, n = Array(e.size);
		return e.forEach(function(e) {
			n[++t] = e;
		}), n;
	}
	var ve = Array.prototype, ye = Function.prototype, be = Object.prototype, xe = B["__core-js_shared__"], Se = ye.toString, U = be.hasOwnProperty, Ce = function() {
		var e = /[^.]+$/.exec(xe && xe.keys && xe.keys.IE_PROTO || "");
		return e ? "Symbol(src)_1." + e : "";
	}(), we = be.toString, Te = RegExp("^" + Se.call(U).replace(I, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), Ee = ae ? B.Buffer : void 0, De = B.Symbol, Oe = B.Uint8Array, ke = be.propertyIsEnumerable, Ae = ve.splice, je = De ? De.toStringTag : void 0, Me = Object.getOwnPropertySymbols, Ne = Ee ? Ee.isBuffer : void 0, Pe = ge(Object.keys, Object), Fe = Pt(B, "DataView"), Ie = Pt(B, "Map"), Le = Pt(B, "Promise"), Re = Pt(B, "Set"), ze = Pt(B, "WeakMap"), Be = Pt(Object, "create"), Ve = Ht(Fe), He = Ht(Ie), Ue = Ht(Le), We = Ht(Re), Ge = Ht(ze), Ke = De ? De.prototype : void 0, qe = Ke ? Ke.valueOf : void 0;
	function Je(e) {
		var t = -1, n = e == null ? 0 : e.length;
		for (this.clear(); ++t < n;) {
			var r = e[t];
			this.set(r[0], r[1]);
		}
	}
	function Ye() {
		this.__data__ = Be ? Be(null) : {}, this.size = 0;
	}
	function Xe(e) {
		var t = this.has(e) && delete this.__data__[e];
		return this.size -= +!!t, t;
	}
	function Ze(e) {
		var t = this.__data__;
		if (Be) {
			var n = t[e];
			return n === r ? void 0 : n;
		}
		return U.call(t, e) ? t[e] : void 0;
	}
	function Qe(e) {
		var t = this.__data__;
		return Be ? t[e] !== void 0 : U.call(t, e);
	}
	function $e(e, t) {
		var n = this.__data__;
		return this.size += +!this.has(e), n[e] = Be && t === void 0 ? r : t, this;
	}
	Je.prototype.clear = Ye, Je.prototype.delete = Xe, Je.prototype.get = Ze, Je.prototype.has = Qe, Je.prototype.set = $e;
	function W(e) {
		var t = -1, n = e == null ? 0 : e.length;
		for (this.clear(); ++t < n;) {
			var r = e[t];
			this.set(r[0], r[1]);
		}
	}
	function et() {
		this.__data__ = [], this.size = 0;
	}
	function tt(e) {
		var t = this.__data__, n = bt(t, e);
		return n < 0 ? !1 : (n == t.length - 1 ? t.pop() : Ae.call(t, n, 1), --this.size, !0);
	}
	function nt(e) {
		var t = this.__data__, n = bt(t, e);
		return n < 0 ? void 0 : t[n][1];
	}
	function rt(e) {
		return bt(this.__data__, e) > -1;
	}
	function it(e, t) {
		var n = this.__data__, r = bt(n, e);
		return r < 0 ? (++this.size, n.push([e, t])) : n[r][1] = t, this;
	}
	W.prototype.clear = et, W.prototype.delete = tt, W.prototype.get = nt, W.prototype.has = rt, W.prototype.set = it;
	function at(e) {
		var t = -1, n = e == null ? 0 : e.length;
		for (this.clear(); ++t < n;) {
			var r = e[t];
			this.set(r[0], r[1]);
		}
	}
	function ot() {
		this.size = 0, this.__data__ = {
			hash: new Je(),
			map: new (Ie || W)(),
			string: new Je()
		};
	}
	function st(e) {
		var t = Nt(this, e).delete(e);
		return this.size -= +!!t, t;
	}
	function ct(e) {
		return Nt(this, e).get(e);
	}
	function lt(e) {
		return Nt(this, e).has(e);
	}
	function ut(e, t) {
		var n = Nt(this, e), r = n.size;
		return n.set(e, t), this.size += n.size == r ? 0 : 1, this;
	}
	at.prototype.clear = ot, at.prototype.delete = st, at.prototype.get = ct, at.prototype.has = lt, at.prototype.set = ut;
	function dt(e) {
		var t = -1, n = e == null ? 0 : e.length;
		for (this.__data__ = new at(); ++t < n;) this.add(e[t]);
	}
	function ft(e) {
		return this.__data__.set(e, r), this;
	}
	function pt(e) {
		return this.__data__.has(e);
	}
	dt.prototype.add = dt.prototype.push = ft, dt.prototype.has = pt;
	function G(e) {
		var t = this.__data__ = new W(e);
		this.size = t.size;
	}
	function mt() {
		this.__data__ = new W(), this.size = 0;
	}
	function ht(e) {
		var t = this.__data__, n = t.delete(e);
		return this.size = t.size, n;
	}
	function gt(e) {
		return this.__data__.get(e);
	}
	function _t(e) {
		return this.__data__.has(e);
	}
	function vt(e, t) {
		var r = this.__data__;
		if (r instanceof W) {
			var i = r.__data__;
			if (!Ie || i.length < n - 1) return i.push([e, t]), this.size = ++r.size, this;
			r = this.__data__ = new at(i);
		}
		return r.set(e, t), this.size = r.size, this;
	}
	G.prototype.clear = mt, G.prototype.delete = ht, G.prototype.get = gt, G.prototype.has = _t, G.prototype.set = vt;
	function yt(e, t) {
		var n = Gt(e), r = !n && Wt(e), i = !n && !r && qt(e), a = !n && !r && !i && $t(e), o = n || r || i || a, s = o ? de(e.length, String) : [], c = s.length;
		for (var l in e) (t || U.call(e, l)) && !(o && (l == "length" || i && (l == "offset" || l == "parent") || a && (l == "buffer" || l == "byteLength" || l == "byteOffset") || Rt(l, c))) && s.push(l);
		return s;
	}
	function bt(e, t) {
		for (var n = e.length; n--;) if (Ut(e[n][0], t)) return n;
		return -1;
	}
	function xt(e, t, n) {
		var r = t(e);
		return Gt(e) ? r : le(r, n(e));
	}
	function St(e) {
		return e == null ? e === void 0 ? T : _ : je && je in Object(e) ? Ft(e) : Vt(e);
	}
	function Ct(e) {
		return Qt(e) && St(e) == s;
	}
	function wt(e, t, n, r, i) {
		return e === t ? !0 : e == null || t == null || !Qt(e) && !Qt(t) ? e !== e && t !== t : Tt(e, t, n, r, wt, i);
	}
	function Tt(e, t, n, r, a, o) {
		var l = Gt(e), u = Gt(t), d = l ? c : Lt(e), f = u ? c : Lt(t);
		d = d == s ? v : d, f = f == s ? v : f;
		var p = d == v, m = f == v, h = d == f;
		if (h && qt(e)) {
			if (!qt(t)) return !1;
			l = !0, p = !1;
		}
		if (h && !p) return o ||= new G(), l || $t(e) ? kt(e, t, n, r, a, o) : At(e, t, d, n, r, a, o);
		if (!(n & i)) {
			var g = p && U.call(e, "__wrapped__"), _ = m && U.call(t, "__wrapped__");
			if (g || _) {
				var y = g ? e.value() : e, b = _ ? t.value() : t;
				return o ||= new G(), a(y, b, n, r, o);
			}
		}
		return h ? (o ||= new G(), jt(e, t, n, r, a, o)) : !1;
	}
	function Et(e) {
		return !Zt(e) || K(e) ? !1 : (Yt(e) ? Te : L).test(Ht(e));
	}
	function Dt(e) {
		return Qt(e) && Xt(e.length) && !!z[St(e)];
	}
	function Ot(e) {
		if (!Bt(e)) return Pe(e);
		var t = [];
		for (var n in Object(e)) U.call(e, n) && n != "constructor" && t.push(n);
		return t;
	}
	function kt(e, t, n, r, o, s) {
		var c = n & i, l = e.length, u = t.length;
		if (l != u && !(c && u > l)) return !1;
		var d = s.get(e);
		if (d && s.get(t)) return d == t;
		var f = -1, p = !0, m = n & a ? new dt() : void 0;
		for (s.set(e, t), s.set(t, e); ++f < l;) {
			var h = e[f], g = t[f];
			if (r) var _ = c ? r(g, h, f, t, e, s) : r(h, g, f, e, t, s);
			if (_ !== void 0) {
				if (_) continue;
				p = !1;
				break;
			}
			if (m) {
				if (!ue(t, function(e, t) {
					if (!pe(m, t) && (h === e || o(h, e, n, r, s))) return m.push(t);
				})) {
					p = !1;
					break;
				}
			} else if (!(h === g || o(h, g, n, r, s))) {
				p = !1;
				break;
			}
		}
		return s.delete(e), s.delete(t), p;
	}
	function At(e, t, n, r, o, s, c) {
		switch (n) {
			case O:
				if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) return !1;
				e = e.buffer, t = t.buffer;
			case D: return !(e.byteLength != t.byteLength || !s(new Oe(e), new Oe(t)));
			case u:
			case d:
			case g: return Ut(+e, +t);
			case f: return e.name == t.name && e.message == t.message;
			case x:
			case C: return e == t + "";
			case h: var l = he;
			case S:
				var p = r & i;
				if (l ||= _e, e.size != t.size && !p) return !1;
				var m = c.get(e);
				if (m) return m == t;
				r |= a, c.set(e, t);
				var _ = kt(l(e), l(t), r, o, s, c);
				return c.delete(e), _;
			case w: if (qe) return qe.call(e) == qe.call(t);
		}
		return !1;
	}
	function jt(e, t, n, r, a, o) {
		var s = n & i, c = Mt(e), l = c.length;
		if (l != Mt(t).length && !s) return !1;
		for (var u = l; u--;) {
			var d = c[u];
			if (!(s ? d in t : U.call(t, d))) return !1;
		}
		var f = o.get(e);
		if (f && o.get(t)) return f == t;
		var p = !0;
		o.set(e, t), o.set(t, e);
		for (var m = s; ++u < l;) {
			d = c[u];
			var h = e[d], g = t[d];
			if (r) var _ = s ? r(g, h, d, t, e, o) : r(h, g, d, e, t, o);
			if (!(_ === void 0 ? h === g || a(h, g, n, r, o) : _)) {
				p = !1;
				break;
			}
			m ||= d == "constructor";
		}
		if (p && !m) {
			var v = e.constructor, y = t.constructor;
			v != y && "constructor" in e && "constructor" in t && !(typeof v == "function" && v instanceof v && typeof y == "function" && y instanceof y) && (p = !1);
		}
		return o.delete(e), o.delete(t), p;
	}
	function Mt(e) {
		return xt(e, q, It);
	}
	function Nt(e, t) {
		var n = e.__data__;
		return zt(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
	}
	function Pt(e, t) {
		var n = me(e, t);
		return Et(n) ? n : void 0;
	}
	function Ft(e) {
		var t = U.call(e, je), n = e[je];
		try {
			e[je] = void 0;
			var r = !0;
		} catch {}
		var i = we.call(e);
		return r && (t ? e[je] = n : delete e[je]), i;
	}
	var It = Me ? function(e) {
		return e == null ? [] : (e = Object(e), ce(Me(e), function(t) {
			return ke.call(e, t);
		}));
	} : en, Lt = St;
	(Fe && Lt(new Fe(/* @__PURE__ */ new ArrayBuffer(1))) != O || Ie && Lt(new Ie()) != h || Le && Lt(Le.resolve()) != y || Re && Lt(new Re()) != S || ze && Lt(new ze()) != E) && (Lt = function(e) {
		var t = St(e), n = t == v ? e.constructor : void 0, r = n ? Ht(n) : "";
		if (r) switch (r) {
			case Ve: return O;
			case He: return h;
			case Ue: return y;
			case We: return S;
			case Ge: return E;
		}
		return t;
	});
	function Rt(e, t) {
		return t ??= o, !!t && (typeof e == "number" || R.test(e)) && e > -1 && e % 1 == 0 && e < t;
	}
	function zt(e) {
		var t = typeof e;
		return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
	}
	function K(e) {
		return !!Ce && Ce in e;
	}
	function Bt(e) {
		var t = e && e.constructor;
		return e === (typeof t == "function" && t.prototype || be);
	}
	function Vt(e) {
		return we.call(e);
	}
	function Ht(e) {
		if (e != null) {
			try {
				return Se.call(e);
			} catch {}
			try {
				return e + "";
			} catch {}
		}
		return "";
	}
	function Ut(e, t) {
		return e === t || e !== e && t !== t;
	}
	var Wt = Ct(function() {
		return arguments;
	}()) ? Ct : function(e) {
		return Qt(e) && U.call(e, "callee") && !ke.call(e, "callee");
	}, Gt = Array.isArray;
	function Kt(e) {
		return e != null && Xt(e.length) && !Yt(e);
	}
	var qt = Ne || tn;
	function Jt(e, t) {
		return wt(e, t);
	}
	function Yt(e) {
		if (!Zt(e)) return !1;
		var t = St(e);
		return t == p || t == m || t == l || t == b;
	}
	function Xt(e) {
		return typeof e == "number" && e > -1 && e % 1 == 0 && e <= o;
	}
	function Zt(e) {
		var t = typeof e;
		return e != null && (t == "object" || t == "function");
	}
	function Qt(e) {
		return typeof e == "object" && !!e;
	}
	var $t = se ? fe(se) : Dt;
	function q(e) {
		return Kt(e) ? yt(e) : Ot(e);
	}
	function en() {
		return [];
	}
	function tn() {
		return !1;
	}
	t.exports = Jt;
})))(), 1), Dn = "EXPERIENCE_STARTED", On = "SHOW", kn = "STOP_EXPERIENCE", X = {
	NAVIGATION: "navigation",
	COMPLETED: "completed",
	DISMISSED: "dismissed",
	ERROR: "error"
}, An = "EXTENDED_EVENT", jn = "START_STEP", Mn = "STOP_STEP", Nn = "UPDATE_STEP", Pn = "SET_STEP_CONTAINER_TARGET", Fn = "UPDATE_STEP_CONTENT", In = "RECOVER_STEP", Ln = "AUTO_RECOVER_STEP", Rn = "PARENT_RECOVER_STEP", zn = "ERROR", Bn = "STEP_INTERACTION", Vn = "STEP_SEEN", Hn = "UPDATE_ROOT_STYLE", Un = "RELOAD", Wn = "STEP_STOPPED", Gn = "EXPERIENCE_DISMISSED", Kn = "EXPERIENCE_SNOOZED", qn = "FORWARD_TO_PARENT", Jn = "TRANSITION_TO_END", Yn = "ACTIONS_STARTED", Xn = "ACTIONS_FINISHED", Zn = "experience.begin", Qn = "experience.end", $n = "step.prebegin", er = "step.begin", tr = "step.prerender", nr = "step.postrender", rr = "step.end", ir = "step.error", ar = "step.container_change", or = "RUN_HOOKS", sr = "RUN_HOOKS_DONE", cr = "START_THEME_REMOVAL_LISTENER", lr = "STOP_THEME_REMOVAL_LISTENER", ur = "GLOBAL_CONTAINER_REMOVED", dr = "STEP_CONTAINER_REMOVED", fr = "appcues-experience-container", pr = "APPCUES-EXPERIENCE-CONTAINER", mr = "APPCUES-EXPERIENCE-CONTAINER-BUILDER", hr = "data-appcues-container-id", gr = "RUN_TRAITS_DONE", _r = "RUN_TRAITS_ERROR", vr = "BIND_ACTIONS_ERROR", yr = (() => {
	let e = /* @__PURE__ */ new Map(), t = (t) => {
		let { observerInstance: n } = e.get(t);
		if (n) return;
		let r = {
			childList: !0,
			subtree: !0
		}, i = new MutationObserver((...n) => {
			let { callbacks: r } = e.get(t);
			r.forEach((e) => e(...n));
		});
		i.observe(t, r);
		let { callbacks: a } = e.get(t);
		e.set(t, {
			callbacks: a,
			observerInstance: i
		});
	}, n = (t, n) => {
		let r = e.get(t);
		if (r) {
			let { callbacks: i, observerInstance: a } = r, o = i.filter((e) => e !== n);
			if (o.length > 0) {
				e.set(t, {
					callbacks: o,
					observerInstance: a
				});
				return;
			}
			a.disconnect(), e.delete(t);
		}
	};
	return (r, i) => {
		let { callbacks: a = [], observerInstance: o = null } = e.get(r) ?? {};
		return e.set(r, {
			observerInstance: o,
			callbacks: [...a, i]
		}), t(r), () => n(r, i);
	};
})(), br = (e, ...t) => {
	t.forEach((t) => e.addEventListener(t, (e) => {
		e.stopPropagation();
	}));
}, xr = "|shadow-root|", Sr = "|iframe|", Cr = (e, t) => {
	try {
		return e.includes(xr) || e.includes("|iframe|") ? e.split(xr).flatMap((e) => e.split("|iframe|")).reduce((e, n) => e === null ? [...t.querySelectorAll(n)] : e.flatMap((e) => e.shadowRoot ? [...e.shadowRoot.querySelectorAll(n)] : e.tagName === "IFRAME" ? [...e.contentDocument.querySelectorAll(n)] : []), null) ?? [] : t.querySelectorAll(e);
	} catch {
		return [];
	}
}, wr = (e, t) => {
	let n = Cr(e, t);
	return n.length > 0 ? n[0] : null;
}, Tr = (e) => `appcues-container-${e}`, Er = (e, t, n) => {
	try {
		if (e.contentDocument && e.contentDocument.body && e.contentDocument.body.children.length > 0) {
			if (n()) return;
			t(e.contentDocument.body);
		} else e.addEventListener("load", () => {
			try {
				let r = e.contentDocument;
				if (!r || !r.body || n()) return;
				t(r.body);
			} catch {}
		}, { once: !0 });
	} catch {}
}, Dr = (e, t) => {
	e.forEach((e) => {
		e.type === "childList" && e.addedNodes.forEach((e) => {
			e.nodeType === 1 && e.tagName === "IFRAME" && t(e);
		});
	});
}, Or = ({ getTarget: e, onInserted: t, getWindowReference: n }) => {
	let r = n().document, i = [], a = () => {
		i.forEach((e) => e()), i = [];
	}, o = () => {
		let n = e();
		return n.length === 1 ? (t(n[0]), a(), !0) : !1;
	};
	if (o()) return () => {};
	let s = (e) => {
		e.some((e) => e.addedNodes.length > 0) && (Dr(e, (e) => {
			Er(e, (e) => i.push(yr(e, s)), o);
		}), o());
	};
	i.push(yr(r.body, s));
	let c, l = r.createNodeIterator(r.body, NodeFilter.SHOW_ELEMENT, (e) => e.shadowRoot && e.nodeName !== "APPCUES-EXPERIENCE-CONTAINER" && e.nodeName !== "APPCUES-EXPERIENCE-CONTAINER-BUILDER" ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT);
	for (; (c = l.nextNode()) !== null;) i.push(yr(c.shadowRoot, s));
	let u, d = r.createNodeIterator(r.body, NodeFilter.SHOW_ELEMENT, (e) => e.tagName === "IFRAME" ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT);
	for (; (u = d.nextNode()) !== null;) Er(u, (e) => i.push(yr(e, s)), o);
	return () => a();
}, kr = ({ getTarget: e, onRemoved: t, getWindowReference: n }) => {
	let r = n().document, [i] = e(), a, o = (n) => {
		if (!n.some((e) => e.removedNodes.length > 0)) return;
		let r = e(), o = i ? r[0] !== i : !1;
		[i] = r, (r.length === 0 || o || !i.isConnected) && (t(), a());
	};
	return a = i && i.getRootNode().nodeType === Node.DOCUMENT_FRAGMENT_NODE ? yr(i.getRootNode(), o) : yr(r.body, o), () => a();
}, Ar = (e) => {
	let t = 0;
	for (let n = 0; n < e.length && !(e[n].nodeName !== "APPCUES-EXPERIENCE-CONTAINER" || e[n].nodeName !== "APPCUES-EXPERIENCE-CONTAINER-BUILDER"); n++) t = n;
	return e.slice(t + 1);
}, jr = (e, t = document) => {
	try {
		let n = e.match(/^((body\s(>?\s?))?)(?<tagName>[\da-z]+):nth-child\((?<index>\d+)\)(?<remainingSelector>.*)/i), r = t.body.firstChild?.nodeName === "APPCUES-EXPERIENCE-CONTAINER" || t.body.firstChild?.nodeName === "APPCUES-EXPERIENCE-CONTAINER-BUILDER";
		if (!n || !r) return [];
		let { tagName: i, index: a, remainingSelector: o } = n.groups, s = Number.parseInt(a, 10) - 1, c = Ar([...t.body.children]), l = c[s]?.nodeName === i.toUpperCase() ? c[s] : null;
		return o ? l ? Cr(`* ${o}`, l) : [] : [l];
	} catch (e) {
		return console.log(e), [];
	}
}, Mr = (e, { step: t, stepContainer: n, checkOutsideContainer: r, getWindowReference: i }) => {
	let a = Tr(t.id), o = [];
	if (r) {
		let t = i().document, n = jr(e, t), r = n.length > 0 ? n : Cr(e, t.documentElement);
		r.length > 0 && (o = [...o, ...r]);
	}
	if (!n) return o;
	let s = wr(`[${hr}=${a}]`, n);
	return s &&= Cr(e, s), s ??= [], s.length > 0 && (o = [...o, ...s]), o;
}, Nr = [
	"keypress",
	"keydown",
	"keyup",
	"click",
	"dblclick",
	"input",
	"change",
	"submit"
], Pr = ({ accountId: e, id: t, theme: n, getWindowReference: r }) => {
	let i = r().document.createElement(fr);
	return n && i.setAttribute("themeId", n), i.setAttribute("accountId", e), i.setAttribute("id", Tr(t)), br(i, ...Nr), i;
}, Fr = (e) => ({ context: { experience: t } }) => {
	let { theme: n, themeSystem: r, accountId: i, id: a } = t;
	if (!i) return;
	let o = e("getWindowReference"), s = o().document, c = Pr({
		accountId: i,
		id: a,
		...!r && { theme: n },
		getWindowReference: o
	});
	s.body.append(c);
}, Ir = (e) => ({ context: { experience: t } }) => {
	let n = e("getWindowReference")().document;
	Cr(`#${Tr(t.id)}`, n.documentElement).forEach((e) => n.body.removeChild(e));
}, Lr = ({ getRoot: e }) => {
	let t = e();
	t.parentElement && t.remove();
}, Rr = ({ getRoot: e }) => nn(({ enqueue: t, check: n }) => {
	n("hasCustomContainer") && t(() => {
		Lr({ getRoot: e });
	});
}), zr = (e) => Nt(({ sendBack: t, receive: n, input: r }) => {
	let { experience: i } = r;
	n(({ type: n }) => {
		if (n !== "START_THEME_REMOVAL_LISTENER") return;
		let r = e("getWindowReference"), a = r().document, o = Tr(i.id);
		kr({
			getTarget: () => Cr(`#${o}`, a.documentElement),
			onRemoved: () => {
				t({ type: ur });
			},
			getWindowReference: r
		});
	});
}), Br = ({ getRoot: e, getWindowReference: t }) => Nt(({ sendBack: n, receive: r }) => {
	let i;
	r(({ type: r }) => {
		if (r === "STOP_THEME_REMOVAL_LISTENER" && i) {
			i();
			return;
		}
		r === "START_THEME_REMOVAL_LISTENER" && (i && i(), i = kr({
			getTarget: () => [e()],
			onRemoved: () => {
				n({ type: dr });
			},
			getWindowReference: t
		}));
	});
}), Vr = $t("themeRemovalService", { type: cr }), Hr = $t("themeRemovalService", { type: lr }), Ur = /* @__PURE__ */ s(((e, t) => {
	(function() {
		function e(e, t, n) {
			return e.call.apply(e.bind, arguments);
		}
		function n(e, t, n) {
			if (!e) throw Error();
			if (2 < arguments.length) {
				var r = Array.prototype.slice.call(arguments, 2);
				return function() {
					var n = Array.prototype.slice.call(arguments);
					return Array.prototype.unshift.apply(n, r), e.apply(t, n);
				};
			}
			return function() {
				return e.apply(t, arguments);
			};
		}
		function r(t, i, a) {
			return r = Function.prototype.bind && Function.prototype.bind.toString().indexOf("native code") != -1 ? e : n, r.apply(null, arguments);
		}
		var i = Date.now || function() {
			return +/* @__PURE__ */ new Date();
		};
		function a(e, t) {
			this.a = e, this.o = t || e, this.c = this.o.document;
		}
		var o = !!window.FontFace;
		function s(e, t, n, r) {
			if (t = e.c.createElement(t), n) for (var i in n) n.hasOwnProperty(i) && (i == "style" ? t.style.cssText = n[i] : t.setAttribute(i, n[i]));
			return r && t.appendChild(e.c.createTextNode(r)), t;
		}
		function c(e, t, n) {
			e = e.c.getElementsByTagName(t)[0], e ||= document.documentElement, e.insertBefore(n, e.lastChild);
		}
		function l(e) {
			e.parentNode && e.parentNode.removeChild(e);
		}
		function u(e, t, n) {
			t ||= [], n ||= [];
			for (var r = e.className.split(/\s+/), i = 0; i < t.length; i += 1) {
				for (var a = !1, o = 0; o < r.length; o += 1) if (t[i] === r[o]) {
					a = !0;
					break;
				}
				a || r.push(t[i]);
			}
			for (t = [], i = 0; i < r.length; i += 1) {
				for (a = !1, o = 0; o < n.length; o += 1) if (r[i] === n[o]) {
					a = !0;
					break;
				}
				a || t.push(r[i]);
			}
			e.className = t.join(" ").replace(/\s+/g, " ").replace(/^\s+|\s+$/, "");
		}
		function d(e, t) {
			for (var n = e.className.split(/\s+/), r = 0, i = n.length; r < i; r++) if (n[r] == t) return !0;
			return !1;
		}
		function f(e) {
			return e.o.location.hostname || e.a.location.hostname;
		}
		function p(e, t, n) {
			function r() {
				u && i && a && (u(l), u = null);
			}
			t = s(e, "link", {
				rel: "stylesheet",
				href: t,
				media: "all"
			});
			var i = !1, a = !0, l = null, u = n || null;
			o ? (t.onload = function() {
				i = !0, r();
			}, t.onerror = function() {
				i = !0, l = Error("Stylesheet failed to load"), r();
			}) : setTimeout(function() {
				i = !0, r();
			}, 0), c(e, "head", t);
		}
		function m(e, t, n, r) {
			var i = e.c.getElementsByTagName("head")[0];
			if (i) {
				var a = s(e, "script", { src: t }), o = !1;
				return a.onload = a.onreadystatechange = function() {
					o || this.readyState && this.readyState != "loaded" && this.readyState != "complete" || (o = !0, n && n(null), a.onload = a.onreadystatechange = null, a.parentNode.tagName == "HEAD" && i.removeChild(a));
				}, i.appendChild(a), setTimeout(function() {
					o || (o = !0, n && n(Error("Script load timeout")));
				}, r || 5e3), a;
			}
			return null;
		}
		function h() {
			this.a = 0, this.c = null;
		}
		function g(e) {
			return e.a++, function() {
				e.a--, v(e);
			};
		}
		function _(e, t) {
			e.c = t, v(e);
		}
		function v(e) {
			e.a == 0 && e.c && (e.c(), e.c = null);
		}
		function y(e) {
			this.a = e || "-";
		}
		y.prototype.c = function(e) {
			for (var t = [], n = 0; n < arguments.length; n++) t.push(arguments[n].replace(/[\W_]+/g, "").toLowerCase());
			return t.join(this.a);
		};
		function b(e, t) {
			this.c = e, this.f = 4, this.a = "n";
			var n = (t || "n4").match(/^([nio])([1-9])$/i);
			n && (this.a = n[1], this.f = parseInt(n[2], 10));
		}
		function x(e) {
			return w(e) + " " + (e.f + "00") + " 300px " + S(e.c);
		}
		function S(e) {
			var t = [];
			e = e.split(/,\s*/);
			for (var n = 0; n < e.length; n++) {
				var r = e[n].replace(/['"]/g, "");
				r.indexOf(" ") != -1 || /^\d/.test(r) ? t.push("'" + r + "'") : t.push(r);
			}
			return t.join(",");
		}
		function C(e) {
			return e.a + e.f;
		}
		function w(e) {
			var t = "normal";
			return e.a === "o" ? t = "oblique" : e.a === "i" && (t = "italic"), t;
		}
		function T(e) {
			var t = 4, n = "n", r = null;
			return e && ((r = e.match(/(normal|oblique|italic)/i)) && r[1] && (n = r[1].substr(0, 1).toLowerCase()), (r = e.match(/([1-9]00|normal|bold)/i)) && r[1] && (/bold/i.test(r[1]) ? t = 7 : /[1-9]00/.test(r[1]) && (t = parseInt(r[1].substr(0, 1), 10)))), n + t;
		}
		function E(e, t) {
			this.c = e, this.f = e.o.document.documentElement, this.h = t, this.a = new y("-"), this.j = !1 !== t.events, this.g = !1 !== t.classes;
		}
		function D(e) {
			e.g && u(e.f, [e.a.c("wf", "loading")]), k(e, "loading");
		}
		function O(e) {
			if (e.g) {
				var t = d(e.f, e.a.c("wf", "active")), n = [], r = [e.a.c("wf", "loading")];
				t || n.push(e.a.c("wf", "inactive")), u(e.f, n, r);
			}
			k(e, "inactive");
		}
		function k(e, t, n) {
			e.j && e.h[t] && (n ? e.h[t](n.c, C(n)) : e.h[t]());
		}
		function A() {
			this.c = {};
		}
		function j(e, t, n) {
			var r = [], i;
			for (i in t) if (t.hasOwnProperty(i)) {
				var a = e.c[i];
				a && r.push(a(t[i], n));
			}
			return r;
		}
		function M(e, t) {
			this.c = e, this.f = t, this.a = s(this.c, "span", { "aria-hidden": "true" }, this.f);
		}
		function N(e) {
			c(e.c, "body", e.a);
		}
		function P(e) {
			return "display:block;position:absolute;top:-9999px;left:-9999px;font-size:300px;width:auto;height:auto;line-height:normal;margin:0;padding:0;font-variant:normal;white-space:nowrap;font-family:" + S(e.c) + ";" + ("font-style:" + w(e) + ";font-weight:" + (e.f + "00") + ";");
		}
		function ee(e, t, n, r, i, a) {
			this.g = e, this.j = t, this.a = r, this.c = n, this.f = i || 3e3, this.h = a || void 0;
		}
		ee.prototype.start = function() {
			var e = this.c.o.document, t = this, n = i(), r = new Promise(function(r, a) {
				function o() {
					i() - n >= t.f ? a() : e.fonts.load(x(t.a), t.h).then(function(e) {
						1 <= e.length ? r() : setTimeout(o, 25);
					}, function() {
						a();
					});
				}
				o();
			}), a = null, o = new Promise(function(e, n) {
				a = setTimeout(n, t.f);
			});
			Promise.race([o, r]).then(function() {
				a &&= (clearTimeout(a), null), t.g(t.a);
			}, function() {
				t.j(t.a);
			});
		};
		function F(e, t, n, r, i, a, o) {
			this.v = e, this.B = t, this.c = n, this.a = r, this.s = o || "BESbswy", this.f = {}, this.w = i || 3e3, this.u = a || null, this.m = this.j = this.h = this.g = null, this.g = new M(this.c, this.s), this.h = new M(this.c, this.s), this.j = new M(this.c, this.s), this.m = new M(this.c, this.s), e = new b(this.a.c + ",serif", C(this.a)), e = P(e), this.g.a.style.cssText = e, e = new b(this.a.c + ",sans-serif", C(this.a)), e = P(e), this.h.a.style.cssText = e, e = new b("serif", C(this.a)), e = P(e), this.j.a.style.cssText = e, e = new b("sans-serif", C(this.a)), e = P(e), this.m.a.style.cssText = e, N(this.g), N(this.h), N(this.j), N(this.m);
		}
		var te = {
			D: "serif",
			C: "sans-serif"
		}, I = null;
		function L() {
			if (I === null) {
				var e = /AppleWebKit\/([0-9]+)(?:\.([0-9]+))/.exec(window.navigator.userAgent);
				I = !!e && (536 > parseInt(e[1], 10) || parseInt(e[1], 10) === 536 && 11 >= parseInt(e[2], 10));
			}
			return I;
		}
		F.prototype.start = function() {
			this.f.serif = this.j.a.offsetWidth, this.f["sans-serif"] = this.m.a.offsetWidth, this.A = i(), z(this);
		};
		function R(e, t, n) {
			for (var r in te) if (te.hasOwnProperty(r) && t === e.f[te[r]] && n === e.f[te[r]]) return !0;
			return !1;
		}
		function z(e) {
			var t = e.g.a.offsetWidth, n = e.h.a.offsetWidth, r;
			(r = t === e.f.serif && n === e.f["sans-serif"]) || (r = L() && R(e, t, n)), r ? i() - e.A >= e.w ? L() && R(e, t, n) && (e.u === null || e.u.hasOwnProperty(e.a.c)) ? re(e, e.v) : re(e, e.B) : ne(e) : re(e, e.v);
		}
		function ne(e) {
			setTimeout(r(function() {
				z(this);
			}, e), 50);
		}
		function re(e, t) {
			setTimeout(r(function() {
				l(this.g.a), l(this.h.a), l(this.j.a), l(this.m.a), t(this.a);
			}, e), 0);
		}
		function B(e, t, n) {
			this.c = e, this.a = t, this.f = 0, this.m = this.j = !1, this.s = n;
		}
		var ie = null;
		B.prototype.g = function(e) {
			var t = this.a;
			t.g && u(t.f, [t.a.c("wf", e.c, C(e).toString(), "active")], [t.a.c("wf", e.c, C(e).toString(), "loading"), t.a.c("wf", e.c, C(e).toString(), "inactive")]), k(t, "fontactive", e), this.m = !0, V(this);
		}, B.prototype.h = function(e) {
			var t = this.a;
			if (t.g) {
				var n = d(t.f, t.a.c("wf", e.c, C(e).toString(), "active")), r = [], i = [t.a.c("wf", e.c, C(e).toString(), "loading")];
				n || r.push(t.a.c("wf", e.c, C(e).toString(), "inactive")), u(t.f, r, i);
			}
			k(t, "fontinactive", e), V(this);
		};
		function V(e) {
			--e.f == 0 && e.j && (e.m ? (e = e.a, e.g && u(e.f, [e.a.c("wf", "active")], [e.a.c("wf", "loading"), e.a.c("wf", "inactive")]), k(e, "active")) : O(e.a));
		}
		function ae(e) {
			this.j = e, this.a = new A(), this.h = 0, this.f = this.g = !0;
		}
		ae.prototype.load = function(e) {
			this.c = new a(this.j, e.context || this.j), this.g = !1 !== e.events, this.f = !1 !== e.classes, oe(this, new E(this.c, e), e);
		};
		function H(e, t, n, i, a) {
			var o = --e.h == 0;
			(e.f || e.g) && setTimeout(function() {
				var e = a || null, s = i || {};
				if (n.length === 0 && o) O(t.a);
				else {
					t.f += n.length, o && (t.j = o);
					var c, l = [];
					for (c = 0; c < n.length; c++) {
						var d = n[c], f = s[d.c], p = t.a, m = d;
						if (p.g && u(p.f, [p.a.c("wf", m.c, C(m).toString(), "loading")]), k(p, "fontloading", m), p = null, ie === null) if (window.FontFace) {
							var m = /Gecko.*Firefox\/(\d+)/.exec(window.navigator.userAgent), h = /OS X.*Version\/10\..*Safari/.exec(window.navigator.userAgent) && /Apple/.exec(window.navigator.vendor);
							ie = m ? 42 < parseInt(m[1], 10) : !h;
						} else ie = !1;
						p = ie ? new ee(r(t.g, t), r(t.h, t), t.c, d, t.s, f) : new F(r(t.g, t), r(t.h, t), t.c, d, t.s, e, f), l.push(p);
					}
					for (c = 0; c < l.length; c++) l[c].start();
				}
			}, 0);
		}
		function oe(e, t, n) {
			var r = [], i = n.timeout;
			D(t);
			var r = j(e.a, n, e.c), a = new B(e.c, t, i);
			for (e.h = r.length, t = 0, n = r.length; t < n; t++) r[t].load(function(t, n, r) {
				H(e, a, t, n, r);
			});
		}
		function se(e, t) {
			this.c = e, this.a = t;
		}
		se.prototype.load = function(e) {
			function t() {
				if (a["__mti_fntLst" + r]) {
					var n = a["__mti_fntLst" + r](), i = [], o;
					if (n) for (var s = 0; s < n.length; s++) {
						var c = n[s].fontfamily;
						n[s].fontStyle != null && n[s].fontWeight != null ? (o = n[s].fontStyle + n[s].fontWeight, i.push(new b(c, o))) : i.push(new b(c));
					}
					e(i);
				} else setTimeout(function() {
					t();
				}, 50);
			}
			var n = this, r = n.a.projectId, i = n.a.version;
			if (r) {
				var a = n.c.o;
				m(this.c, (n.a.api || "https://fast.fonts.net/jsapi") + "/" + r + ".js" + (i ? "?v=" + i : ""), function(i) {
					i ? e([]) : (a["__MonotypeConfiguration__" + r] = function() {
						return n.a;
					}, t());
				}).id = "__MonotypeAPIScript__" + r;
			} else e([]);
		};
		function ce(e, t) {
			this.c = e, this.a = t;
		}
		ce.prototype.load = function(e) {
			var t, n, r = this.a.urls || [], i = this.a.families || [], a = this.a.testStrings || {}, o = new h();
			for (t = 0, n = r.length; t < n; t++) p(this.c, r[t], g(o));
			var s = [];
			for (t = 0, n = i.length; t < n; t++) if (r = i[t].split(":"), r[1]) for (var c = r[1].split(","), l = 0; l < c.length; l += 1) s.push(new b(r[0], c[l]));
			else s.push(new b(r[0]));
			_(o, function() {
				e(s, a);
			});
		};
		function le(e, t) {
			e ? this.c = e : this.c = ue, this.a = [], this.f = [], this.g = t || "";
		}
		var ue = "https://fonts.googleapis.com/css";
		function de(e, t) {
			for (var n = t.length, r = 0; r < n; r++) {
				var i = t[r].split(":");
				i.length == 3 && e.f.push(i.pop());
				var a = "";
				i.length == 2 && i[1] != "" && (a = ":"), e.a.push(i.join(a));
			}
		}
		function fe(e) {
			if (e.a.length == 0) throw Error("No fonts to load!");
			if (e.c.indexOf("kit=") != -1) return e.c;
			for (var t = e.a.length, n = [], r = 0; r < t; r++) n.push(e.a[r].replace(/ /g, "+"));
			return t = e.c + "?family=" + n.join("%7C"), 0 < e.f.length && (t += "&subset=" + e.f.join(",")), 0 < e.g.length && (t += "&text=" + encodeURIComponent(e.g)), t;
		}
		function pe(e) {
			this.f = e, this.a = [], this.c = {};
		}
		var me = {
			latin: "BESbswy",
			"latin-ext": "çöüğş",
			cyrillic: "йяЖ",
			greek: "αβΣ",
			khmer: "កខគ",
			Hanuman: "កខគ"
		}, he = {
			thin: "1",
			extralight: "2",
			"extra-light": "2",
			ultralight: "2",
			"ultra-light": "2",
			light: "3",
			regular: "4",
			book: "4",
			medium: "5",
			"semi-bold": "6",
			semibold: "6",
			"demi-bold": "6",
			demibold: "6",
			bold: "7",
			"extra-bold": "8",
			extrabold: "8",
			"ultra-bold": "8",
			ultrabold: "8",
			black: "9",
			heavy: "9",
			l: "3",
			r: "4",
			b: "7"
		}, ge = {
			i: "i",
			italic: "i",
			n: "n",
			normal: "n"
		}, _e = /^(thin|(?:(?:extra|ultra)-?)?light|regular|book|medium|(?:(?:semi|demi|extra|ultra)-?)?bold|black|heavy|l|r|b|[1-9]00)?(n|i|normal|italic)?$/;
		function ve(e) {
			for (var t = e.f.length, n = 0; n < t; n++) {
				var r = e.f[n].split(":"), i = r[0].replace(/\+/g, " "), a = ["n4"];
				if (2 <= r.length) {
					var o, s = r[1];
					if (o = [], s) for (var s = s.split(","), c = s.length, l = 0; l < c; l++) {
						var u = s[l];
						if (u.match(/^[\w-]+$/)) {
							var d = _e.exec(u.toLowerCase());
							if (d == null) u = "";
							else {
								if (u = d[2], u = u == null || u == "" ? "n" : ge[u], d = d[1], d == null || d == "") d = "4";
								else var f = he[d], d = f || (isNaN(d) ? "4" : d.substr(0, 1));
								u = [u, d].join("");
							}
						} else u = "";
						u && o.push(u);
					}
					0 < o.length && (a = o), r.length == 3 && (r = r[2], o = [], r = r ? r.split(",") : o, 0 < r.length && (r = me[r[0]]) && (e.c[i] = r));
				}
				for (e.c[i] || (r = me[i]) && (e.c[i] = r), r = 0; r < a.length; r += 1) e.a.push(new b(i, a[r]));
			}
		}
		function ye(e, t) {
			this.c = e, this.a = t;
		}
		var be = {
			Arimo: !0,
			Cousine: !0,
			Tinos: !0
		};
		ye.prototype.load = function(e) {
			var t = new h(), n = this.c, r = new le(this.a.api, this.a.text), i = this.a.families;
			de(r, i);
			var a = new pe(i);
			ve(a), p(n, fe(r), g(t)), _(t, function() {
				e(a.a, a.c, be);
			});
		};
		function xe(e, t) {
			this.c = e, this.a = t;
		}
		xe.prototype.load = function(e) {
			var t = this.a.id, n = this.c.o;
			t ? m(this.c, (this.a.api || "https://use.typekit.net") + "/" + t + ".js", function(t) {
				if (t) e([]);
				else if (n.Typekit && n.Typekit.config && n.Typekit.config.fn) {
					t = n.Typekit.config.fn;
					for (var r = [], i = 0; i < t.length; i += 2) for (var a = t[i], o = t[i + 1], s = 0; s < o.length; s++) r.push(new b(a, o[s]));
					try {
						n.Typekit.load({
							events: !1,
							classes: !1,
							async: !0
						});
					} catch {}
					e(r);
				}
			}, 2e3) : e([]);
		};
		function Se(e, t) {
			this.c = e, this.f = t, this.a = [];
		}
		Se.prototype.load = function(e) {
			var t = this.f.id, n = this.c.o, r = this;
			t ? (n.__webfontfontdeckmodule__ ||= {}, n.__webfontfontdeckmodule__[t] = function(t, n) {
				for (var i = 0, a = n.fonts.length; i < a; ++i) {
					var o = n.fonts[i];
					r.a.push(new b(o.name, T("font-weight:" + o.weight + ";font-style:" + o.style)));
				}
				e(r.a);
			}, m(this.c, (this.f.api || "https://f.fontdeck.com/s/css/js/") + f(this.c) + "/" + t + ".js", function(t) {
				t && e([]);
			})) : e([]);
		};
		var U = new ae(window);
		U.a.c.custom = function(e, t) {
			return new ce(t, e);
		}, U.a.c.fontdeck = function(e, t) {
			return new Se(t, e);
		}, U.a.c.monotype = function(e, t) {
			return new se(t, e);
		}, U.a.c.typekit = function(e, t) {
			return new xe(t, e);
		}, U.a.c.google = function(e, t) {
			return new ye(t, e);
		};
		var Ce = { load: r(U.load, U) };
		t !== void 0 && t.exports ? t.exports = Ce : (window.WebFont = Ce, window.WebFontConfig && U.load(window.WebFontConfig));
	})();
})), Wr = /* @__PURE__ */ s(((e, t) => {
	function n(e, t) {
		var n = t && t.cache ? t.cache : f, r = t && t.serializer ? t.serializer : u;
		return (t && t.strategy ? t.strategy : s)(e, {
			cache: n,
			serializer: r
		});
	}
	function r(e) {
		return e == null || typeof e == "number" || typeof e == "boolean";
	}
	function i(e, t, n, i) {
		var a = r(i) ? i : n(i), o = t.get(a);
		return o === void 0 && (o = e.call(this, i), t.set(a, o)), o;
	}
	function a(e, t, n) {
		var r = Array.prototype.slice.call(arguments, 3), i = n(r), a = t.get(i);
		return a === void 0 && (a = e.apply(this, r), t.set(i, a)), a;
	}
	function o(e, t, n, r, i) {
		return n.bind(t, e, r, i);
	}
	function s(e, t) {
		var n = e.length === 1 ? i : a;
		return o(e, this, n, t.cache.create(), t.serializer);
	}
	function c(e, t) {
		var n = a;
		return o(e, this, n, t.cache.create(), t.serializer);
	}
	function l(e, t) {
		var n = i;
		return o(e, this, n, t.cache.create(), t.serializer);
	}
	function u() {
		return JSON.stringify(arguments);
	}
	function d() {
		this.cache = Object.create(null);
	}
	d.prototype.has = function(e) {
		return e in this.cache;
	}, d.prototype.get = function(e) {
		return this.cache[e];
	}, d.prototype.set = function(e, t) {
		this.cache[e] = t;
	};
	var f = { create: function() {
		return new d();
	} };
	t.exports = n, t.exports.strategies = {
		variadic: c,
		monadic: l
	};
})), Gr = /* @__PURE__ */ u(Ur(), 1), Kr = /* @__PURE__ */ u(Wr(), 1), qr = window.AppcuesBundleSettings?.VERSION === "dev" ? "https://fast.appcues.com/v1" : window.AppcuesBundleSettings?.GENERIC_BUNDLE_DOMAIN ? `${window.AppcuesBundleSettings.GENERIC_BUNDLE_DOMAIN}/v1` : "https://fast.appcues.com/v1", Jr = 9999, Yr = {
	fastBaseUrl: null,
	useAssetsPath: !1
}, Xr = (e = {}) => {
	Yr = {
		...Yr,
		...e
	};
}, Zr = () => Yr.fastBaseUrl ?? qr, Qr = () => Yr.useAssetsPath;
//#endregion
//#region src/lib/url.js
function $r(e) {
	return e.replace(/\/+$/, "");
}
//#endregion
//#region src/api.js
var ei = (0, Kr.default)((e, t) => {
	let n = Zr();
	if (Qr()) {
		let t = $r(n);
		return fetch(`${t}/themes/${encodeURIComponent(e)}.json`).then((e) => e.json());
	}
	return fetch(`${n}/accounts/${t}/styles/${e}`).then((e) => e.json());
}, { serializer: ([e, t]) => `${e}:${t}:${Qr()}` }), ti = (e, t) => {
	let n = { classes: !1 };
	t != null && (n.custom = { urls: [t.general.headerFontUrl, t.general.bodyFontUrl] }), e && (n.typekit = { id: e }), Object.keys(n).length > 1 && Gr.default.load(n);
}, ni = (e, t, n) => {
	if (!e) return;
	let r = (n.ownerDocument || document).createElement("style");
	r.innerHTML = `${e}`, t && r.classList.add(`theme-${t}`), n.shadowRoot.prepend(r);
}, ri = async (e) => {
	let t = e.getAttribute("themeId"), { globalStyling: n, theme: r, typekitId: i } = await ei(t, e.getAttribute("accountId")).catch(() => {}) ?? {
		globalStyling: "",
		theme: {},
		typekitId: ""
	};
	ti(r?.json?.typekitId ?? i, r?.json), ni(r?.css, t, e), ni(n, t, e);
}, ii = async (e, t) => {
	await ri(e), t && e.shadowRoot.querySelectorAll(`.theme-${t}`).forEach((e) => e.remove());
}, ai = K({ step: ({ context: { step: e }, event: t }) => ({
	...e,
	virtualizedContent: t.virtualizedContent
}) }), oi = (e) => K({ step: ({ event: t }) => ({
	stepConfig: t.stepConfig,
	virtualizedContent: e(t.stepConfig)
}) }), si = K({
	experience: ({ event: e }) => e.experience,
	step: ({ context: { step: e }, event: t }) => ({
		...e,
		...t.stepConfig
	})
}), ci = q({ type: Dn }), li = q(({ context: { step: e, stopReason: t } }) => ({
	type: Wn,
	id: e.id,
	reason: t
})), ui = ({ event: { styles: e, getRoot: t } }) => {
	let n = t();
	n && Object.entries(e).forEach(([e, t]) => {
		e.startsWith("--") ? n.style.setProperty(e, t) : n.style[e] = t;
	});
}, di = (e) => ({ context: t }) => {
	let { theme: n, themeSystem: r, id: i } = t.experience;
	if (r || !n) return;
	let a = e("getWindowReference")().document.documentElement.querySelector(`#${Tr(i)}`), o = a.getAttribute("themeId");
	a?.setAttribute("themeId", n), ii(a, o);
}, fi = (e) => K({ step: ({ context: { step: t } }) => {
	if (t.type !== "tooltip" || t.contentType === "application/json") return t;
	let n = Object.entries(t.actions).filter(([, e]) => e.find((e) => e.on === "click")).map(([e]) => e), r = t.traits.filter(({ config: e }) => e.targetId).map(({ config: e }) => e.targetId);
	return {
		...t,
		virtualizedContent: e(t, {
			interactiveEls: n,
			focusableEls: r
		})
	};
} }), pi = nn(({ enqueue: e, event: t }) => {
	t.errorEvent?.type === "STEP_CONTAINER_REMOVED" && e.raise({
		type: Ln,
		isAutoRecoverEvent: !0
	});
}), mi = K({ actionsRunning: !0 }), hi = K({ actionsRunning: !1 }), gi = ({ event: e }) => {
	let t = e.changedExperienceTraits && e.changedExperienceTraits.changedTraits.length > 0, n = e.changedExperienceTraits && (e.changedExperienceTraits.addedTraits.length > 0 || e.changedExperienceTraits.removedTraits.length > 0), r = e.changedStepTraits && e.changedStepTraits.changedTraits.length > 0, i = e.changedStepTraits && (e.changedStepTraits.addedTraits.length > 0 || e.changedStepTraits.removedTraits.length > 0);
	return n || i ? !1 : !!(t || r);
}, _i = "There is already a key registered with this name", vi = "Key name should be string and callback a valid function", yi = () => {
	let e = /* @__PURE__ */ new Map(), t = (t) => e.get(t);
	return {
		getCallback: t,
		registerCallback: (n, r) => {
			if (t(n) && console.info(`${_i}: ${n}, the callback will be replaced by the new one`), typeof n != "string" || typeof r != "function") throw TypeError(vi);
			e.set(n, r);
		}
	};
}, bi = ({ getTrait: e, trait: t, ...n }) => {
	let r = e(t.type);
	r && r(n, t.config ?? {});
}, { getCallback: xi, registerCallback: Z } = yi(), Si = (e = 21) => crypto.getRandomValues(new Uint8Array(e)).reduce((e, t) => (t &= 63, t < 36 ? e += t.toString(36) : t < 62 ? e += (t - 26).toString(36).toUpperCase() : t > 62 ? e += "-" : e += "_", e), ""), Ci = ({ experience: e, callback: t, step: n, findId: r, getContainer: i, getWindowReference: a, sendToExperience: o }) => {
	let s = (e, { forwardToParent: r = !1 } = {}) => {
		let s = ({ type: e, ...n }) => t(r ? {
			...n,
			eventType: e,
			type: qn
		} : {
			type: e,
			...n
		}), c = (e) => r && o ? o(e) : s(e);
		return {
			querySelector: (e) => Mr(e, {
				step: n,
				checkOutsideContainer: !1,
				stepContainer: i(),
				getWindowReference: a
			}),
			start: () => c({
				type: jn,
				id: e.id
			}),
			stop: (t, n) => {
				c({
					type: Mn,
					id: e.id,
					onStopped: t,
					reason: n
				});
			},
			setStepContainerTarget: (t) => {
				s({
					type: Pn,
					id: e.id,
					container: t
				});
			},
			recover: ({ errorId: t }) => {
				s({
					type: In,
					id: e.id,
					errorId: t
				});
			},
			dismissExperience: () => s({ type: Gn }),
			snoozeExperience: () => s({ type: Kn }),
			seen: () => s({
				type: Vn,
				id: e.id
			}),
			getConfig: () => e,
			interaction: (t, n) => s({
				type: Bn,
				id: e.id,
				interactionType: t,
				interactionData: n
			}),
			extendedEvent: (t, n) => s({
				type: An,
				id: e.id,
				name: t,
				...n
			})
		};
	}, c = e.steps.map((e) => s(e, { forwardToParent: !!n }));
	return n ? {
		getRootNodeId: () => r(n.virtualizedContent),
		steps: c,
		step: s(n, { forwardToParent: !1 })
	} : {
		getRootNodeId: () => r(n.virtualizedContent),
		steps: c
	};
}, wi = ({ experience: e, step: t, overrideStyle: n, getContainer: r, getRoot: i, callback: a, get: o, getAction: s = () => null, handleNavigation: c }) => {
	let { findId: l } = o("vNodeHandlers"), u = o("getWindowReference"), d = o("getExperienceSend"), f = Ci({
		experience: e,
		step: t,
		callback: a,
		findId: l,
		getContainer: r,
		getWindowReference: u,
		sendToExperience: typeof d == "function" ? d(e.id) : void 0
	}), p = (e) => {
		let t = Si();
		return console.info("error reported:", e), a({
			type: zn,
			message: e,
			errorId: t
		}), t;
	}, m = () => a({ type: kn }), h = () => e.id, g = {
		getContainer: r,
		querySelector: (e) => Mr(e, {
			step: t,
			checkOutsideContainer: !0,
			stepContainer: r(),
			getWindowReference: u
		}),
		reportError: p,
		onElementInserted: (e) => Or({
			...e,
			getWindowReference: u
		}),
		onElementRemoved: (e) => kr({
			...e,
			getWindowReference: u
		}),
		...f,
		stopExperience: m,
		getExperienceId: h,
		getWindowReference: u,
		sendEvent: o("sendEvent"),
		sendCustomEvent: o("sendCustomEvent"),
		showFlow: (t) => o("showFlow")({
			campaignId: e.campaignId ?? null,
			tacticId: e.tacticId ?? null,
			...t
		}),
		updateUserProfile: o("updateUserProfile"),
		handleNavigation: (n) => c({
			...n,
			experienceId: e.id,
			stepId: t.id,
			campaignId: e.campaignId ?? null,
			tacticId: e.tacticId ?? null
		}),
		getAction: (n) => s(`${e.id}.${n}`) ?? s(`${t.id}.${n}`) ?? s(n)
	};
	return n ? {
		updateStyle: (e, r) => {
			n(e, r), a({
				type: Nn,
				id: t.id
			});
		},
		updateRootStyle: (e, t = {}) => {
			a({
				type: Hn,
				styles: e,
				options: t,
				getRoot: i
			});
		},
		...g
	} : g;
}, Ti = "formData.", Ei = "a, button, video, input, textarea, select, form", Di = (e, t) => {
	if (t.startsWith(Ti)) {
		let n = t.replace(Ti, "");
		return new FormData(e.target).get(n);
	}
	return bn(e, t);
}, { getCallback: Oi, registerCallback: ki } = yi(), Ai = (e, t, n) => {
	let r = {
		target: t.target,
		detail: t.detail
	};
	return Object.entries(e).reduce((e, [t, n]) => {
		let i = Di(r, t);
		return i ? vn(e, n, i) : e;
	}, n);
}, ji = ({ step: e, experience: t, overrideStyle: n, getContainer: r, callback: i, get: a }) => {
	let o = a("getWindowReference"), s = [], c = [], l = (e) => {
		try {
			return [...Cr(e, o().document.documentElement)];
		} catch {
			return [];
		}
	}, u = (o, c) => {
		if (o.length === 0) return;
		let l = {};
		c.forEach(({ on: n, type: r, config: i, allowedKeys: a, mapEventToConfig: o }) => {
			if (!i?.external || n.startsWith("hooks/")) return;
			let s = Oi(`${t.id}.${r}`) ?? Oi(`${e.id}.${r}`) ?? Oi(r);
			l[n] || (l[n] = []), s && l[n].push([
				s,
				i,
				a,
				o
			]);
		}), Object.entries(l).forEach(([c, l]) => {
			let u = (o) => {
				i({ type: Yn });
				let s = wi({
					experience: t,
					step: e,
					overrideStyle: n,
					getContainer: r,
					callback: i,
					get: a,
					getAction: Oi
				});
				try {
					l.forEach(([e, t, n, r]) => {
						n && !n.includes(o.code) || e(r ? {
							...t,
							...Ai(r, o, t)
						} : t, s);
					});
				} catch {
					s.reportError("something bad happened while running an action.");
				} finally {
					i({ type: Xn });
				}
			};
			o.forEach((e) => {
				e.addEventListener(c, u), s.push({
					el: e,
					event: c,
					handler: u
				});
			});
		});
	};
	return Object.entries(e.actions ?? {}).forEach(([e, t]) => {
		if (!t.some((e) => e.config?.external)) return;
		let n = l(e);
		if (n.length > 0) {
			u(n, t);
			return;
		}
		let r = Or({
			getTarget: () => l(e),
			onInserted: () => {
				u(l(e), t);
			},
			getWindowReference: o
		});
		c.push(r);
	}), () => {
		s.forEach(({ el: e, event: t, handler: n }) => e.removeEventListener(t, n)), c.forEach((e) => e());
	};
}, Mi = ({ overrideStyle: e, getContainer: t }, n) => Nt(({ sendBack: r, receive: i }) => {
	let a = () => {};
	return i(({ type: i, step: o, experience: s }) => {
		if (i === "RUN_TRAITS_DONE") {
			a();
			try {
				let { findId: i, traverseTree: c, injectHandlers: l } = n("vNodeHandlers"), u = JSON.parse(JSON.stringify(o.virtualizedContent));
				c(u, (a) => {
					let c = i(a);
					if (!o.actions[c]) return;
					let u = {}, d = (i, a) => {
						r({ type: Yn });
						let c = wi({
							experience: s,
							step: o,
							overrideStyle: e,
							getContainer: t,
							callback: r,
							get: n,
							getAction: Oi,
							handleNavigation: n("handleNavigation")
						});
						try {
							u[i].forEach(([e, t, n]) => {
								e(n && a ? {
									...t,
									...Ai(n, a, t)
								} : t, c);
							});
						} catch {
							c.reportError("something bad happened while running an action.");
						} finally {
							r({ type: Xn });
						}
					}, f = {}, p = o.actions[c].reduce((e, { on: t, type: n, config: r, allowedKeys: i, mapEventToConfig: a, guardInteractiveChildren: c }) => {
						c && (f[t] = !0);
						let l = Oi(`${s.id}.${n}`) ?? Oi(`${o.id}.${n}`) ?? Oi(n);
						return u[t] || (u[t] = []), l && u[t].push([
							l,
							r,
							a
						]), t.startsWith("hooks/") ? e.hook[t.replace("hooks/", "")] = () => d(t) : e.on[t] = (e) => {
							if (!(i && !i.includes(e.code))) {
								if (f[t]) {
									let t = e.target.closest(Ei);
									if (t && t !== e.currentTarget) return;
								}
								e.preventDefault(), e.stopPropagation(), d(t, e);
							}
						}, e;
					}, {
						on: {},
						hook: {}
					});
					a = l(a, p);
				}), r({
					type: Fn,
					virtualizedContent: u
				}), a = ji({
					step: o,
					experience: s,
					overrideStyle: e,
					getContainer: t,
					callback: r,
					get: n
				});
			} catch (e) {
				console.error("[actions service] Error binding actions:", e), r({ type: vr });
			}
		}
	}), () => a();
}), Ni = ({ addHook: e }) => Nt(({ sendBack: t, input: n }) => {
	let { step: r } = n;
	try {
		r.traits.forEach((t) => bi({
			getTrait: xi,
			addHook: (n, r) => {
				e(n, {
					callback: r,
					traitId: t.id
				});
			},
			registerAction: (e, n) => {
				ki(`${r.id}.${t.type}.${e}`, n);
			},
			trait: t
		})), t({ type: gr });
	} catch {
		t({ type: _r });
	}
}), Pi = ({ applyOverridesToVnode: e }) => {
	let t = {}, n = (e) => (n, r) => {
		t[n] || (t[n] = {}), t[n][e] || (t[n][e] = {}), t[n][e] = {
			...t[n][e],
			...r
		};
	}, r = (e) => t[e];
	return {
		createOverrideCallback: n,
		getOverrides: r,
		applyOverrides: K(({ context: { step: t } }) => ({ step: {
			...t,
			virtualizedContent: e(t.virtualizedContent, r)
		} })),
		clearOverrides: () => {
			t = {};
		}
	};
};
//#endregion
//#region ../../node_modules/snabbdom/build/htmldomapi.js
function Fi(e, t) {
	return document.createElement(e, t);
}
function Ii(e, t, n) {
	return document.createElementNS(e, t, n);
}
function Li() {
	return Qi(document.createDocumentFragment());
}
function Ri(e) {
	return document.createTextNode(e);
}
function zi(e) {
	return document.createComment(e);
}
function Bi(e, t, n) {
	if (Zi(e)) {
		let t = e;
		for (; t && Zi(t);) t = Qi(t).parent;
		e = t ?? e;
	}
	Zi(t) && (t = Qi(t, e)), n && Zi(n) && (n = Qi(n).firstChildNode), e.insertBefore(t, n);
}
function Vi(e, t) {
	e.removeChild(t);
}
function Hi(e, t) {
	Zi(t) && (t = Qi(t, e)), e.appendChild(t);
}
function Ui(e) {
	if (Zi(e)) {
		for (; e && Zi(e);) e = Qi(e).parent;
		return e ?? null;
	}
	return e.parentNode;
}
function Wi(e) {
	if (Zi(e)) {
		let t = Qi(e), n = Ui(t);
		if (n && t.lastChildNode) {
			let e = Array.from(n.childNodes);
			return e[e.indexOf(t.lastChildNode) + 1] ?? null;
		}
		return null;
	}
	return e.nextSibling;
}
function Gi(e) {
	return e.tagName;
}
function Ki(e, t) {
	e.textContent = t;
}
function qi(e) {
	return e.textContent;
}
function Ji(e) {
	return e.nodeType === 1;
}
function Yi(e) {
	return e.nodeType === 3;
}
function Xi(e) {
	return e.nodeType === 8;
}
function Zi(e) {
	return e.nodeType === 11;
}
function Qi(e, t) {
	let n = e;
	return n.parent ??= t ?? null, n.firstChildNode ??= e.firstChild, n.lastChildNode ??= e.lastChild, n;
}
var $i, ea = o((() => {
	$i = {
		createElement: Fi,
		createElementNS: Ii,
		createTextNode: Ri,
		createDocumentFragment: Li,
		createComment: zi,
		insertBefore: Bi,
		removeChild: Vi,
		appendChild: Hi,
		parentNode: Ui,
		nextSibling: Wi,
		tagName: Gi,
		setTextContent: Ki,
		getTextContent: qi,
		isElement: Ji,
		isText: Yi,
		isComment: Xi,
		isDocumentFragment: Zi
	};
}));
//#endregion
//#region ../../node_modules/snabbdom/build/vnode.js
function Q(e, t, n, r, i) {
	return {
		sel: e,
		data: t,
		children: n,
		text: r,
		elm: i,
		key: t === void 0 ? void 0 : t.key
	};
}
var ta = o((() => {}));
//#endregion
//#region ../../node_modules/snabbdom/build/is.js
function na(e) {
	return typeof e == "string" || typeof e == "number" || e instanceof String || e instanceof Number;
}
var ra, ia = o((() => {
	ra = Array.isArray;
}));
//#endregion
//#region ../../node_modules/snabbdom/build/init.js
function aa(e, t) {
	let n = e.key === t.key, r = e.data?.is === t.data?.is, i = e.sel === t.sel, a = !e.sel && e.sel === t.sel ? typeof e.text == typeof t.text : !0;
	return i && n && r && a;
}
function oa() {
	throw Error("The document fragment is not supported on this platform.");
}
function sa(e, t) {
	return e.isElement(t);
}
function ca(e, t) {
	return e.isDocumentFragment(t);
}
function la(e, t, n) {
	let r = {};
	for (let i = t; i <= n; ++i) {
		let t = e[i]?.key;
		t !== void 0 && (r[t] = i);
	}
	return r;
}
function ua(e, t, n) {
	let r = {
		create: [],
		update: [],
		remove: [],
		destroy: [],
		pre: [],
		post: []
	}, i = t === void 0 ? $i : t;
	for (let t of fa) for (let n of e) {
		let e = n[t];
		e !== void 0 && r[t].push(e);
	}
	function a(e) {
		let t = e.id ? "#" + e.id : "", n = e.getAttribute("class"), r = n ? "." + n.split(" ").join(".") : "";
		return Q(i.tagName(e).toLowerCase() + t + r, {}, [], void 0, e);
	}
	function o(e) {
		return Q(void 0, {}, [], void 0, e);
	}
	function s(e, t) {
		return function() {
			if (--t === 0) {
				let t = i.parentNode(e);
				t !== null && i.removeChild(t, e);
			}
		};
	}
	function c(e, t) {
		var a, o;
		let s, l = e.data, u = l?.hook;
		(a = u?.init) == null || a.call(u, e);
		let d = e.children, f = e.sel;
		if (f === "!") e.text ??= "", e.elm = i.createComment(e.text);
		else if (f === "") e.elm = i.createTextNode(e.text);
		else if (f !== void 0) {
			let n = f.indexOf("#"), a = f.indexOf(".", n), p = n > 0 ? n : f.length, m = a > 0 ? a : f.length, h = n !== -1 || a !== -1 ? f.slice(0, Math.min(p, m)) : f, g = l?.ns, _ = g === void 0 ? i.createElement(h, l) : i.createElementNS(g, h, l);
			for (e.elm = _, p < m && _.setAttribute("id", f.slice(p + 1, m)), a > 0 && _.setAttribute("class", f.slice(m + 1).replace(/\./g, " ")), s = 0; s < r.create.length; ++s) r.create[s](da, e);
			if (na(e.text) && (!ra(d) || d.length === 0) && i.appendChild(_, i.createTextNode(e.text)), ra(d)) for (s = 0; s < d.length; ++s) {
				let e = d[s];
				e != null && i.appendChild(_, c(e, t));
			}
			u !== void 0 && ((o = u.create) == null || o.call(u, da, e), u.insert !== void 0 && t.push(e));
		} else if (n?.experimental?.fragments && e.children) {
			for (e.elm = (i.createDocumentFragment ?? oa)(), s = 0; s < r.create.length; ++s) r.create[s](da, e);
			for (s = 0; s < e.children.length; ++s) {
				let n = e.children[s];
				n != null && i.appendChild(e.elm, c(n, t));
			}
		} else e.elm = i.createTextNode(e.text);
		return e.elm;
	}
	function l(e, t, n, r, a, o) {
		for (; r <= a; ++r) {
			let a = n[r];
			a != null && i.insertBefore(e, c(a, o), t);
		}
	}
	function u(e) {
		var t, n;
		let i = e.data;
		if (i !== void 0) {
			(n = (t = i?.hook)?.destroy) == null || n.call(t, e);
			for (let t = 0; t < r.destroy.length; ++t) r.destroy[t](e);
			if (e.children !== void 0) for (let t = 0; t < e.children.length; ++t) {
				let n = e.children[t];
				n != null && typeof n != "string" && u(n);
			}
		}
	}
	function d(e, t, n, a) {
		for (; n <= a; ++n) {
			let a, o = t[n];
			if (o != null) if (o.sel !== void 0) {
				u(o), a = r.remove.length + 1;
				let e = s(o.elm, a);
				for (let t = 0; t < r.remove.length; ++t) r.remove[t](o, e);
				let t = o?.data?.hook?.remove;
				t === void 0 ? e() : t(o, e);
			} else o.children ? (u(o), d(e, o.children, 0, o.children.length - 1)) : i.removeChild(e, o.elm);
		}
	}
	function f(e, t, n, r) {
		let a = 0, o = 0, s = t.length - 1, u = t[0], f = t[s], m = n.length - 1, h = n[0], g = n[m], _, v, y, b;
		for (; a <= s && o <= m;) u == null ? u = t[++a] : f == null ? f = t[--s] : h == null ? h = n[++o] : g == null ? g = n[--m] : aa(u, h) ? (p(u, h, r), u = t[++a], h = n[++o]) : aa(f, g) ? (p(f, g, r), f = t[--s], g = n[--m]) : aa(u, g) ? (p(u, g, r), i.insertBefore(e, u.elm, i.nextSibling(f.elm)), u = t[++a], g = n[--m]) : aa(f, h) ? (p(f, h, r), i.insertBefore(e, f.elm, u.elm), f = t[--s], h = n[++o]) : (_ === void 0 && (_ = la(t, a, s)), v = _[h.key], v === void 0 ? (i.insertBefore(e, c(h, r), u.elm), h = n[++o]) : _[g.key] === void 0 ? (i.insertBefore(e, c(g, r), i.nextSibling(f.elm)), g = n[--m]) : (y = t[v], y.sel === h.sel ? (p(y, h, r), t[v] = void 0, i.insertBefore(e, y.elm, u.elm)) : i.insertBefore(e, c(h, r), u.elm), h = n[++o]));
		o <= m && (b = n[m + 1] == null ? null : n[m + 1].elm, l(e, b, n, o, m, r)), a <= s && d(e, t, a, s);
	}
	function p(e, t, n) {
		var a, o, s, c;
		let u = t.data?.hook;
		(a = u?.prepatch) == null || a.call(u, e, t);
		let p = t.elm = e.elm;
		if (e === t) return;
		if (t.data !== void 0 || t.text !== void 0 && t.text !== e.text) {
			t.data ??= {}, e.data ??= {};
			for (let n = 0; n < r.update.length; ++n) r.update[n](e, t);
			(s = (o = t.data?.hook)?.update) == null || s.call(o, e, t);
		}
		let m = e.children, h = t.children;
		t.text === void 0 ? m !== void 0 && h !== void 0 ? m !== h && f(p, m, h, n) : h === void 0 ? m === void 0 ? e.text !== void 0 && i.setTextContent(p, "") : d(p, m, 0, m.length - 1) : (e.text !== void 0 && i.setTextContent(p, ""), l(p, null, h, 0, h.length - 1, n)) : e.text !== t.text && (m !== void 0 && d(p, m, 0, m.length - 1), i.setTextContent(p, t.text)), (c = u?.postpatch) == null || c.call(u, e, t);
	}
	return function(e, t) {
		let n, s, l, u = [];
		for (n = 0; n < r.pre.length; ++n) r.pre[n]();
		for (sa(i, e) ? e = a(e) : ca(i, e) && (e = o(e)), aa(e, t) ? p(e, t, u) : (s = e.elm, l = i.parentNode(s), c(t, u), l !== null && (i.insertBefore(l, t.elm, i.nextSibling(s)), d(l, [e], 0, 0))), n = 0; n < u.length; ++n) u[n].data.hook.insert(u[n]);
		for (n = 0; n < r.post.length; ++n) r.post[n]();
		return t;
	};
}
var da, fa, pa = o((() => {
	ta(), ia(), ea(), da = Q("", {}, [], void 0, void 0), fa = [
		"create",
		"update",
		"remove",
		"destroy",
		"pre",
		"post"
	];
}));
//#endregion
//#region ../../node_modules/snabbdom/build/h.js
function ma(e, t, n) {
	if (e.ns = "http://www.w3.org/2000/svg", n !== "foreignObject" && t !== void 0) for (let e = 0; e < t.length; ++e) {
		let n = t[e];
		if (typeof n == "string") continue;
		let r = n.data;
		r !== void 0 && ma(r, n.children, n.sel);
	}
}
function ha(e, t, n) {
	let r = {}, i, a, o;
	if (n === void 0 ? t != null && (ra(t) ? i = t : na(t) ? a = t.toString() : t && t.sel ? i = [t] : r = t) : (t !== null && (r = t), ra(n) ? i = n : na(n) ? a = n.toString() : n && n.sel && (i = [n])), i !== void 0) for (o = 0; o < i.length; ++o) na(i[o]) && (i[o] = Q(void 0, void 0, void 0, i[o], void 0));
	return e.startsWith("svg") && (e.length === 3 || e[3] === "." || e[3] === "#") && ma(r, i, e), Q(e, r, i, a, void 0);
}
function ga(e) {
	let t, n;
	if (ra(e) ? t = e : na(t) ? n = e : t && t.sel && (t = [e]), t !== void 0) for (let e = 0; e < t.length; ++e) na(t[e]) && (t[e] = Q(void 0, void 0, void 0, t[e], void 0));
	return Q(void 0, {}, t, n, void 0);
}
var _a = o((() => {
	ta(), ia();
}));
//#endregion
//#region ../../node_modules/snabbdom/build/thunk.js
function va(e, t) {
	let n = t.data?.ns;
	e.data.fn = t.data.fn, e.data.args = t.data.args, t.data = e.data, t.children = e.children, t.text = e.text, t.elm = e.elm, n && ma(t.data, t.children, t.sel);
}
function ya(e) {
	let t = e.data;
	va(t.fn(...t.args), e);
}
function ba(e, t) {
	let n, r = e.data, i = t.data, a = r.args, o = i.args;
	if (r.fn !== i.fn || a.length !== o.length) {
		va(i.fn(...o), t);
		return;
	}
	for (n = 0; n < o.length; ++n) if (a[n] !== o[n]) {
		va(i.fn(...o), t);
		return;
	}
	va(e, t);
}
var xa, Sa = o((() => {
	_a(), xa = function(e, t, n, r) {
		return r === void 0 && (r = n, n = t, t = void 0), ha(e, {
			key: t,
			hook: {
				init: ya,
				prepatch: ba
			},
			fn: n,
			args: r
		});
	};
}));
//#endregion
//#region ../../node_modules/snabbdom/build/helpers/attachto.js
function Ca(e, t) {
	let n = e.data.attachData;
	t.data.attachData.placeholder = n.placeholder, t.data.attachData.real = n.real, e.elm = e.data.attachData.real;
}
function wa(e, t) {
	t.elm = t.data.attachData.placeholder;
}
function Ta(e) {
	e.elm !== void 0 && e.elm.parentNode.removeChild(e.elm), e.elm = e.data.attachData.real;
}
function Ea(e, t) {
	let n = t.elm, r = t.data.attachData, i = document.createElement("span");
	t.elm = i, r.target.appendChild(n), r.real = n, r.placeholder = i;
}
function Da(e, t) {
	t.data === void 0 && (t.data = {}), t.data.hook === void 0 && (t.data.hook = {});
	let n = t.data, r = t.data.hook;
	return n.attachData = {
		target: e,
		placeholder: void 0,
		real: void 0
	}, r.create = Ea, r.prepatch = Ca, r.postpatch = wa, r.destroy = Ta, t;
}
var Oa = o((() => {}));
//#endregion
//#region ../../node_modules/snabbdom/build/tovnode.js
function ka(e) {
	return e.slice(5).replace(/-([a-z])/g, (e, t) => t.toUpperCase());
}
function Aa(e, t) {
	let n = t === void 0 ? $i : t, r;
	if (n.isElement(e)) {
		let r = e.id ? "#" + e.id : "", i = e.getAttribute("class")?.match(/[^\t\r\n\f ]+/g), a = i ? "." + i.join(".") : "", o = n.tagName(e).toLowerCase() + r + a, s = {}, c = {}, l = {}, u = [], d, f, p, m = e.attributes, h = e.childNodes;
		for (f = 0, p = m.length; f < p; f++) d = m[f].nodeName, d.startsWith("data-") ? c[ka(d)] = m[f].nodeValue || "" : d !== "id" && d !== "class" && (s[d] = m[f].nodeValue);
		for (f = 0, p = h.length; f < p; f++) u.push(Aa(h[f], t));
		return Object.keys(s).length > 0 && (l.attrs = s), Object.keys(c).length > 0 && (l.dataset = c), o.startsWith("svg") && (o.length === 3 || o[3] === "." || o[3] === "#") && ma(l, u, o), Q(o, l, u, void 0, e);
	} else if (n.isText(e)) return r = n.getTextContent(e), Q(void 0, void 0, void 0, r, e);
	else if (n.isComment(e)) return r = n.getTextContent(e), Q("!", {}, [], r, e);
	else return Q("", {}, [], void 0, e);
}
var ja = o((() => {
	_a(), ta(), ea();
})), Ma = o((() => {}));
//#endregion
//#region ../../node_modules/snabbdom/build/modules/attributes.js
function Na(e, t) {
	let n, r = t.elm, i = e.data.attrs, a = t.data.attrs;
	if (!(!i && !a) && i !== a) {
		for (n in i ||= {}, a ||= {}, a) {
			let e = a[n];
			i[n] !== e && (e === !0 ? r.setAttribute(n, "") : e === !1 ? r.removeAttribute(n) : n.charCodeAt(0) === Ra ? n.charCodeAt(3) === La ? r.setAttributeNS(Ia, n, e) : n.charCodeAt(5) === La ? n.charCodeAt(1) === za ? r.setAttributeNS(Fa, n, e) : r.setAttributeNS(Pa, n, e) : r.setAttribute(n, e) : r.setAttribute(n, e));
		}
		for (n in i) n in a || r.removeAttribute(n);
	}
}
var Pa, Fa, Ia, La, Ra, za, Ba, Va = o((() => {
	Pa = "http://www.w3.org/1999/xlink", Fa = "http://www.w3.org/2000/xmlns/", Ia = "http://www.w3.org/XML/1998/namespace", La = 58, Ra = 120, za = 109, Ba = {
		create: Na,
		update: Na
	};
}));
//#endregion
//#region ../../node_modules/snabbdom/build/modules/class.js
function Ha(e, t) {
	let n, r, i = t.elm, a = e.data.class, o = t.data.class;
	if (!(!a && !o) && a !== o) {
		for (r in a ||= {}, o ||= {}, a) a[r] && !Object.prototype.hasOwnProperty.call(o, r) && i.classList.remove(r);
		for (r in o) n = o[r], n !== a[r] && i.classList[n ? "add" : "remove"](r);
	}
}
var Ua, Wa = o((() => {
	Ua = {
		create: Ha,
		update: Ha
	};
}));
//#endregion
//#region ../../node_modules/snabbdom/build/modules/dataset.js
function Ga(e, t) {
	let n = t.elm, r = e.data.dataset, i = t.data.dataset, a;
	if (!r && !i || r === i) return;
	r ||= {}, i ||= {};
	let o = n.dataset;
	for (a in r) a in i || (o ? a in o && delete o[a] : n.removeAttribute("data-" + a.replace(Ka, "-$&").toLowerCase()));
	for (a in i) r[a] !== i[a] && (o ? o[a] = i[a] : n.setAttribute("data-" + a.replace(Ka, "-$&").toLowerCase(), i[a]));
}
var Ka, qa, Ja = o((() => {
	Ka = /[A-Z]/g, qa = {
		create: Ga,
		update: Ga
	};
}));
//#endregion
//#region ../../node_modules/snabbdom/build/modules/eventlisteners.js
function Ya(e, t, n) {
	if (typeof e == "function") e.call(t, n, t);
	else if (typeof e == "object") for (let r = 0; r < e.length; r++) Ya(e[r], t, n);
}
function Xa(e, t) {
	let n = e.type, r = t.data.on;
	r && r[n] && Ya(r[n], t, e);
}
function Za() {
	return function e(t) {
		Xa(t, e.vnode);
	};
}
function Qa(e, t) {
	let n = e.data.on, r = e.listener, i = e.elm, a = t && t.data.on, o = t && t.elm, s;
	if (n !== a) {
		if (n && r) if (a) for (s in n) a[s] || i.removeEventListener(s, r, !1);
		else for (s in n) i.removeEventListener(s, r, !1);
		if (a) {
			let r = t.listener = e.listener || Za();
			if (r.vnode = t, n) for (s in a) n[s] || o.addEventListener(s, r, !1);
			else for (s in a) o.addEventListener(s, r, !1);
		}
	}
}
var $a, eo = o((() => {
	$a = {
		create: Qa,
		update: Qa,
		destroy: Qa
	};
}));
//#endregion
//#region ../../node_modules/snabbdom/build/modules/props.js
function to(e, t) {
	let n, r, i, a = t.elm, o = e.data.props, s = t.data.props;
	if (!(!o && !s) && o !== s) for (n in o ||= {}, s ||= {}, s) r = s[n], i = o[n], i !== r && (n !== "value" || a[n] !== r) && (a[n] = r);
}
var no, ro = o((() => {
	no = {
		create: to,
		update: to
	};
}));
//#endregion
//#region ../../node_modules/snabbdom/build/modules/style.js
function io(e, t, n) {
	uo(() => {
		e[t] = n;
	});
}
function ao(e, t) {
	let n, r, i = t.elm, a = e.data.style, o = t.data.style;
	if (!a && !o || a === o) return;
	a ||= {}, o ||= {};
	let s = "delayed" in a;
	for (r in a) r in o || (r[0] === "-" && r[1] === "-" ? i.style.removeProperty(r) : i.style[r] = "");
	for (r in o) if (n = o[r], r === "delayed" && o.delayed) for (let e in o.delayed) n = o.delayed[e], (!s || n !== a.delayed[e]) && io(i.style, e, n);
	else r !== "remove" && n !== a[r] && (r[0] === "-" && r[1] === "-" ? i.style.setProperty(r, n) : i.style[r] = n);
}
function oo(e) {
	let t, n, r = e.elm, i = e.data.style;
	if (!(!i || !(t = i.destroy))) for (n in t) r.style[n] = t[n];
}
function so(e, t) {
	let n = e.data.style;
	if (!n || !n.remove) {
		t();
		return;
	}
	fo ||= (e.elm.offsetLeft, !0);
	let r, i = e.elm, a = 0, o = n.remove, s = 0, c = [];
	for (r in o) c.push(r), i.style[r] = o[r];
	let l = getComputedStyle(i)["transition-property"].split(", ");
	for (; a < l.length; ++a) c.indexOf(l[a]) !== -1 && s++;
	i.addEventListener("transitionend", (e) => {
		e.target === i && --s, s === 0 && t();
	});
}
function co() {
	fo = !1;
}
var lo, uo, fo, po, mo = o((() => {
	lo = typeof (window == null ? void 0 : window.requestAnimationFrame) == "function" ? window.requestAnimationFrame.bind(window) : setTimeout, uo = (e) => {
		lo(() => {
			lo(e);
		});
	}, fo = !1, po = {
		pre: co,
		create: ao,
		update: ao,
		destroy: oo,
		remove: so
	};
}));
//#endregion
//#region ../../node_modules/snabbdom/build/jsx.js
function ho(e, ...t) {
	let n = go(t, []);
	return n.length === 1 && !n[0].sel && n[0].text ? Q(void 0, void 0, void 0, n[0].text, void 0) : Q(void 0, e ?? {}, n, void 0, void 0);
}
function go(e, t) {
	for (let n of e) n != null && n !== !1 && n !== "" && (Array.isArray(n) ? go(n, t) : typeof n == "string" || typeof n == "number" || typeof n == "boolean" ? t.push(Q(void 0, void 0, void 0, String(n), void 0)) : t.push(n));
	return t;
}
function _o(e, t, ...n) {
	let r = go(n, []);
	return typeof e == "function" ? e(t, r) : r.length === 1 && !r[0].sel && r[0].text ? ha(e, t, r[0].text) : ha(e, t, r);
}
var vo = o((() => {
	ta(), _a();
})), yo = /* @__PURE__ */ c({
	Fragment: () => ho,
	array: () => ra,
	attachTo: () => Da,
	attributesModule: () => Ba,
	classModule: () => Ua,
	datasetModule: () => qa,
	eventListenersModule: () => $a,
	fragment: () => ga,
	h: () => ha,
	htmlDomApi: () => $i,
	init: () => ua,
	jsx: () => _o,
	primitive: () => na,
	propsModule: () => no,
	styleModule: () => po,
	thunk: () => xa,
	toVNode: () => Aa,
	vnode: () => Q
}), bo = o((() => {
	ea(), pa(), Sa(), ta(), Oa(), ia(), ja(), _a(), Ma(), Va(), Wa(), Ja(), eo(), ro(), mo(), vo();
}));
//#endregion
//#region src/core/lib/functions.js
bo();
var xo = (...e) => (t) => e.reduce((e, t) => t(e), t), So = (e) => e.reduce((e, { callback: t, context: n }) => e.then(() => t(n)), Promise.resolve()), Co = ({ experience: e, onRender: t, onRenderReset: n, wrapContent: r, getWindowReference: i = () => window }) => {
	let a = null, o = null, s = () => {
		let t = i().document, n = Tr(e.id);
		return t.documentElement.querySelector(`#${n}`);
	}, c = () => o ? o.shadowRoot : null, l = () => a ? a.shadowRoot : null, u = xo((e) => (l() !== null || c() !== null || (a = s()), e), r, ({ step: { virtualizedContent: e } }) => {
		t(c() ?? l(), e);
	});
	return {
		render: Lt(async ({ input: e }) => new Promise((t) => {
			t(u(e));
		})),
		unmount: () => t(null, ha("!")),
		setContainer: ({ context: e, event: { container: t } }) => {
			let { theme: n, themeSystem: r, accountId: a } = e.experience, { id: s } = e.step;
			o && o.remove(), o = Pr({
				accountId: a,
				id: s,
				...!r && { theme: n },
				getWindowReference: i
			}), t.parentNode.replaceChild(o, t);
		},
		resetRender: () => {
			a = null, o && o.remove(), o = null, n();
		},
		getContainer: () => c() ?? l() ?? s().shadowRoot,
		getRoot: () => o ?? s(),
		hasCustomContainer: ({ event: e }) => e.type === "UPDATE_ROOT_STYLE" && e.options?.forceUpdate || !!c()
	};
}, wo = ({ container: e, nodes: t }, n = 0) => e.replace(/<% node %>/, t[n]), To = (e) => e.replaceAll("//twemoji.maxcdn.com/2/svg/", "//cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/svg/"), Eo = (e) => e.split("_").map((e) => e.charAt(0).toUpperCase() + e.slice(1)).join(" "), Do = ({ experience: e, experienceInstanceId: t }, n) => ({
	experienceId: e.id,
	experienceName: e.name,
	experienceType: e.type,
	isCoreEvent: !0,
	localeName: e.context?.localeName || "default",
	localeId: e.context?.localeId || "default",
	...e.campaignId != null && { campaignId: e.campaignId },
	...e.tacticId != null && { tacticId: e.tacticId },
	timestamp: Date.now(),
	version: e.version,
	name: Eo(n),
	experienceInstanceId: t
}), Oo = ({ step: e }) => ({
	stepId: e.id,
	stepName: e.name,
	stepType: e.type
}), ko = ({ context: e, event: t }) => !e.blockedEvents[t.type], Ao = (e) => {
	let t = ({ context: t }) => {
		let n = "experience_started", r = Do(t, n);
		e("sendEvent")(n, r);
	}, n = ({ context: t }) => {
		let n = "experience_completed", r = Do(t, n);
		e("sendEvent")(n, r);
	}, r = ({ context: t, event: { message: n } }) => {
		let r = "experience_error", i = Do(t, r);
		e("sendEvent")(r, {
			...i,
			message: n
		});
	}, i = ({ context: t }) => {
		let n = "experience_dismissed", r = Do(t, n), i = Oo(t);
		e("sendEvent")(n, {
			...r,
			...i
		});
	}, a = ({ context: t }) => {
		let n = "experience_snoozed", r = Do(t, n), i = Oo(t);
		e("sendEvent")(n, {
			...r,
			...i
		});
	}, o = ({ context: t }) => {
		let n = "step_seen", r = Do(t, n), i = Oo(t);
		e("sendEvent")(n, {
			...r,
			...i
		});
	}, s = ({ context: t }) => {
		let n = "step_completed", r = Do(t, n), i = Oo(t);
		e("sendEvent")(n, {
			...r,
			...i
		});
	}, c = ({ context: t, event: n }) => {
		let r = Do(t, n.name), i = Oo(t), a = e("sendEvent"), { name: o, ...s } = n;
		a(o, {
			...r,
			...i,
			...s
		});
	}, l = ({ context: t, event: { interactionType: n, interactionData: r } }) => {
		let i = "step_interaction", a = Do(t, i), o = Oo(t);
		e("sendEvent")(i, {
			...a,
			...o,
			interactionType: n,
			interactionData: r
		});
	}, u = ({ context: t, event: { message: n, errorId: r, error: i } }) => {
		let a = "step_error", o = Do(t, a), s = Oo(t);
		e("sendEvent")(a, {
			...o,
			...s,
			message: n ?? i?.message,
			errorId: r
		});
	}, d = ({ context: t, event: { errorId: n } }) => {
		let r = "step_recovered", i = Do(t, r), a = Oo(t);
		e("sendEvent")(r, {
			...i,
			...a,
			errorId: n
		});
	}, f = K(({ context: e, event: { type: t, name: n = "" } }) => {
		let r = t === "EXTENDED_EVENT" ? n : t;
		return { blockedEvents: {
			...e.blockedEvents,
			[r]: !0
		} };
	});
	return {
		experienceActions: {
			experienceStarted: t,
			experienceError: r,
			experienceCompleted: n
		},
		stepActions: {
			experienceDismissed: i,
			experienceSnoozed: a,
			stepSeen: o,
			stepInteraction: l,
			stepError: u,
			stepRecovered: d,
			stepExtendedEvent: c,
			stepCompleted: s
		},
		helpers: {
			blockEvent: f,
			isEventEnabled: ko
		}
	};
}, jo = rn({
	initial: "waitingForAsyncEvents",
	context: { runHooksDone: !1 },
	states: {
		waitingForAsyncEvents: { on: {
			UPDATE_STEP: "update_step",
			ERROR: "error",
			RUN_HOOKS_DONE: {
				target: "",
				actions: K({ runHooksDone: !0 })
			}
		} },
		update_step: {
			always: [{
				target: "done",
				guard: ({ context: e }) => e.runHooksDone,
				actions: [q({ type: "RERENDER" })]
			}],
			on: {
				UPDATE_STEP: "",
				ERROR: "error",
				RUN_HOOKS_DONE: {
					target: "done",
					actions: [K({ runHooksDone: !0 }), q({ type: "RERENDER" })]
				}
			}
		},
		error: {
			always: [{
				target: "done",
				guard: ({ context: e }) => e.runHooksDone,
				actions: [q({ type: "FORCE_ERROR" })]
			}],
			on: {
				UPDATE_STEP: "",
				ERROR: "",
				RUN_HOOKS_DONE: {
					target: "done",
					actions: [K({ runHooksDone: !0 }), q({ type: "FORCE_ERROR" })]
				}
			}
		},
		done: { type: "final" }
	}
}), Mo = rn({
	initial: "waitingForAsyncEvents",
	context: { runHooksDone: !1 },
	states: {
		waitingForAsyncEvents: { on: {
			RECOVER_STEP: "recover_step",
			RUN_HOOKS_DONE: {
				target: "",
				actions: K({ runHooksDone: !0 })
			}
		} },
		recover_step: {
			always: [{
				target: "done",
				guard: ({ context: e }) => e.runHooksDone,
				actions: [q({ type: "FORCE_RECOVER" })]
			}],
			on: { RUN_HOOKS_DONE: {
				target: "done",
				actions: [K({ runHooksDone: !0 }), q({ type: "FORCE_RECOVER" })]
			} }
		},
		done: { type: "final" }
	}
}), No = {
	initial: "waiting_to_render",
	on: {
		SET_STEP_CONTAINER_TARGET: {
			actions: ["setContainer", "runStepContainerChangeHooks"],
			target: ""
		},
		UPDATE_ROOT_STYLE: {
			actions: "updateRootStyle",
			target: "",
			guard: "hasCustomContainer"
		},
		UPDATE_STEP_CONTENT: {
			actions: "setContent",
			target: ""
		},
		RUN_HOOKS_ERROR: ".destroyed",
		BIND_ACTIONS_ERROR: ".destroyed",
		STOP_STEP: [{
			guard: "hasPendingActions",
			target: ".waitingPendingActions",
			actions: ["saveStopReason", "addStoppedCallback"]
		}, {
			target: ".running_end_hooks",
			actions: ["saveStopReason", "addStoppedCallback"]
		}],
		PARENT_RECOVER_STEP: {
			actions: ["stepRecovered", "clearStepErrorEmitted"],
			target: ".rendering"
		},
		EXPERIENCE_DISMISSED: {
			target: "",
			actions: ["experienceDismissed", q({
				type: kn,
				reason: X.DISMISSED
			})]
		},
		EXPERIENCE_SNOOZED: {
			target: "",
			actions: ["experienceSnoozed", q({
				type: kn,
				reason: X.DISMISSED
			})]
		},
		STEP_SEEN: {
			target: "",
			actions: ["queueStepSeen", "blockEvent"],
			guard: "isEventEnabled"
		},
		STEP_INTERACTION: {
			target: "",
			actions: ["stepInteraction"]
		},
		EXTENDED_EVENT: {
			actions: ["stepExtendedEvent", "blockEvent"],
			guard: "isEventEnabled"
		},
		RELOAD: [
			{
				target: ".reload",
				actions: ["updateTheme", "updateStepContext"],
				guard: "didThemeChange"
			},
			{
				target: ".reloading_traits",
				actions: [
					"setVirtualizedContent",
					"updateStepContext",
					"saveChangedStepTraits",
					"saveChangedExperienceTraits"
				],
				guard: "shouldOnlyReloadTraits"
			},
			{
				target: ".reload",
				actions: ["setVirtualizedContent", "updateStepContext"],
				guard: "shouldStepReload"
			},
			{
				target: ".rendering",
				actions: [
					"setVirtualizedContent",
					"updateStepContext",
					"rebindActions"
				],
				guard: "didContentChanged"
			}
		],
		[kn]: { actions: [q({ type: kn })] },
		FORWARD_TO_PARENT: [{ actions: [q(({ event: { eventType: e, ...t } }) => ({
			...t,
			type: e
		}))] }],
		ACTIONS_STARTED: {
			target: "",
			actions: "setActionsRunning"
		},
		ACTIONS_FINISHED: {
			target: "",
			actions: "setActionsFinished"
		}
	},
	invoke: [
		{
			id: "hooksService",
			src: "hooksService"
		},
		{
			id: "actionsService",
			src: "actionsService"
		},
		{
			id: "themeRemovalService",
			src: "themeRemovalService"
		}
	],
	states: {
		waiting_to_render: { on: { START_STEP: "running_traits" } },
		reload: {
			entry: [
				"removeCustomContainer",
				"unmount",
				"resetRender",
				"clearOverrides",
				"runStepEndHooks"
			],
			exit: ["removeStepHooks"],
			on: { RUN_HOOKS_DONE: {
				target: "running_traits",
				guard: "isHooksDoneEventEndType"
			} }
		},
		reloading_traits: {
			initial: "running_end_hooks",
			exit: ["clearChangedStepTraits", "clearChangedExperienceTraits"],
			onDone: {
				target: "rendering",
				actions: "ensuresElementsAreAccessible"
			},
			on: { ERROR: {
				target: "error",
				actions: "stepError"
			} },
			states: {
				running_end_hooks: {
					entry: ["runStepEndHooks"],
					on: { RUN_HOOKS_DONE: {
						target: "running_pre_begin_hooks",
						guard: "isHooksDoneEventEndType"
					} }
				},
				running_pre_begin_hooks: {
					entry: ["runStepPreBeginHooks"],
					exit: ["rebindActions"],
					on: { RUN_HOOKS_DONE: {
						target: "running_begin_hooks",
						guard: "isHooksDoneEventPreBeginType"
					} }
				},
				running_begin_hooks: {
					entry: ["runStepBeginHooks"],
					on: { RUN_HOOKS_DONE: {
						target: "done",
						guard: "isHooksDoneEventBeginType"
					} }
				},
				done: { type: "final" }
			}
		},
		running_traits: {
			invoke: {
				src: "runStepTraits",
				input: ({ context: e }) => ({ step: e.step })
			},
			on: {
				RUN_TRAITS_DONE: {
					target: "pre_begin",
					actions: "rebindActions"
				},
				RUN_TRAITS_ERROR: "destroyed"
			}
		},
		pre_begin: {
			entry: ["runStepPreBeginHooks"],
			on: {
				ERROR: {
					target: "error",
					actions: "reportStepErrorOnce"
				},
				RUN_HOOKS_DONE: {
					target: "begin",
					guard: "isHooksDoneEventPreBeginType"
				}
			}
		},
		begin: {
			entry: ["runStepBeginHooks"],
			on: {
				ERROR: {
					target: "error",
					actions: "reportStepErrorOnce"
				},
				RUN_HOOKS_DONE: {
					target: "rendering",
					actions: "ensuresElementsAreAccessible",
					guard: "isHooksDoneEventBeginType"
				}
			}
		},
		rendering: {
			initial: "pre-render",
			on: { STEP_CONTAINER_REMOVED: { target: "error" } },
			states: {
				"pre-render": {
					entry: ["runStepPreRenderHooks"],
					on: { RUN_HOOKS_DONE: [{
						target: "render",
						actions: ["applyOverrides"],
						guard: "isHooksDoneEventPreRenderType"
					}] }
				},
				render: { invoke: {
					src: "render",
					input: ({ context: e }) => e,
					onDone: [{
						target: "post-render",
						guard: "hasCustomContainer",
						actions: "startThemeRemovalListener"
					}, { target: "post-render" }],
					onError: {
						target: "#error",
						actions: "stepError"
					}
				} },
				"post-render": {
					invoke: {
						id: "postRenderAsyncEventsHandler",
						src: jo
					},
					entry: ["runStepPostRenderHooks"],
					on: {
						FORCE_ERROR: "#error",
						RERENDER: "pre-render",
						UPDATE_STEP: {
							target: "",
							actions: [en("postRenderAsyncEventsHandler")]
						},
						ERROR: {
							target: "",
							actions: [
								en("postRenderAsyncEventsHandler"),
								"reportStepErrorOnce",
								"markErrorReported"
							]
						},
						RUN_HOOKS_DONE: {
							target: "",
							guard: "isHooksDoneEventPostRenderType",
							actions: [
								"notifyExperienceStarted",
								"commitPendingStepSeen",
								en("postRenderAsyncEventsHandler")
							]
						}
					}
				}
			}
		},
		running_end_hooks: {
			entry: ["runStepEndHooks"],
			on: {
				RUN_HOOKS_DONE: [{
					guard: "shouldFireStepCompletedEvent",
					target: "calling_stopped_callbacks",
					actions: [
						"removeCustomContainer",
						"unmount",
						"stepCompleted",
						"removeStepHooks"
					]
				}, {
					guard: "isHooksDoneEventEndType",
					target: "calling_stopped_callbacks",
					actions: [
						"removeCustomContainer",
						"unmount",
						"removeStepHooks"
					]
				}],
				RUN_HOOKS_ERROR: {
					target: "destroyed",
					actions: ["callStoppedCallbacks"]
				}
			}
		},
		calling_stopped_callbacks: {
			entry: ["callStoppedCallbacks", "deferTransitionToEnd"],
			on: { [Jn]: "end" }
		},
		end: {
			type: "final",
			entry: ["notifyStepStopped"]
		},
		error: {
			id: "error",
			invoke: [{
				id: "errorAsyncEventsHandler",
				src: Mo
			}],
			entry: [
				"unmount",
				"runStepErrorHooks",
				"stopThemeRemovalListener"
			],
			on: {
				RUN_HOOKS_DONE: {
					target: "",
					guard: "isHooksDoneEventErrorType",
					actions: [en("errorAsyncEventsHandler"), "autoRecover"]
				},
				RECOVER_STEP: {
					target: "",
					actions: [en("errorAsyncEventsHandler")]
				},
				FORCE_RECOVER: {
					target: "pre_begin",
					actions: [
						"resetRender",
						"stepRecovered",
						"clearStepErrorEmitted"
					]
				},
				AUTO_RECOVER_STEP: {
					target: "pre_begin",
					actions: ["resetRender", "clearStepErrorEmitted"],
					guard: "isAutoRecoverEvent"
				}
			}
		},
		destroyed: { entry: ["reportStepErrorOnce", "unmount"] },
		waitingPendingActions: { on: { ACTIONS_FINISHED: {
			target: "running_end_hooks",
			actions: "setActionsFinished"
		} } }
	}
}, Po = (e, { createStepHooks: t, createHooksService: n, experience: r, get: i, experienceInstanceId: a }) => {
	let { virtualizeContent: o, createVnodeTree: s, wrapContent: c, applyOverridesToVnode: l } = i("vNodeHandlers"), { makeElementsAccessible: u } = i("accessibilityHandlers"), { applyOverrides: d, createOverrideCallback: f, clearOverrides: p } = Pi({ applyOverridesToVnode: l }), m = f("style"), h = i("getWindowReference"), { onRender: g, onRenderReset: _ } = i("createRenderListener")(), { render: v, unmount: y, setContainer: b, resetRender: x, getContainer: S, hasCustomContainer: C, getRoot: w } = Co({
		experience: r,
		onRender: g,
		onRenderReset: _,
		wrapContent: c,
		getWindowReference: h
	}), { addHook: T, runStepPreBeginHooks: E, runStepBeginHooks: D, runStepPreRenderHooks: O, runStepPostRenderHooks: k, runStepEndHooks: A, runStepErrorHooks: j, removeStepHooks: M, runStepContainerChangeHooks: N } = t({
		step: e,
		overrideStyle: m
	}), P = Ni({ addHook: T }), ee = Mi({
		overrideStyle: m,
		getContainer: S,
		getRoot: w
	}, i), F = n({
		overrideStyle: m,
		getContainer: S,
		getRoot: w
	}, i), te = Br({
		getRoot: w,
		getWindowReference: h
	}), I = di(i), L = Ao(i), R = (e) => e.contentType === "text/html" ? o(To(wo(e.content))) : s(e.content);
	return rn({
		...No,
		context: {
			id: `step-machine-${e.id}`,
			step: {
				...e,
				activeNodeIndex: 0,
				virtualizedContent: R(e)
			},
			experience: r,
			blockedEvents: {},
			pendingStepSeen: !1,
			errorReported: !1,
			stepErrorEmitted: !1,
			actionsRunning: !1,
			experienceInstanceId: a,
			stopReason: null,
			stoppedCallbacks: [],
			changedStepTraits: null,
			changedExperienceTraits: null
		}
	}, {
		actions: {
			setContent: ai,
			updateRootStyle: ui,
			unmount: y,
			setContainer: b,
			updateTheme: I,
			resetRender: x,
			runStepPreBeginHooks: E,
			runStepBeginHooks: D,
			runStepPreRenderHooks: O,
			runStepPostRenderHooks: k,
			runStepEndHooks: A,
			runStepErrorHooks: j,
			runStepContainerChangeHooks: N,
			updateStepContext: si,
			rebindActions: $t("actionsService", ({ context: e }) => ({
				type: gr,
				step: e.step,
				experience: e.experience
			})),
			removeStepHooks: () => M(),
			clearOverrides: () => p(),
			setVirtualizedContent: oi(R),
			applyOverrides: d,
			startThemeRemovalListener: Vr,
			stopThemeRemovalListener: Hr,
			removeCustomContainer: Rr({ getRoot: w }),
			ensuresElementsAreAccessible: fi(u),
			notifyExperienceStarted: ci,
			notifyStepStopped: li,
			...L.stepActions,
			blockEvent: L.helpers.blockEvent,
			queueStepSeen: K({ pendingStepSeen: !0 }),
			markErrorReported: K({ errorReported: !0 }),
			markStepErrorEmitted: K({ stepErrorEmitted: !0 }),
			clearStepErrorEmitted: K({ stepErrorEmitted: !1 }),
			reportStepErrorOnce: nn(({ context: e, enqueue: t }) => {
				e.stepErrorEmitted || (t("stepError"), t("markStepErrorEmitted"));
			}),
			commitPendingStepSeen: K(({ context: e }) => (e.pendingStepSeen && !e.errorReported && L.stepActions.stepSeen({ context: e }), { pendingStepSeen: !1 })),
			autoRecover: pi,
			setActionsRunning: mi,
			setActionsFinished: hi,
			saveStopReason: K({ stopReason: ({ event: e }) => e.reason }),
			addStoppedCallback: K({ stoppedCallbacks: ({ context: e, event: t }) => t.onStopped ? [...e.stoppedCallbacks, t.onStopped] : e.stoppedCallbacks }),
			callStoppedCallbacks: ({ context: e }) => e.stoppedCallbacks.forEach((e) => {
				try {
					e();
				} catch {}
			}),
			deferTransitionToEnd: jt({ type: Jn }, { delay: 0 }),
			saveChangedStepTraits: K({ changedStepTraits: ({ event: e }) => e.changedStepTraits ?? null }),
			clearChangedStepTraits: K({ changedStepTraits: () => null }),
			saveChangedExperienceTraits: K({ changedExperienceTraits: ({ event: e }) => e.changedExperienceTraits ?? null }),
			clearChangedExperienceTraits: K({ changedExperienceTraits: () => null })
		},
		actors: {
			runStepTraits: P,
			render: v,
			hooksService: F,
			actionsService: ee,
			themeRemovalService: te
		},
		guards: {
			hasCustomContainer: C,
			isAutoRecoverEvent: ({ event: e }) => e.isAutoRecoverEvent,
			isEventEnabled: L.helpers.isEventEnabled,
			didContentChanged: ({ context: e, event: t }) => !(0, En.default)(e.step.content, t.stepConfig.content),
			shouldOnlyReloadTraits: gi,
			shouldStepReload: ({ context: e, event: t }) => !(0, En.default)(e.step.traits, t.stepConfig.traits) || !(0, En.default)(e.step.actions, t.stepConfig.actions) || !(0, En.default)(e.experience.traits, t.experience.traits),
			didThemeChange: ({ context: e, event: t }) => e.experience.theme !== t.experience.theme,
			isHooksDoneEventPostRenderType: ({ event: e }) => e.hookType === nr,
			isHooksDoneEventPreRenderType: ({ event: e }) => e.hookType === tr,
			isHooksDoneEventPreBeginType: ({ event: e }) => e.hookType === $n,
			isHooksDoneEventBeginType: ({ event: e }) => e.hookType === er,
			isHooksDoneEventErrorType: ({ event: e }) => e.hookType === ir,
			isHooksDoneEventEndType: ({ event: e }) => e.hookType === rr,
			hasPendingActions: ({ context: e }) => e.actionsRunning,
			shouldFireStepCompletedEvent: ({ context: e, event: t }) => t.hookType === "step.end" && e.blockedEvents.STEP_SEEN && e.stopReason !== X.NAVIGATION && e.stopReason !== X.DISMISSED && e.stopReason !== X.ERROR
		}
	});
}, Fo = ({ createStepHooks: e, createHooksService: t, get: n }) => K({ stepMachines: ({ context: { experience: r, experienceInstanceId: i }, spawn: a }) => {
	let o = {
		experience: r,
		experienceInstanceId: i,
		createStepHooks: e,
		createHooksService: t,
		get: n
	};
	return r.steps.reduce((e, t) => (e[`${t.id}`] = a(Po(t, o), { id: `step-machine - ${t.id}` }), e), {});
} }), Io = ({ createStepHooks: e, createHooksService: t, get: n }) => K({ stepMachines: ({ context: { experience: r, stepMachines: i }, event: a, spawn: o }) => {
	let s = {
		experience: r,
		createStepHooks: e,
		createHooksService: t,
		get: n
	}, c = r.steps.find((e) => e.id === a.id);
	return c ? {
		...i,
		[`${a.id}`]: o(Po(c, s), { id: `step-machine - ${a.id}` })
	} : i;
} }), Lo = (e) => ({ context: t, event: { id: n, ...r } }) => {
	t.stepMachines[n]?.send({
		...r,
		type: e
	});
}, Ro = Lo(jn), zo = ({ context: e, event: t }) => {
	let n = e.stepMachines[t.id];
	n && (n.getSnapshot().status === "done" && t.onStopped ? t.onStopped() : n.send({
		...t,
		type: Mn
	}));
}, Bo = Lo(Nn), Vo = Lo(Pn), Ho = Lo(Rn), Uo = Lo(Fn), Wo = ({ context: e, event: t }) => {
	Object.values(e.stepMachines).forEach((e) => {
		e.send({
			type: Mn,
			reason: t.reason
		});
	});
}, Go = (e = [], t = []) => {
	let n = new Map(e.map((e) => [e.id, e])), r = new Map(t.map((e) => [e.id, e]));
	return {
		addedTraits: t.filter((e) => {
			let t = n.get(e.id);
			return !t || t.type !== e.type;
		}),
		removedTraits: e.filter((e) => {
			let t = r.get(e.id);
			return !t || t.type !== e.type;
		}),
		changedTraits: t.filter((e) => {
			let t = n.get(e.id);
			return !t || t.type !== e.type ? !1 : !(0, En.default)(t.config || {}, e.config || {});
		})
	};
}, Ko = K(({ context: e, event: t }) => {
	let n = Go(e.experience.traits, t.experience.traits);
	return Object.entries(e.stepMachines).forEach(([r, i]) => {
		let a = e.experience.steps.find((e) => e.id === r), o = t.experience.steps.find((e) => e.id === r);
		if (!a || !o) return;
		let s = Go(a.traits, o.traits);
		i.send({
			type: Un,
			stepConfig: o,
			experience: t.experience,
			changedExperienceTraits: n,
			changedStepTraits: s
		});
	}), { experience: t.experience };
}), qo = ({ context: e }) => {
	Object.values(e.stepMachines).forEach((e) => {
		e.send({ type: dr });
	});
}, Jo = K({ experienceInstanceId: () => wn() }), Yo = K({ stepMachines: ({ context: e, event: t }) => Object.entries(e.stepMachines).reduce((e, [n, r]) => (n !== t.id && (e[n] = r), e), {}) }), Xo = K({ experience: ({ context: { experience: e }, event: t }) => {
	let n = e.steps.findIndex((e) => e.id === t.id);
	return n === -1 ? e : yn(e, `steps.${n}.traits`, (e) => e.filter(({ once: e = !1 }) => !e));
} }), Zo = ({ addHook: e }) => Nt(({ sendBack: t, input: n }) => {
	let { experience: r } = n;
	try {
		r.traits.forEach((t) => bi({
			getTrait: xi,
			trait: t,
			addHook: (n, r) => {
				e(n, {
					callback: r,
					traitId: t.id
				});
			},
			registerAction: (e, n) => ki(`${r.id}.${t.type}.${e}`, n)
		})), t({ type: gr });
	} catch {
		t({ type: _r });
	}
}), Qo = (e, t) => (n, { callback: r, traitId: i }) => {
	let a = e();
	a.get(n) || a.set(n, []), t(n, [...a.get(n), {
		callback: r,
		traitId: i
	}]);
}, $o = (e, t) => $t("hooksService", ({ context: n, event: r }) => {
	let i = t, a = r.changedExperienceTraits ?? n.changedExperienceTraits;
	a && (i = {
		...i,
		onlyExperienceTraits: a.changedTraits.filter((e) => e.id != null).map(({ id: e }) => e)
	});
	let o = r.changedStepTraits ?? n.changedStepTraits;
	return o && (i = {
		...i,
		onlyStepTraits: o.changedTraits.filter((e) => e.id != null).map(({ id: e }) => e)
	}), {
		type: or,
		hookType: e,
		experience: n.experience,
		step: n.step,
		...i
	};
}), es = $o(Zn), ts = $o(Qn), ns = $o($n), rs = $o(er), is = $o(tr), as = $o(nr), os = $o(rr), ss = nn(({ enqueue: e, event: t }) => {
	e($o(ir, { errorEvent: t }));
}), cs = $o(ar), ls = () => {
	let e = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Map();
	return {
		addHook: Qo(() => e, (t, n) => e.set(t, n)),
		createStepHooks: ({ step: e }) => (t.get(e.id) || t.set(e.id, /* @__PURE__ */ new Map()), {
			addHook: Qo(() => t.get(e.id), (n, r) => t.get(e.id).set(n, r)),
			removeStepHooks: () => t.set(e.id, /* @__PURE__ */ new Map()),
			runStepPreBeginHooks: ns,
			runStepBeginHooks: rs,
			runStepPreRenderHooks: is,
			runStepPostRenderHooks: as,
			runStepEndHooks: os,
			runStepErrorHooks: ss,
			runStepContainerChangeHooks: cs
		}),
		createHooksService: (n = {}, r) => Nt(({ sendBack: i, receive: a }) => {
			a(async ({ type: a, hookType: o, experience: s, step: c, ...l }) => {
				if (a !== "RUN_HOOKS") return;
				let u = {
					experience: s,
					step: c,
					callback: i,
					get: r,
					getContainer: n.getContainer
				};
				[
					"step.prebegin",
					"step.begin",
					"step.container_change",
					"step.end"
				].includes(o) && (u = {
					...u,
					...n
				});
				let d = ({ callback: e, trait: t }) => ({
					callback: e,
					context: {
						...wi({
							...u,
							getAction: Oi,
							handleNavigation: r("handleNavigation")
						}),
						getTraitConfig: () => t.config
					}
				}), f = (e.get(o) ?? []).filter(({ traitId: e }) => !l.onlyExperienceTraits || l.onlyExperienceTraits && l.onlyExperienceTraits.includes(e)).map((e) => d({
					...e,
					trait: (s.traits ?? []).find((t) => t.id === e.traitId)
				}));
				try {
					await So(f), c && await So((t.get(c.id)?.get(o) ?? []).filter(({ traitId: e }) => !l.onlyStepTraits || l.onlyStepTraits && l.onlyStepTraits.includes(e)).map((e) => d({
						...e,
						trait: (c.traits ?? []).find((t) => t.id === e.traitId)
					}))), i({
						type: sr,
						hookType: o,
						...l
					});
				} catch {
					i({ type: "RUN_HOOKS_ERROR" });
				}
			});
		}),
		runExperienceBeginHooks: es,
		runExperienceEndHooks: ts
	};
}, us = {
	id: "experience",
	initial: "idle",
	invoke: [{
		src: "hooksService",
		id: "hooksService"
	}, {
		id: "themeRemovalService",
		src: "globalThemeRemovalService",
		input: ({ context: e }) => ({ experience: e.experience })
	}],
	on: {
		RUN_HOOKS_ERROR: ".destroyed",
		EXPERIENCE_STARTED: {
			target: "",
			actions: ["experienceStarted", "blockEvent"],
			guard: "isEventEnabled"
		},
		SHOW: ".running-traits"
	},
	states: {
		idle: { on: { SHOW: [{
			target: "running-traits",
			actions: ["updateExperienceInstanceId"]
		}, { target: "destroyed" }] } },
		"running-traits": {
			invoke: {
				src: "runGlobalExperienceTraits",
				input: ({ context: e }) => ({ experience: e.experience })
			},
			on: {
				RUN_TRAITS_ERROR: "destroyed",
				RUN_TRAITS_DONE: "rendering-steps"
			}
		},
		"rendering-steps": {
			on: {
				STOP_EXPERIENCE: [{
					target: "end",
					actions: ["experienceCompleted", "stopSteps"],
					guard: "shouldFireCompletedEvent"
				}, {
					target: "end",
					actions: ["stopSteps"]
				}],
				START_STEP: [{
					target: "",
					guard: "doesStepInstanceExist",
					actions: "startStep"
				}, {
					target: "",
					actions: ["startStepMachine", "startStep"]
				}],
				STOP_STEP: {
					target: "",
					actions: "stopStep"
				},
				UPDATE_STEP: {
					target: "",
					actions: "updateStep"
				},
				SET_STEP_CONTAINER_TARGET: {
					target: "",
					actions: "setStepContainerTarget"
				},
				RECOVER_STEP: {
					target: "",
					actions: "recoverStep"
				},
				GLOBAL_CONTAINER_REMOVED: {
					target: "",
					actions: [
						"createGlobalThemeComponent",
						"startThemeRemovalListener",
						"notifyStepsContainerRemoved"
					]
				},
				UPDATE_STEP_CONTENT: {
					target: "",
					actions: "updateStepContent"
				},
				SHOW: {
					target: "",
					actions: ["reloadSteps"]
				},
				STEP_STOPPED: [
					{
						target: "end-final",
						guard: "areAllStepsStoppedFromError",
						actions: ["removeGlobalThemeComponent", "runExperienceEndHooks"]
					},
					{
						target: "end-final",
						guard: "areAllStepsStopped",
						actions: [
							"experienceCompleted",
							"removeGlobalThemeComponent",
							"runExperienceEndHooks"
						]
					},
					{
						target: "",
						actions: ["cleanStepMachines", "cleanRunOnceTraits"]
					}
				]
			},
			entry: [
				"createGlobalThemeComponent",
				"startStepMachines",
				"runExperienceBeginHooks",
				"startThemeRemovalListener"
			]
		},
		end: {
			entry: ["removeGlobalThemeComponent", "runExperienceEndHooks"],
			on: { [Wn]: {
				target: "end-final",
				guard: "areAllStepsStopped"
			} }
		},
		"end-final": { final: !0 },
		destroyed: {
			entry: "experienceError",
			type: "final"
		}
	}
}, ds = (e, t) => {
	let { addHook: n, createStepHooks: r, createHooksService: i, runExperienceBeginHooks: a, runExperienceEndHooks: o } = ls(), s = i({}, t), c = Fo({
		createStepHooks: r,
		createHooksService: i,
		get: t
	}), l = Io({
		createStepHooks: r,
		createHooksService: i,
		get: t
	}), u = Zo({ addHook: n }), d = Ao(t), f = Fr(t), p = Ir(t), m = zr(t);
	return rn({
		...us,
		context: {
			experience: e,
			blockedEvents: {},
			experienceInstanceId: null
		}
	}, {
		actions: {
			startStep: Ro,
			stopStep: zo,
			updateStep: Bo,
			setStepContainerTarget: Vo,
			recoverStep: Ho,
			startStepMachines: c,
			stopSteps: Wo,
			notifyStepsContainerRemoved: qo,
			updateStepContent: Uo,
			reloadSteps: Ko,
			updateExperienceInstanceId: Jo,
			cleanStepMachines: Yo,
			startStepMachine: l,
			runExperienceBeginHooks: a,
			runExperienceEndHooks: o,
			createGlobalThemeComponent: f,
			removeGlobalThemeComponent: p,
			startThemeRemovalListener: Vr,
			cleanRunOnceTraits: Xo,
			...d.experienceActions,
			blockEvent: d.helpers.blockEvent
		},
		actors: {
			runGlobalExperienceTraits: u,
			hooksService: s,
			globalThemeRemovalService: m
		},
		guards: {
			isEventEnabled: d.helpers.isEventEnabled,
			areAllStepsStopped: ({ context: e }) => Object.values(e.stepMachines).every((e) => e.getSnapshot().status === "done"),
			areAllStepsStoppedFromError: ({ context: e, event: t }) => t.reason === X.ERROR && Object.values(e.stepMachines).every((e) => e.getSnapshot().status === "done"),
			doesStepInstanceExist: ({ context: e, event: t }) => e.stepMachines?.[t.id] !== void 0,
			shouldFireCompletedEvent: ({ event: e }) => e.reason !== X.NAVIGATION && e.reason !== X.DISMISSED
		}
	});
};
//#endregion
//#region src/core/lib/patch.js
bo();
var fs = ua([
	Ua,
	no,
	po,
	$a,
	Ba
], void 0, { experimental: { fragments: !0 } });
function ps(e) {
	let t = (e.ownerDocument || document).createElement("div");
	return e.append(t), fs(t, ha("div"));
}
var ms = () => {
	let e = null;
	return {
		onRender: (t, n) => {
			!e && !t || (e ||= ps(t), e = fs(e, n));
		},
		onRenderReset: () => {
			e = null;
		}
	};
}, hs = /* @__PURE__ */ s(((e, t) => {
	t.exports = {
		area: !0,
		base: !0,
		br: !0,
		col: !0,
		embed: !0,
		hr: !0,
		img: !0,
		input: !0,
		keygen: !0,
		link: !0,
		menuitem: !0,
		meta: !0,
		param: !0,
		source: !0,
		track: !0,
		wbr: !0
	};
})), gs = /* @__PURE__ */ s(((e, t) => {
	var n = /([\w-]+)|=|(['"])([.\s\S]*?)\2/g, r = hs();
	t.exports = function(e) {
		var t = 0, i, a = !0, o = {
			type: "tag",
			name: "",
			voidElement: !1,
			attrs: {},
			children: []
		};
		return e.replace(n, function(n) {
			if (n === "=") {
				a = !0, t++;
				return;
			}
			a ? t === 0 ? ((r[n] || e.charAt(e.length - 2) === "/") && (o.voidElement = !0), o.name = n) : (o.attrs[i] = n.replace(/^['"]|['"]$/g, ""), i = void 0) : (i && (o.attrs[i] = i), i = n), t++, a = !1;
		}), o;
	};
})), _s = /* @__PURE__ */ s(((e, t) => {
	var n = /(?:<!--[\S\s]*?-->|<(?:"[^"]*"|'[^']*'|[^'">])+>)/g, r = gs(), i = Object.create ? Object.create(null) : {};
	function a(e, t, n, r, i) {
		var a = t.indexOf("<", r), o = t.slice(r, a === -1 ? void 0 : a);
		/^\s*$/.test(o) && (o = " "), (!i && a > -1 && n + e.length >= 0 || o !== " ") && e.push({
			type: "text",
			content: o
		});
	}
	t.exports = function(e, t) {
		t ||= {}, t.components ||= i;
		var o = [], s, c = -1, l = [], u = {}, d = !1;
		return e.replace(n, function(n, i) {
			if (d) {
				if (n !== "</" + s.name + ">") return;
				d = !1;
			}
			var f = n.charAt(1) !== "/", p = n.indexOf("<!--") === 0, m = i + n.length, h = e.charAt(m), g;
			f && !p && (c++, s = r(n), s.type === "tag" && t.components[s.name] && (s.type = "component", d = !0), !s.voidElement && !d && h && h !== "<" && a(s.children, e, c, m, t.ignoreWhitespace), u[s.tagName] = s, c === 0 && o.push(s), g = l[c - 1], g && g.children.push(s), l[c] = s), (p || !f || s.voidElement) && (p || c--, !d && h !== "<" && h && (g = c === -1 ? o : l[c].children, a(g, e, c, m, t.ignoreWhitespace)));
		}), !o.length && e.length && a(o, e, 0, 0, t.ignoreWhitespace), o;
	};
})), vs = /* @__PURE__ */ s(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.createTextVNode = n, e.transformName = r, e.unescapeEntities = o;
	var t = (bo(), d(yo));
	function n(e, n) {
		return (0, t.vnode)(void 0, void 0, void 0, o(e, n));
	}
	function r(e) {
		return e = e.replace(/-(\w)/g, function(e, t) {
			return t.toUpperCase();
		}), "" + e.charAt(0).toLowerCase() + e.substring(1);
	}
	var i = /* @__PURE__ */ RegExp("&[a-z0-9#]+;", "gi"), a = null;
	function o(e, t) {
		return a ||= t.createElement("div"), e.replace(i, function(e) {
			return a.innerHTML = e, a.textContent;
		});
	}
})), ys = /* @__PURE__ */ s(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.default = function(e) {
		var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = n.context || document;
		if (!e) return null;
		var i = [], a = o((0, t.default)(e), i, r), c = void 0;
		return c = a ? a.length === 1 ? a[0] : a : s({
			type: "text",
			content: e
		}, i, r), n.hooks && n.hooks.create && i.forEach(function(e) {
			n.hooks.create(e);
		}), c;
	};
	var t = i(_s()), n = (bo(), d(yo)), r = vs();
	function i(e) {
		return e && e.__esModule ? e : { default: e };
	}
	function a(e, t, n) {
		return t in e ? Object.defineProperty(e, t, {
			value: n,
			enumerable: !0,
			configurable: !0,
			writable: !0
		}) : e[t] = n, e;
	}
	function o(e, t, n) {
		if (e instanceof Array && e.length > 0) return e.map(function(e) {
			return s(e, t, n);
		});
	}
	function s(e, t, i) {
		var a = void 0;
		return a = e.type === "text" ? (0, r.createTextVNode)(e.content, i) : (0, n.h)(e.name, c(e, i), o(e.children, t, i)), t.push(a), a;
	}
	function c(e, t) {
		var n = {};
		if (!e.attrs) return n;
		var i = Object.keys(e.attrs).reduce(function(n, i) {
			if (i !== "style" && i !== "class") {
				var o = (0, r.unescapeEntities)(e.attrs[i], t);
				n ? n[i] = o : n = a({}, i, o);
			}
			return n;
		}, null);
		i && (n.attrs = i);
		var o = l(e);
		o && (n.style = o);
		var s = u(e);
		return s && (n.class = s), n;
	}
	function l(e) {
		try {
			return e.attrs.style.split(";").reduce(function(e, t) {
				var n = t.split(":"), i = (0, r.transformName)(n[0].trim());
				if (i) {
					var o = n[1].replace("!important", "").trim();
					e ? e[i] = o : e = a({}, i, o);
				}
				return e;
			}, null);
		} catch {
			return null;
		}
	}
	function u(e) {
		try {
			return e.attrs.class.split(" ").reduce(function(e, t) {
				return t = t.trim(), t && (e ? e[t] = !0 : e = a({}, t, !0)), e;
			}, null);
		} catch {
			return null;
		}
	}
})), bs = /* @__PURE__ */ s(((e, t) => {
	t.exports = ys();
})), xs = /* @__PURE__ */ c({
	applyOverridesToVnode: () => Ms,
	createStyleState: () => Ds,
	createVnodeTree: () => js,
	findId: () => Os,
	injectHandlers: () => Ps,
	mergeVnodeData: () => ks,
	traverseTree: () => As,
	virtualizeContent: () => Cs,
	wrapContent: () => Ns
});
bo();
var Ss = /* @__PURE__ */ u(bs(), 1), Cs = typeof Ss.default == "function" ? Ss.default : Ss.default.default, ws = "data-interaction-style", Ts = (e) => e.replace(/([A-Z])/g, (e) => `-${e[0].toLowerCase()}`), Es = (e) => e.replace(/&amp;/g, "&").replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&#39;/g, "'").replace(/&quot;/g, "\""), Ds = ({ nodeId: e, interactionId: t, state: n }) => {
	let r = t ? `[${ws}="${t}"]` : `#${e}`;
	return Object.keys(n).map((e) => `${r}:${e} {
        ${Object.entries(n[e]).map(([e, t]) => {
		let n = Es(String(t));
		return `${Ts(e)}:${n} !important`;
	}).join(";")}
      }`).join(" ");
}, Os = (e) => e.data && e.data.attrs ? e.data.attrs.id : void 0, ks = (e, t) => Object.keys(t).reduce((e, n) => ({
	...e,
	[n]: {
		...e[n],
		...t[n]
	}
}), e.data || {}), As = (e, t) => {
	e && (t(e), e.children && e.children.forEach((e) => As(e, t)));
}, js = (e) => {
	if (typeof e == "string") return Es(e);
	if (e == null) return ga([]);
	let { is: t = "div", children: n = [], style: r, behaviors: i, htmlCode: a, ...o } = e.props, { state: s, ...c } = r ?? {}, l = e.props.id, u = e.props[ws], d = ha(t, {
		...Object.keys(c).length > 0 && { style: c },
		...Object.keys(o).length > 0 && { attrs: o }
	}, n.map(js));
	return s ? ga([ha("style", Ds({
		nodeId: l,
		interactionId: u,
		state: s
	})), d]) : d;
}, Ms = (e, t) => {
	let n = t(Os(e)) ?? {};
	return {
		...e,
		data: ks(e, n),
		children: e.children?.map((e) => Ms(e, t))
	};
}, Ns = ({ step: e }) => {
	let t = Tr(e.id), n = ha("div", {
		attrs: { [hr]: t },
		style: {
			width: "100%",
			display: "contents"
		}
	}, [e.virtualizedContent]);
	return { step: {
		...e,
		virtualizedContent: n
	} };
}, Ps = (e, t) => (e.data = {
	...e.data,
	on: t.on,
	hook: t.hook
}, e), Fs = /* @__PURE__ */ c({ makeElementsAccessible: () => Rs }), Is = (e, t) => t.includes(e.data?.attrs?.id) && typeof e.data?.attrs?.tabindex != "string" && typeof e.data?.attrs?.tabIndex != "number", Ls = (e) => {
	e.data.attrs.tabindex = 0, e.sel = "button", e.data.style = {
		...e.data.style,
		border: e.data?.style?.border ?? "none",
		...e?.children?.length > 0 && { backgroundColor: e.data?.style?.backgroundColor ?? "transparent" }
	};
}, Rs = ({ virtualizedContent: e, index: t }, { interactiveEls: n = [], focusableEls: r = [] }) => (As(e, (e) => {
	Is(e, n) ? Ls(e) : Is(e, r) && (e.data.attrs = {
		...e.data.attrs,
		tabindex: 0,
		role: "dialog",
		"aria-labelledby": `content-${t}`,
		"aria-describedby": `content-${t}`
	}), e.data?.class?.canvas && (e.data.attrs = {
		...e.data.attrs,
		id: `content-${t}`
	});
}), e), zs = "@appcues/close", Bs = { markComplete: !0 };
ki(zs, ({ markComplete: e = Bs.markComplete } = Bs, { stopExperience: t, step: n }) => {
	e ? t() : n.dismissExperience();
});
//#endregion
//#region src/actions/redirectTo/redirect-to.js
var Vs = "@appcues/redirectTo";
function Hs(e, t) {
	if (/^https?:\/\//i.test(t)) return t;
	try {
		return new URL(t, e.location.origin).href;
	} catch {
		return t;
	}
}
ki(Vs, ({ url: e = "", openInNewWindow: t = !1 } = {}, { reportError: n, getWindowReference: r }) => {
	if (!e) {
		n("Can't redirect to undefined URL");
		return;
	}
	let i = r(), a = Hs(i, e);
	i.open(a, t ? "_blank" : "_self", "noopener");
}), ki("@appcues/trackEvent", ({ name: e, properties: t = {} }, { sendCustomEvent: n }) => {
	n(e, t);
}), ki("@appcues/triggerFlow", ({ flowId: e, url: t, prefetch: n = !1 } = {}, { showFlow: r }) => {
	r({
		flowId: e,
		url: t,
		prefetch: n
	});
});
//#endregion
//#region src/lib/objects.js
var Us = (e) => Object.keys(e).length === 0, Ws = (e) => {
	switch (e) {
		case "date.now": return Date.now();
		default: return null;
	}
}, Gs = (e) => typeof e == "string" && e.startsWith("{") && e.endsWith("}"), Ks = (e) => Object.entries(e).reduce((e, [t, n]) => {
	if (Gs(n)) {
		let r = Ws(n.slice(1, -1));
		return {
			...e,
			[t]: r ?? n
		};
	}
	return {
		...e,
		[t]: n
	};
}, {});
ki("@appcues/setUserProperties", (e, { updateUserProfile: t }) => {
	Us(e) || t(Ks(e));
}), ki("@appcues/toggleActions", ({ actions: e = [], target: t } = {}, n) => {
	let r = n.querySelector(t.selector);
	r.length !== 0 && e.forEach((e) => {
		let t = `toggleActions_${e.id}`, i = n.getAction(e.type), [a] = r, o = !a.getAttribute(t);
		i && o && (i(e.config, n), a.setAttribute(t, !0)), o || a.removeAttribute(t);
	});
});
//#endregion
//#region ../../node_modules/intl-locale-textinfo-polyfill/lib/Locale.js
var qs = /([\.\*\+\^\$\[\]\\\(\)\|\{\}\,\-\:\?])/g, Js = /^([a-zA-Z]{2,3}|[a-zA-Z]{5,8})(-[a-zA-Z]{4})?(-(?:[a-zA-Z]{2}|\d{3}))?(-(?:[a-zA-Z\d]{5,8}|\d[a-zA-Z\d]{3}))?$/, Ys = class e {
	constructor(e) {
		if (typeof e != "string") throw TypeError("A string argument is expected");
		if (!Js.test(e)) throw RangeError("A proper locale must be provided");
		this._locale = e;
	}
	static _escapeRegExpPattern(e) {
		return typeof e == "string" ? e.replace(qs, "\\$1") : e;
	}
	static _toLowerCase(e, t) {
		return typeof e == "string" ? e.toLowerCase() : t && e;
	}
	static _toUpperCase(e, t) {
		return typeof e == "string" ? e.toUpperCase() : t && e;
	}
	static _trim(e, t, n) {
		let r = [], i, a = function(e) {
			r.push("^" + e + "+|" + e + "+$");
		};
		if (typeof t == "boolean" && (n = t, t = null), typeof e != "string") return n ? e : void 0;
		Array.isArray(t) && t.map((e) => {
			a(this._escapeRegExpPattern(e));
		}), typeof t == "string" && a(this._escapeRegExpPattern(t)), t || a("\\s");
		let o = "(" + r.join("|") + ")";
		for (i = new RegExp(o, "g"); e.match(i);) e = e.replace(i, "");
		return e;
	}
	static _parseLocale(e) {
		if (typeof e != "string") return;
		let t = Js.exec(e), n, r, i;
		if (!e || !t) return;
		let a = this._trim(t[2], ["-", "_"]), o = this._trim(t[3], ["-", "_"]);
		return n = this._toLowerCase(t[1]), r = this._toLowerCase(a) || r, i = this._toUpperCase(o) || i, {
			lang: n,
			script: r,
			countryCode: i
		};
	}
	_isRtlLang() {
		let { lang: t, script: n } = e._parseLocale(this._locale);
		return n ? e._RTL_SCRIPTS.indexOf(n) >= 0 : e._BIDI_RTL_LANGS.indexOf(t) >= 0;
	}
	get textInfo() {
		return { direction: this._isRtlLang() ? "rtl" : "ltr" };
	}
};
Ys._RTL_SCRIPTS = /* @__PURE__ */ "adlm.arab.armi.avst.chrs.cprt.elym.hatr.hebr.hung.khar.lydi.mand.mani.mend.merc.mero.narb.nbat.nkoo.orkh.ougr.palm.phli.phlp.phnx.prti.rohg.samr.sarb.sogd.sogo.syrc.thaa.yezi".split("."), Ys._BIDI_RTL_LANGS = /* @__PURE__ */ "ae.aeb.ajt.apc.apd.ar.ara.arb.arc.arq.ars.ary.arz.ave.avl.bal.bcc.bej.bft.bgn.bqi.brh.cja.ckb.cld.dcc.dgl.div.drw.dv.fa.fas.fia.fub.gbz.gjk.gju.glk.grc.gwc.gwt.haz.he.heb.hnd.hno.iw.ji.kas.kby.khw.ks.kvx.kxp.kzh.lad.lah.lki.lrc.luz.mde.mfa.mki.mvy.myz.mzn.nqo.oru.ota.otk.oui.pal.pbu.per.pes.phl.phn.pnb.pra.prd.prs.ps.pus.rhg.rmt.scl.sd.sdh.shu.skr.smp.snd.sog.swb.syr.tnf.trw.ug.uig.ur.urd.wni.xco.xld.xmn.xmr.xna.xpr.xsa.ydd.yi.yid.zdj".split(".");
//#endregion
//#region src/traits/contentDirection/content-direction.js
var Xs = "@appcues/content-direction";
function Zs(e) {
	try {
		return new Ys(e).textInfo;
	} catch {
		return { direction: "ltr" };
	}
}
var Qs = ({ updateRootStyle: e, getTraitConfig: t }) => {
	let n = navigator.languages ? navigator.languages[0] : navigator.language || navigator.userLanguage, { currentLanguage: r = n, forceDirection: i = null } = t(), a = Zs(r);
	e({ direction: i ?? a.direction }, { forceUpdate: !0 });
};
Z(Xs, ({ addHook: e }) => {
	e("step.begin", Qs), e("step.container_change", Qs);
});
//#endregion
//#region ../../node_modules/@floating-ui/utils/dist/floating-ui.utils.mjs
var $s = [
	"top",
	"right",
	"bottom",
	"left"
], ec = ["start", "end"], tc = /* @__PURE__ */ $s.reduce((e, t) => e.concat(t, t + "-" + ec[0], t + "-" + ec[1]), []), nc = Math.min, rc = Math.max, ic = Math.round, ac = (e) => ({
	x: e,
	y: e
}), oc = {
	left: "right",
	right: "left",
	bottom: "top",
	top: "bottom"
}, sc = {
	start: "end",
	end: "start"
};
function cc(e, t, n) {
	return rc(e, nc(t, n));
}
function lc(e, t) {
	return typeof e == "function" ? e(t) : e;
}
function uc(e) {
	return e.split("-")[0];
}
function dc(e) {
	return e.split("-")[1];
}
function fc(e) {
	return e === "x" ? "y" : "x";
}
function pc(e) {
	return e === "y" ? "height" : "width";
}
var mc = /* @__PURE__ */ new Set(["top", "bottom"]);
function hc(e) {
	return mc.has(uc(e)) ? "y" : "x";
}
function gc(e) {
	return fc(hc(e));
}
function _c(e, t, n) {
	n === void 0 && (n = !1);
	let r = dc(e), i = gc(e), a = pc(i), o = i === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
	return t.reference[a] > t.floating[a] && (o = yc(o)), [o, yc(o)];
}
function vc(e) {
	return e.replace(/start|end/g, (e) => sc[e]);
}
function yc(e) {
	return e.replace(/left|right|bottom|top/g, (e) => oc[e]);
}
function bc(e) {
	return {
		top: 0,
		right: 0,
		bottom: 0,
		left: 0,
		...e
	};
}
function xc(e) {
	return typeof e == "number" ? {
		top: e,
		right: e,
		bottom: e,
		left: e
	} : bc(e);
}
function Sc(e) {
	let { x: t, y: n, width: r, height: i } = e;
	return {
		width: r,
		height: i,
		top: n,
		left: t,
		right: t + r,
		bottom: n + i,
		x: t,
		y: n
	};
}
//#endregion
//#region node_modules/@floating-ui/core/dist/floating-ui.core.mjs
function Cc(e, t, n) {
	let { reference: r, floating: i } = e, a = hc(t), o = gc(t), s = pc(o), c = uc(t), l = a === "y", u = r.x + r.width / 2 - i.width / 2, d = r.y + r.height / 2 - i.height / 2, f = r[s] / 2 - i[s] / 2, p;
	switch (c) {
		case "top":
			p = {
				x: u,
				y: r.y - i.height
			};
			break;
		case "bottom":
			p = {
				x: u,
				y: r.y + r.height
			};
			break;
		case "right":
			p = {
				x: r.x + r.width,
				y: d
			};
			break;
		case "left":
			p = {
				x: r.x - i.width,
				y: d
			};
			break;
		default: p = {
			x: r.x,
			y: r.y
		};
	}
	switch (dc(t)) {
		case "start":
			p[o] -= f * (n && l ? -1 : 1);
			break;
		case "end":
			p[o] += f * (n && l ? -1 : 1);
			break;
	}
	return p;
}
var wc = async (e, t, n) => {
	let { placement: r = "bottom", strategy: i = "absolute", middleware: a = [], platform: o } = n, s = a.filter(Boolean), c = await (o.isRTL == null ? void 0 : o.isRTL(t)), l = await o.getElementRects({
		reference: e,
		floating: t,
		strategy: i
	}), { x: u, y: d } = Cc(l, r, c), f = r, p = {}, m = 0;
	for (let n = 0; n < s.length; n++) {
		let { name: a, fn: h } = s[n], { x: g, y: _, data: v, reset: y } = await h({
			x: u,
			y: d,
			initialPlacement: r,
			placement: f,
			strategy: i,
			middlewareData: p,
			rects: l,
			platform: o,
			elements: {
				reference: e,
				floating: t
			}
		});
		u = g ?? u, d = _ ?? d, p = {
			...p,
			[a]: {
				...p[a],
				...v
			}
		}, y && m <= 50 && (m++, typeof y == "object" && (y.placement && (f = y.placement), y.rects && (l = y.rects === !0 ? await o.getElementRects({
			reference: e,
			floating: t,
			strategy: i
		}) : y.rects), {x: u, y: d} = Cc(l, f, c)), n = -1);
	}
	return {
		x: u,
		y: d,
		placement: f,
		strategy: i,
		middlewareData: p
	};
};
async function Tc(e, t) {
	t === void 0 && (t = {});
	let { x: n, y: r, platform: i, rects: a, elements: o, strategy: s } = e, { boundary: c = "clippingAncestors", rootBoundary: l = "viewport", elementContext: u = "floating", altBoundary: d = !1, padding: f = 0 } = lc(t, e), p = xc(f), m = o[d ? u === "floating" ? "reference" : "floating" : u], h = Sc(await i.getClippingRect({
		element: await (i.isElement == null ? void 0 : i.isElement(m)) ?? !0 ? m : m.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(o.floating)),
		boundary: c,
		rootBoundary: l,
		strategy: s
	})), g = u === "floating" ? {
		x: n,
		y: r,
		width: a.floating.width,
		height: a.floating.height
	} : a.reference, _ = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(o.floating)), v = await (i.isElement == null ? void 0 : i.isElement(_)) && await (i.getScale == null ? void 0 : i.getScale(_)) || {
		x: 1,
		y: 1
	}, y = Sc(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
		elements: o,
		rect: g,
		offsetParent: _,
		strategy: s
	}) : g);
	return {
		top: (h.top - y.top + p.top) / v.y,
		bottom: (y.bottom - h.bottom + p.bottom) / v.y,
		left: (h.left - y.left + p.left) / v.x,
		right: (y.right - h.right + p.right) / v.x
	};
}
var Ec = (e) => ({
	name: "arrow",
	options: e,
	async fn(t) {
		let { x: n, y: r, placement: i, rects: a, platform: o, elements: s, middlewareData: c } = t, { element: l, padding: u = 0 } = lc(e, t) || {};
		if (l == null) return {};
		let d = xc(u), f = {
			x: n,
			y: r
		}, p = gc(i), m = pc(p), h = await o.getDimensions(l), g = p === "y", _ = g ? "top" : "left", v = g ? "bottom" : "right", y = g ? "clientHeight" : "clientWidth", b = a.reference[m] + a.reference[p] - f[p] - a.floating[m], x = f[p] - a.reference[p], S = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(l)), C = S ? S[y] : 0;
		(!C || !await (o.isElement == null ? void 0 : o.isElement(S))) && (C = s.floating[y] || a.floating[m]);
		let w = b / 2 - x / 2, T = C / 2 - h[m] / 2 - 1, E = nc(d[_], T), D = nc(d[v], T), O = E, k = C - h[m] - D, A = C / 2 - h[m] / 2 + w, j = cc(O, A, k), M = !c.arrow && dc(i) != null && A !== j && a.reference[m] / 2 - (A < O ? E : D) - h[m] / 2 < 0, N = M ? A < O ? A - O : A - k : 0;
		return {
			[p]: f[p] + N,
			data: {
				[p]: j,
				centerOffset: A - j - N,
				...M && { alignmentOffset: N }
			},
			reset: M
		};
	}
});
function Dc(e, t, n) {
	return (e ? [...n.filter((t) => dc(t) === e), ...n.filter((t) => dc(t) !== e)] : n.filter((e) => uc(e) === e)).filter((n) => e ? dc(n) === e || (t ? vc(n) !== n : !1) : !0);
}
var Oc = function(e) {
	return e === void 0 && (e = {}), {
		name: "autoPlacement",
		options: e,
		async fn(t) {
			let { rects: n, middlewareData: r, placement: i, platform: a, elements: o } = t, { crossAxis: s = !1, alignment: c, allowedPlacements: l = tc, autoAlignment: u = !0, ...d } = lc(e, t), f = c !== void 0 || l === tc ? Dc(c || null, u, l) : l, p = await Tc(t, d), m = r.autoPlacement?.index || 0, h = f[m];
			if (h == null) return {};
			let g = _c(h, n, await (a.isRTL == null ? void 0 : a.isRTL(o.floating)));
			if (i !== h) return { reset: { placement: f[0] } };
			let _ = [
				p[uc(h)],
				p[g[0]],
				p[g[1]]
			], v = [...r.autoPlacement?.overflows || [], {
				placement: h,
				overflows: _
			}], y = f[m + 1];
			if (y) return {
				data: {
					index: m + 1,
					overflows: v
				},
				reset: { placement: y }
			};
			let b = v.map((e) => {
				let t = dc(e.placement);
				return [
					e.placement,
					t && s ? e.overflows.slice(0, 2).reduce((e, t) => e + t, 0) : e.overflows[0],
					e.overflows
				];
			}).sort((e, t) => e[1] - t[1]), x = b.filter((e) => e[2].slice(0, dc(e[0]) ? 2 : 3).every((e) => e <= 0))[0]?.[0] || b[0][0];
			return x === i ? {} : {
				data: {
					index: m + 1,
					overflows: v
				},
				reset: { placement: x }
			};
		}
	};
};
function kc(e, t) {
	return {
		top: e.top - t.height,
		right: e.right - t.width,
		bottom: e.bottom - t.height,
		left: e.left - t.width
	};
}
function Ac(e) {
	return $s.some((t) => e[t] >= 0);
}
var jc = function(e) {
	return e === void 0 && (e = {}), {
		name: "hide",
		options: e,
		async fn(t) {
			let { rects: n } = t, { strategy: r = "referenceHidden", ...i } = lc(e, t);
			switch (r) {
				case "referenceHidden": {
					let e = kc(await Tc(t, {
						...i,
						elementContext: "reference"
					}), n.reference);
					return { data: {
						referenceHiddenOffsets: e,
						referenceHidden: Ac(e)
					} };
				}
				case "escaped": {
					let e = kc(await Tc(t, {
						...i,
						altBoundary: !0
					}), n.floating);
					return { data: {
						escapedOffsets: e,
						escaped: Ac(e)
					} };
				}
				default: return {};
			}
		}
	};
}, Mc = /* @__PURE__ */ new Set(["left", "top"]);
async function Nc(e, t) {
	let { placement: n, platform: r, elements: i } = e, a = await (r.isRTL == null ? void 0 : r.isRTL(i.floating)), o = uc(n), s = dc(n), c = hc(n) === "y", l = Mc.has(o) ? -1 : 1, u = a && c ? -1 : 1, d = lc(t, e), { mainAxis: f, crossAxis: p, alignmentAxis: m } = typeof d == "number" ? {
		mainAxis: d,
		crossAxis: 0,
		alignmentAxis: null
	} : {
		mainAxis: d.mainAxis || 0,
		crossAxis: d.crossAxis || 0,
		alignmentAxis: d.alignmentAxis
	};
	return s && typeof m == "number" && (p = s === "end" ? m * -1 : m), c ? {
		x: p * u,
		y: f * l
	} : {
		x: f * l,
		y: p * u
	};
}
var Pc = function(e) {
	return e === void 0 && (e = 0), {
		name: "offset",
		options: e,
		async fn(t) {
			var n;
			let { x: r, y: i, placement: a, middlewareData: o } = t, s = await Nc(t, e);
			return a === o.offset?.placement && (n = o.arrow) != null && n.alignmentOffset ? {} : {
				x: r + s.x,
				y: i + s.y,
				data: {
					...s,
					placement: a
				}
			};
		}
	};
}, Fc = function(e) {
	return e === void 0 && (e = {}), {
		name: "shift",
		options: e,
		async fn(t) {
			let { x: n, y: r, placement: i } = t, { mainAxis: a = !0, crossAxis: o = !1, limiter: s = { fn: (e) => {
				let { x: t, y: n } = e;
				return {
					x: t,
					y: n
				};
			} }, ...c } = lc(e, t), l = {
				x: n,
				y: r
			}, u = await Tc(t, c), d = hc(uc(i)), f = fc(d), p = l[f], m = l[d];
			if (a) {
				let e = f === "y" ? "top" : "left", t = f === "y" ? "bottom" : "right", n = p + u[e], r = p - u[t];
				p = cc(n, p, r);
			}
			if (o) {
				let e = d === "y" ? "top" : "left", t = d === "y" ? "bottom" : "right", n = m + u[e], r = m - u[t];
				m = cc(n, m, r);
			}
			let h = s.fn({
				...t,
				[f]: p,
				[d]: m
			});
			return {
				...h,
				data: {
					x: h.x - n,
					y: h.y - r,
					enabled: {
						[f]: a,
						[d]: o
					}
				}
			};
		}
	};
};
//#endregion
//#region ../../node_modules/@floating-ui/utils/dist/floating-ui.utils.dom.mjs
function Ic() {
	return typeof window < "u";
}
function Lc(e) {
	return zc(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function $(e) {
	var t;
	return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Rc(e) {
	return ((zc(e) ? e.ownerDocument : e.document) || window.document)?.documentElement;
}
function zc(e) {
	return Ic() ? e instanceof Node || e instanceof $(e).Node : !1;
}
function Bc(e) {
	return Ic() ? e instanceof Element || e instanceof $(e).Element : !1;
}
function Vc(e) {
	return Ic() ? e instanceof HTMLElement || e instanceof $(e).HTMLElement : !1;
}
function Hc(e) {
	return !Ic() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof $(e).ShadowRoot;
}
var Uc = /* @__PURE__ */ new Set(["inline", "contents"]);
function Wc(e) {
	let { overflow: t, overflowX: n, overflowY: r, display: i } = rl(e);
	return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !Uc.has(i);
}
var Gc = /* @__PURE__ */ new Set([
	"table",
	"td",
	"th"
]);
function Kc(e) {
	return Gc.has(Lc(e));
}
var qc = [":popover-open", ":modal"];
function Jc(e) {
	return qc.some((t) => {
		try {
			return e.matches(t);
		} catch {
			return !1;
		}
	});
}
var Yc = [
	"transform",
	"translate",
	"scale",
	"rotate",
	"perspective"
], Xc = [
	"transform",
	"translate",
	"scale",
	"rotate",
	"perspective",
	"filter"
], Zc = [
	"paint",
	"layout",
	"strict",
	"content"
];
function Qc(e) {
	let t = el(), n = Bc(e) ? rl(e) : e;
	return Yc.some((e) => n[e] ? n[e] !== "none" : !1) || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || Xc.some((e) => (n.willChange || "").includes(e)) || Zc.some((e) => (n.contain || "").includes(e));
}
function $c(e) {
	let t = al(e);
	for (; Vc(t) && !nl(t);) {
		if (Qc(t)) return t;
		if (Jc(t)) return null;
		t = al(t);
	}
	return null;
}
function el() {
	return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
var tl = /* @__PURE__ */ new Set([
	"html",
	"body",
	"#document"
]);
function nl(e) {
	return tl.has(Lc(e));
}
function rl(e) {
	return $(e).getComputedStyle(e);
}
function il(e) {
	return Bc(e) ? {
		scrollLeft: e.scrollLeft,
		scrollTop: e.scrollTop
	} : {
		scrollLeft: e.scrollX,
		scrollTop: e.scrollY
	};
}
function al(e) {
	if (Lc(e) === "html") return e;
	let t = e.assignedSlot || e.parentNode || Hc(e) && e.host || Rc(e);
	return Hc(t) ? t.host : t;
}
function ol(e) {
	let t = al(e);
	return nl(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : Vc(t) && Wc(t) ? t : ol(t);
}
function sl(e, t, n) {
	t === void 0 && (t = []), n === void 0 && (n = !0);
	let r = ol(e), i = r === e.ownerDocument?.body, a = $(r);
	if (i) {
		let e = cl(a);
		return t.concat(a, a.visualViewport || [], Wc(r) ? r : [], e && n ? sl(e) : []);
	}
	return t.concat(r, sl(r, [], n));
}
function cl(e) {
	return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
//#endregion
//#region node_modules/@floating-ui/dom/dist/floating-ui.dom.mjs
function ll(e) {
	let t = rl(e), n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0, i = Vc(e), a = i ? e.offsetWidth : n, o = i ? e.offsetHeight : r, s = ic(n) !== a || ic(r) !== o;
	return s && (n = a, r = o), {
		width: n,
		height: r,
		$: s
	};
}
function ul(e) {
	return Bc(e) ? e : e.contextElement;
}
function dl(e) {
	let t = ul(e);
	if (!Vc(t)) return ac(1);
	let n = t.getBoundingClientRect(), { width: r, height: i, $: a } = ll(t), o = (a ? ic(n.width) : n.width) / r, s = (a ? ic(n.height) : n.height) / i;
	return (!o || !Number.isFinite(o)) && (o = 1), (!s || !Number.isFinite(s)) && (s = 1), {
		x: o,
		y: s
	};
}
var fl = /* @__PURE__ */ ac(0);
function pl(e) {
	let t = $(e);
	return !el() || !t.visualViewport ? fl : {
		x: t.visualViewport.offsetLeft,
		y: t.visualViewport.offsetTop
	};
}
function ml(e, t, n) {
	return t === void 0 && (t = !1), !n || t && n !== $(e) ? !1 : t;
}
function hl(e, t, n, r) {
	t === void 0 && (t = !1), n === void 0 && (n = !1);
	let i = e.getBoundingClientRect(), a = ul(e), o = ac(1);
	t && (r ? Bc(r) && (o = dl(r)) : o = dl(e));
	let s = ml(a, n, r) ? pl(a) : ac(0), c = (i.left + s.x) / o.x, l = (i.top + s.y) / o.y, u = i.width / o.x, d = i.height / o.y;
	if (a) {
		let e = $(a), t = r && Bc(r) ? $(r) : r, n = e, i = cl(n);
		for (; i && r && t !== n;) {
			let e = dl(i), t = i.getBoundingClientRect(), r = rl(i), a = t.left + (i.clientLeft + parseFloat(r.paddingLeft)) * e.x, o = t.top + (i.clientTop + parseFloat(r.paddingTop)) * e.y;
			c *= e.x, l *= e.y, u *= e.x, d *= e.y, c += a, l += o, n = $(i), i = cl(n);
		}
	}
	return Sc({
		width: u,
		height: d,
		x: c,
		y: l
	});
}
function gl(e, t) {
	let n = il(e).scrollLeft;
	return t ? t.left + n : hl(Rc(e)).left + n;
}
function _l(e, t) {
	let n = e.getBoundingClientRect();
	return {
		x: n.left + t.scrollLeft - gl(e, n),
		y: n.top + t.scrollTop
	};
}
function vl(e) {
	let { elements: t, rect: n, offsetParent: r, strategy: i } = e, a = i === "fixed", o = Rc(r), s = t ? Jc(t.floating) : !1;
	if (r === o || s && a) return n;
	let c = {
		scrollLeft: 0,
		scrollTop: 0
	}, l = ac(1), u = ac(0), d = Vc(r);
	if ((d || !d && !a) && ((Lc(r) !== "body" || Wc(o)) && (c = il(r)), Vc(r))) {
		let e = hl(r);
		l = dl(r), u.x = e.x + r.clientLeft, u.y = e.y + r.clientTop;
	}
	let f = o && !d && !a ? _l(o, c) : ac(0);
	return {
		width: n.width * l.x,
		height: n.height * l.y,
		x: n.x * l.x - c.scrollLeft * l.x + u.x + f.x,
		y: n.y * l.y - c.scrollTop * l.y + u.y + f.y
	};
}
function yl(e) {
	return Array.from(e.getClientRects());
}
function bl(e) {
	let t = Rc(e), n = il(e), r = e.ownerDocument.body, i = rc(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), a = rc(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight), o = -n.scrollLeft + gl(e), s = -n.scrollTop;
	return rl(r).direction === "rtl" && (o += rc(t.clientWidth, r.clientWidth) - i), {
		width: i,
		height: a,
		x: o,
		y: s
	};
}
var xl = 25;
function Sl(e, t) {
	let n = $(e), r = Rc(e), i = n.visualViewport, a = r.clientWidth, o = r.clientHeight, s = 0, c = 0;
	if (i) {
		a = i.width, o = i.height;
		let e = el();
		(!e || e && t === "fixed") && (s = i.offsetLeft, c = i.offsetTop);
	}
	let l = gl(r);
	if (l <= 0) {
		let e = r.ownerDocument, t = e.body, n = getComputedStyle(t), i = e.compatMode === "CSS1Compat" && parseFloat(n.marginLeft) + parseFloat(n.marginRight) || 0, o = Math.abs(r.clientWidth - t.clientWidth - i);
		o <= xl && (a -= o);
	} else l <= xl && (a += l);
	return {
		width: a,
		height: o,
		x: s,
		y: c
	};
}
var Cl = /* @__PURE__ */ new Set(["absolute", "fixed"]);
function wl(e, t) {
	let n = hl(e, !0, t === "fixed"), r = n.top + e.clientTop, i = n.left + e.clientLeft, a = Vc(e) ? dl(e) : ac(1);
	return {
		width: e.clientWidth * a.x,
		height: e.clientHeight * a.y,
		x: i * a.x,
		y: r * a.y
	};
}
function Tl(e, t, n) {
	let r;
	if (t === "viewport") r = Sl(e, n);
	else if (t === "document") r = bl(Rc(e));
	else if (Bc(t)) r = wl(t, n);
	else {
		let n = pl(e);
		r = {
			x: t.x - n.x,
			y: t.y - n.y,
			width: t.width,
			height: t.height
		};
	}
	return Sc(r);
}
function El(e, t) {
	let n = al(e);
	return n === t || !Bc(n) || nl(n) ? !1 : rl(n).position === "fixed" || El(n, t);
}
function Dl(e, t) {
	let n = t.get(e);
	if (n) return n;
	let r = sl(e, [], !1).filter((e) => Bc(e) && Lc(e) !== "body"), i = null, a = rl(e).position === "fixed", o = a ? al(e) : e;
	for (; Bc(o) && !nl(o);) {
		let t = rl(o), n = Qc(o);
		!n && t.position === "fixed" && (i = null), (a ? !n && !i : !n && t.position === "static" && i && Cl.has(i.position) || Wc(o) && !n && El(e, o)) ? r = r.filter((e) => e !== o) : i = t, o = al(o);
	}
	return t.set(e, r), r;
}
function Ol(e) {
	let { element: t, boundary: n, rootBoundary: r, strategy: i } = e, a = [...n === "clippingAncestors" ? Jc(t) ? [] : Dl(t, this._c) : [].concat(n), r], o = a[0], s = a.reduce((e, n) => {
		let r = Tl(t, n, i);
		return e.top = rc(r.top, e.top), e.right = nc(r.right, e.right), e.bottom = nc(r.bottom, e.bottom), e.left = rc(r.left, e.left), e;
	}, Tl(t, o, i));
	return {
		width: s.right - s.left,
		height: s.bottom - s.top,
		x: s.left,
		y: s.top
	};
}
function kl(e) {
	let { width: t, height: n } = ll(e);
	return {
		width: t,
		height: n
	};
}
function Al(e, t, n) {
	let r = Vc(t), i = Rc(t), a = n === "fixed", o = hl(e, !0, a, t), s = {
		scrollLeft: 0,
		scrollTop: 0
	}, c = ac(0);
	function l() {
		c.x = gl(i);
	}
	if (r || !r && !a) if ((Lc(t) !== "body" || Wc(i)) && (s = il(t)), r) {
		let e = hl(t, !0, a, t);
		c.x = e.x + t.clientLeft, c.y = e.y + t.clientTop;
	} else i && l();
	a && !r && i && l();
	let u = i && !r && !a ? _l(i, s) : ac(0);
	return {
		x: o.left + s.scrollLeft - c.x - u.x,
		y: o.top + s.scrollTop - c.y - u.y,
		width: o.width,
		height: o.height
	};
}
function jl(e) {
	return rl(e).position === "static";
}
function Ml(e, t) {
	if (!Vc(e) || rl(e).position === "fixed") return null;
	if (t) return t(e);
	let n = e.offsetParent;
	return Rc(e) === n && (n = n.ownerDocument.body), n;
}
function Nl(e, t) {
	let n = $(e);
	if (Jc(e)) return n;
	if (!Vc(e)) {
		let t = al(e);
		for (; t && !nl(t);) {
			if (Bc(t) && !jl(t)) return t;
			t = al(t);
		}
		return n;
	}
	let r = Ml(e, t);
	for (; r && Kc(r) && jl(r);) r = Ml(r, t);
	return r && nl(r) && jl(r) && !Qc(r) ? n : r || $c(e) || n;
}
var Pl = async function(e) {
	let t = this.getOffsetParent || Nl, n = this.getDimensions, r = await n(e.floating);
	return {
		reference: Al(e.reference, await t(e.floating), e.strategy),
		floating: {
			x: 0,
			y: 0,
			width: r.width,
			height: r.height
		}
	};
};
function Fl(e) {
	return rl(e).direction === "rtl";
}
var Il = {
	convertOffsetParentRelativeRectToViewportRelativeRect: vl,
	getDocumentElement: Rc,
	getClippingRect: Ol,
	getOffsetParent: Nl,
	getElementRects: Pl,
	getClientRects: yl,
	getDimensions: kl,
	getScale: dl,
	isElement: Bc,
	isRTL: Fl
}, Ll = Pc, Rl = Oc, zl = Fc, Bl = jc, Vl = Ec, Hl = (e, t, n) => {
	let r = /* @__PURE__ */ new Map(), i = {
		platform: Il,
		...n
	}, a = {
		...i.platform,
		_c: r
	};
	return wc(e, t, {
		...i,
		platform: a
	});
}, Ul = /* @__PURE__ */ s(((e, t) => {
	var n = "Expected a function", r = NaN, i = "[object Symbol]", a = /^\s+|\s+$/g, o = /^[-+]0x[0-9a-f]+$/i, s = /^0b[01]+$/i, c = /^0o[0-7]+$/i, l = parseInt, u = typeof global == "object" && global && global.Object === Object && global, d = typeof self == "object" && self && self.Object === Object && self, f = u || d || Function("return this")(), p = Object.prototype.toString, m = Math.max, h = Math.min, g = function() {
		return f.Date.now();
	};
	function _(e, t, r) {
		var i, a, o, s, c, l, u = 0, d = !1, f = !1, p = !0;
		if (typeof e != "function") throw TypeError(n);
		t = x(t) || 0, v(r) && (d = !!r.leading, f = "maxWait" in r, o = f ? m(x(r.maxWait) || 0, t) : o, p = "trailing" in r ? !!r.trailing : p);
		function _(t) {
			var n = i, r = a;
			return i = a = void 0, u = t, s = e.apply(r, n), s;
		}
		function y(e) {
			return u = e, c = setTimeout(C, t), d ? _(e) : s;
		}
		function b(e) {
			var n = e - l, r = e - u, i = t - n;
			return f ? h(i, o - r) : i;
		}
		function S(e) {
			var n = e - l, r = e - u;
			return l === void 0 || n >= t || n < 0 || f && r >= o;
		}
		function C() {
			var e = g();
			if (S(e)) return w(e);
			c = setTimeout(C, b(e));
		}
		function w(e) {
			return c = void 0, p && i ? _(e) : (i = a = void 0, s);
		}
		function T() {
			c !== void 0 && clearTimeout(c), u = 0, i = l = a = c = void 0;
		}
		function E() {
			return c === void 0 ? s : w(g());
		}
		function D() {
			var e = g(), n = S(e);
			if (i = arguments, a = this, l = e, n) {
				if (c === void 0) return y(l);
				if (f) return c = setTimeout(C, t), _(l);
			}
			return c === void 0 && (c = setTimeout(C, t)), s;
		}
		return D.cancel = T, D.flush = E, D;
	}
	function v(e) {
		var t = typeof e;
		return !!e && (t == "object" || t == "function");
	}
	function y(e) {
		return !!e && typeof e == "object";
	}
	function b(e) {
		return typeof e == "symbol" || y(e) && p.call(e) == i;
	}
	function x(e) {
		if (typeof e == "number") return e;
		if (b(e)) return r;
		if (v(e)) {
			var t = typeof e.valueOf == "function" ? e.valueOf() : e;
			e = v(t) ? t + "" : t;
		}
		if (typeof e != "string") return e === 0 ? e : +e;
		e = e.replace(a, "");
		var n = s.test(e);
		return n || c.test(e) ? l(e.slice(2), n ? 2 : 8) : o.test(e) ? r : +e;
	}
	t.exports = _;
})), Wl = /* @__PURE__ */ s(((e, t) => {
	var n = 200, r = "__lodash_hash_undefined__", i = Infinity, a = "[object Function]", o = "[object GeneratorFunction]", s = /[\\^$.*+?()[\]{}|]/g, c = /^\[object .+?Constructor\]$/, l = typeof global == "object" && global && global.Object === Object && global, u = typeof self == "object" && self && self.Object === Object && self, d = l || u || Function("return this")();
	function f(e, t) {
		return !!(e && e.length) && h(e, t, 0) > -1;
	}
	function p(e, t, n) {
		for (var r = -1, i = e ? e.length : 0; ++r < i;) if (n(t, e[r])) return !0;
		return !1;
	}
	function m(e, t, n, r) {
		for (var i = e.length, a = n + (r ? 1 : -1); r ? a-- : ++a < i;) if (t(e[a], a, e)) return a;
		return -1;
	}
	function h(e, t, n) {
		if (t !== t) return m(e, g, n);
		for (var r = n - 1, i = e.length; ++r < i;) if (e[r] === t) return r;
		return -1;
	}
	function g(e) {
		return e !== e;
	}
	function _(e, t) {
		return e.has(t);
	}
	function v(e, t) {
		return e?.[t];
	}
	function y(e) {
		var t = !1;
		if (e != null && typeof e.toString != "function") try {
			t = !!(e + "");
		} catch {}
		return t;
	}
	function b(e) {
		var t = -1, n = Array(e.size);
		return e.forEach(function(e) {
			n[++t] = e;
		}), n;
	}
	var x = Array.prototype, S = Function.prototype, C = Object.prototype, w = d["__core-js_shared__"], T = function() {
		var e = /[^.]+$/.exec(w && w.keys && w.keys.IE_PROTO || "");
		return e ? "Symbol(src)_1." + e : "";
	}(), E = S.toString, D = C.hasOwnProperty, O = C.toString, k = RegExp("^" + E.call(D).replace(s, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), A = x.splice, j = _e(d, "Map"), M = _e(d, "Set"), N = _e(Object, "create");
	function P(e) {
		var t = -1, n = e ? e.length : 0;
		for (this.clear(); ++t < n;) {
			var r = e[t];
			this.set(r[0], r[1]);
		}
	}
	function ee() {
		this.__data__ = N ? N(null) : {};
	}
	function F(e) {
		return this.has(e) && delete this.__data__[e];
	}
	function te(e) {
		var t = this.__data__;
		if (N) {
			var n = t[e];
			return n === r ? void 0 : n;
		}
		return D.call(t, e) ? t[e] : void 0;
	}
	function I(e) {
		var t = this.__data__;
		return N ? t[e] !== void 0 : D.call(t, e);
	}
	function L(e, t) {
		var n = this.__data__;
		return n[e] = N && t === void 0 ? r : t, this;
	}
	P.prototype.clear = ee, P.prototype.delete = F, P.prototype.get = te, P.prototype.has = I, P.prototype.set = L;
	function R(e) {
		var t = -1, n = e ? e.length : 0;
		for (this.clear(); ++t < n;) {
			var r = e[t];
			this.set(r[0], r[1]);
		}
	}
	function z() {
		this.__data__ = [];
	}
	function ne(e) {
		var t = this.__data__, n = fe(t, e);
		return n < 0 ? !1 : (n == t.length - 1 ? t.pop() : A.call(t, n, 1), !0);
	}
	function re(e) {
		var t = this.__data__, n = fe(t, e);
		return n < 0 ? void 0 : t[n][1];
	}
	function B(e) {
		return fe(this.__data__, e) > -1;
	}
	function ie(e, t) {
		var n = this.__data__, r = fe(n, e);
		return r < 0 ? n.push([e, t]) : n[r][1] = t, this;
	}
	R.prototype.clear = z, R.prototype.delete = ne, R.prototype.get = re, R.prototype.has = B, R.prototype.set = ie;
	function V(e) {
		var t = -1, n = e ? e.length : 0;
		for (this.clear(); ++t < n;) {
			var r = e[t];
			this.set(r[0], r[1]);
		}
	}
	function ae() {
		this.__data__ = {
			hash: new P(),
			map: new (j || R)(),
			string: new P()
		};
	}
	function H(e) {
		return ge(this, e).delete(e);
	}
	function oe(e) {
		return ge(this, e).get(e);
	}
	function se(e) {
		return ge(this, e).has(e);
	}
	function ce(e, t) {
		return ge(this, e).set(e, t), this;
	}
	V.prototype.clear = ae, V.prototype.delete = H, V.prototype.get = oe, V.prototype.has = se, V.prototype.set = ce;
	function le(e) {
		var t = -1, n = e ? e.length : 0;
		for (this.__data__ = new V(); ++t < n;) this.add(e[t]);
	}
	function ue(e) {
		return this.__data__.set(e, r), this;
	}
	function de(e) {
		return this.__data__.has(e);
	}
	le.prototype.add = le.prototype.push = ue, le.prototype.has = de;
	function fe(e, t) {
		for (var n = e.length; n--;) if (Se(e[n][0], t)) return n;
		return -1;
	}
	function pe(e) {
		return !Ce(e) || ye(e) ? !1 : (U(e) || y(e) ? k : c).test(be(e));
	}
	function me(e, t, r) {
		var i = -1, a = f, o = e.length, s = !0, c = [], l = c;
		if (r) s = !1, a = p;
		else if (o >= n) {
			var u = t ? null : he(e);
			if (u) return b(u);
			s = !1, a = _, l = new le();
		} else l = t ? [] : c;
		outer: for (; ++i < o;) {
			var d = e[i], m = t ? t(d) : d;
			if (d = r || d !== 0 ? d : 0, s && m === m) {
				for (var h = l.length; h--;) if (l[h] === m) continue outer;
				t && l.push(m), c.push(d);
			} else a(l, m, r) || (l !== c && l.push(m), c.push(d));
		}
		return c;
	}
	var he = M && 1 / b(new M([, -0]))[1] == i ? function(e) {
		return new M(e);
	} : we;
	function ge(e, t) {
		var n = e.__data__;
		return ve(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
	}
	function _e(e, t) {
		var n = v(e, t);
		return pe(n) ? n : void 0;
	}
	function ve(e) {
		var t = typeof e;
		return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
	}
	function ye(e) {
		return !!T && T in e;
	}
	function be(e) {
		if (e != null) {
			try {
				return E.call(e);
			} catch {}
			try {
				return e + "";
			} catch {}
		}
		return "";
	}
	function xe(e) {
		return e && e.length ? me(e) : [];
	}
	function Se(e, t) {
		return e === t || e !== e && t !== t;
	}
	function U(e) {
		var t = Ce(e) ? O.call(e) : "";
		return t == a || t == o;
	}
	function Ce(e) {
		var t = typeof e;
		return !!e && (t == "object" || t == "function");
	}
	function we() {}
	t.exports = xe;
})), Gl = /* @__PURE__ */ u(Ul(), 1), Kl = /* @__PURE__ */ u(Wl(), 1), ql = (e, t, n, r, i, a) => {
	let o = `-${15 / 2}px`, s = e.split("-")[0], { staticSide: c, rotation: l, shadowOpacity: u } = {
		top: {
			staticSide: "bottom",
			rotation: 45,
			shadowOpacity: 40
		},
		bottom: {
			staticSide: "top",
			rotation: 225,
			shadowOpacity: 7
		},
		right: {
			staticSide: "left",
			rotation: 135,
			shadowOpacity: 7
		},
		left: {
			staticSide: "right",
			rotation: -45,
			shadowOpacity: 40
		}
	}[s], d = s === "top" || s === "bottom", f = 15 / 2, p = t != null && d && r > 0 ? Number.parseFloat(((t + f) / r * 100).toFixed(4)) : null, m = n != null && !d && i > 0 ? Number.parseFloat(((n + f) / i * 100).toFixed(4)) : null, h = p == null ? "" : `calc(${p}% - ${f}px)`, g = m == null ? "" : `calc(${m}% - ${f}px)`;
	return {
		boxShadow: `1px 1px 1px hsl(0deg 0% 13% / ${u}%)`,
		transform: `rotate(${l}deg)`,
		clipPath: "polygon(0% 100%, 100% 100%, 100% 0%)",
		left: h,
		top: g,
		right: "",
		bottom: "",
		[c]: o,
		zIndex: a
	};
}, Jl = (e, t) => {
	let n = e.slice(1);
	return t.find(({ config: e, type: t }) => t === "@appcues/overlay" && n === e.rootId);
}, Yl = (e, t) => {
	let n = 17.5;
	return t.includes("start") ? e - n : e + n;
}, Xl = ({ placementUnit: e, distance: t, skidding: n, placement: r, targetEl: i }) => {
	let a = r.startsWith("left") || r.startsWith("right"), o = a ? t : n, s = a ? n : t;
	if (e !== "percentage" || !i) return {
		mainAxis: t,
		crossAxis: n
	};
	let { width: c, height: l } = i.getBoundingClientRect();
	return {
		mainAxis: a ? c * o / 100 : l * s / 100,
		crossAxis: a ? l * s / 100 : c * o / 100
	};
}, Zl = (e, t) => {
	try {
		let n = t(), r = n.document, i = n.getComputedStyle(e), { overflow: a, overflowY: o, overflowX: s } = i, c = new Set([
			a,
			o,
			s
		]);
		if (i.position === "fixed" || i.position === "sticky" || c.has("auto") || c.has("hidden")) return !0;
		let { host: l = null } = e?.getRootNode() ?? {}, u = l?.tagName?.includes("APPCUES-EXPERIENCE-CONTAINER") || l?.tagName?.includes("APPCUES-EXPERIENCE-CONTAINER-BUILDER");
		return e.parentElement === null && l && !u ? Zl(l.parentElement, t) : e.parentElement !== null && e.parentElement !== r.body ? Zl(e.parentElement, t) : !1;
	} catch {
		return !1;
	}
};
function Ql(e) {
	return e === "fixed" || e === "relative" || e === "absolute" || e === "sticky";
}
function $l(e) {
	return e.display === "flex" || e.display === "inline-flex";
}
function eu(e, t, n, r, i) {
	let a = i, o = t.zIndex, s = t.position, c = e.parentElement, l = c ? r.getComputedStyle(c) : {};
	if (o !== "" && o !== "auto" && !Ql(s) && !$l(l) && (o = "auto"), (!a || o !== "" && o !== "auto" && (Ql(s) || $l(l))) && (a = o), c && c !== n.body && c !== n.documentElement) return eu(c, l, n, r, a);
	if (/^\d+$/.test(a)) {
		let e = Number.parseInt(a, 10);
		e += 1, a = e;
	}
	return a;
}
var tu = (e, t) => {
	let n = t(), r = n.document;
	return eu(e, n.getComputedStyle(e), r, n);
}, nu = ({ targetEl: e, rootStyle: t, shouldAutoCalculateZIndex: n, getWindowReference: r }) => {
	let i = t;
	if (n) {
		let n = tu(e, r);
		i = {
			...t,
			zIndex: n
		};
	}
	return i;
}, { addEventListener: ru, removeEventListener: iu } = (() => {
	let e = /* @__PURE__ */ new Map();
	function t(t) {
		t.composedPath().forEach((n) => {
			(e.get(n) ?? {})[t.type]?.map((e) => e(t));
		});
	}
	return {
		addEventListener: (n, r, i) => {
			e.get(n) || e.set(n, {});
			let a = e.get(n);
			a[r] || (a[r] = []), a[r].includes(i) || (a[r] = [...a[r], i], e.set(n, a)), a[r].length === 1 && n.addEventListener(r, t, !0);
		},
		removeEventListener: (n, r, i) => {
			let a = e.get(n);
			a && (a[r] = (a[r] ?? []).filter((e) => e !== i), e.set(n, a), a[r].length === 0 && n.removeEventListener(r, t, !0));
		}
	};
})(), au = (() => {
	let e = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Map(), n = (n) => {
		if (t.has(n)) return;
		let r = setInterval(() => {
			e.get(n).forEach((e) => e());
		}, n);
		t.set(n, r);
	}, r = (n, r) => {
		let i = e.get(r);
		if (i) {
			let a = i.filter((e) => e !== n);
			if (a.length > 0) {
				e.set(r, a);
				return;
			}
			let o = t.get(r);
			clearInterval(o), e.delete(r), t.delete(r);
		}
	};
	return (t, i) => {
		let a = e.get(i) ?? [];
		return e.set(i, [...a, t]), n(i), () => r(t, i);
	};
})(), ou = (e, t) => {
	if (!t) return e;
	let { order: n, text: r } = t, i = [...e];
	return r && r !== "" && (i = i.filter((e) => e.textContent.replace(/\r\n|\r|\n/g, " ").toLowerCase().trim() === r.toString().toLowerCase().trim())), n == null ? i : i.length > n ? [i[n]] : [];
}, su = (e) => e.includes(Sr), cu = (e, t) => e != null && e.ownerDocument !== t.document, lu = (e, t) => ({ getBoundingClientRect() {
	let n = 0, r = 0, i = e.ownerDocument?.defaultView, a = 0;
	for (; i && i !== t && a < 20;) {
		a += 1;
		try {
			let e = i.frameElement;
			if (!e) break;
			let t = e.getBoundingClientRect(), a = e.ownerDocument.defaultView.getComputedStyle(e);
			n += t.left + e.clientLeft + Number.parseFloat(a.paddingLeft || "0"), r += t.top + e.clientTop + Number.parseFloat(a.paddingTop || "0");
			let o = i.parent;
			if (o === i) break;
			i = o;
		} catch {
			break;
		}
	}
	let o = e.getBoundingClientRect(), s = n + o.left, c = r + o.top;
	return {
		x: s,
		y: c,
		left: s,
		top: c,
		right: s + o.width,
		bottom: c + o.height,
		width: o.width,
		height: o.height,
		toJSON() {
			return this;
		}
	};
} }), uu = "@appcues/overlay", du = 500, fu = "top 200ms, left 200ms, right 200ms, bottom 200ms", pu = {
	top: "top",
	"top-left": "top-start",
	"top-right": "top-end",
	right: "right",
	"right-top": "right-start",
	"right-bottom": "right-end",
	bottom: "bottom",
	"bottom-right": "bottom-end",
	"bottom-left": "bottom-start",
	left: "left",
	"left-bottom": "left-end",
	"left-top": "left-start",
	center: "top-start"
}, mu = (e, t) => {
	let n, r, i, a = [], o, s = () => {}, c, l = !1;
	function u() {
		if (t()?.__appcuesIsResizing) {
			l = !0;
			return;
		}
		l = !1, e();
	}
	let d = (0, Gl.default)(u, 100);
	function f(t) {
		!t.detail?.isResizing && l && (l = !1, d.cancel(), e());
	}
	function p() {
		let e = n.getBoundingClientRect();
		c && (e.x !== c.x || e.y !== c.y || e.width !== c.width || e.height !== c.height) && d(), c = e;
	}
	return {
		setElements(e, t, o) {
			return n = e, r = t, i = o, a = [], this;
		},
		start() {
			i && (a = (0, Kl.default)([...sl(i)])), a.forEach((e) => {
				ru(e, "scroll", d), ru(e, "resize", d);
			}), o = new ResizeObserver(d), o.observe(r), c = n.getBoundingClientRect(), s = au(p, 200), t()?.addEventListener("isResizing", f);
		},
		remove() {
			a.forEach((e) => {
				iu(e, "scroll", d), iu(e, "resize", d);
			}), o?.unobserve(r), s(), t()?.removeEventListener("isResizing", f);
		}
	};
};
Z(uu, ({ addHook: e, registerAction: t }) => {
	let n, r, i, a = !1, o = null, s = !1, c, l, u, d, f, p, m, h, g = !1, _ = "absolute", v, y;
	e("step.begin", ({ onElementInserted: e, onElementRemoved: t, querySelector: b, reportError: x, step: S, updateStyle: C, getWindowReference: w, getTraitConfig: T, getContainer: E }) => {
		let { traits: D } = S.getConfig(), { arrowId: O = "arrow", target: k, rootId: A, placement: j = "auto", distance: M, skidding: N, placementUnit: P = "pixels", shouldAutoCalculateZIndex: ee = !0 } = T(), F = Jl(k.selector, D), te = D.find((e) => e.type === "@appcues/toggle")?.config?.startHidden ?? !0;
		te || C(A, { position: "absolute" }), f = () => {
			let e = S.querySelector(`#${A}`), t = S.querySelector(`#${O}`), n = ou(b(k.selector), k.filters);
			return {
				matchingElements: n,
				targetEl: n[0],
				rootEl: e[0],
				arrowEl: t[0]
			};
		};
		let I = async () => {
			let { targetEl: e, rootEl: t, arrowEl: n } = f();
			if (!a && e && t) {
				a = !0;
				let r = Date.now();
				o === null && (o = r);
				let i = r - o > du, s = Xl({
					placement: j,
					targetEl: e,
					distance: M,
					skidding: N,
					placementUnit: P
				}), c = [Ll(({ placement: e }) => ({
					...s,
					crossAxis: n && /start|end/gm.test(e) ? Yl(N, e) : s.crossAxis
				}))];
				j === "auto" && c.push(zl(), Rl({ crossAxis: !0 })), n && c.push(Vl({
					element: n,
					padding: 10
				}));
				let l = w(), u = cu(e, l), d = F != null && su(F.config.target.selector), f = u ? lu(e, l) : e;
				!u && !d && c.push(Bl());
				let { middlewareData: p, strategy: v, x: y, y: b, placement: x } = await Hl(f, t, {
					middleware: c,
					placement: pu[j] ?? "auto",
					strategy: _
				}), { referenceHidden: S } = p.hide ?? { referenceHidden: !1 };
				if (n) {
					let { x: e, y: n } = p.arrow, r = t.getBoundingClientRect();
					C(O, {
						...ql(x, e, n, r.width, r.height),
						transition: i ? fu : "none"
					});
				}
				t.dataset.placement = x;
				let T = nu({
					targetEl: e,
					rootStyle: {
						left: `${y}px`,
						position: v,
						top: `${b}px`
					},
					shouldAutoCalculateZIndex: ee,
					getWindowReference: w
				});
				e.style.visibility === "hidden" && (T.visibility = "hidden", h = e.style.visibility), S && t.style.visibility !== "hidden" && (m = t.style.visibility, g = !0, T.visibility = "hidden"), !S && g && (T.visibility = m ?? "visible", g = !1), !S && e.style.visibility !== "hidden" && e.style.visibility !== "" && h === "hidden" && (T.visibility = "visible"), j === "center" && (T.transform = "translate(-50%, 50%)"), T.transition = i ? fu : "none", C(A, T), Object.assign(t.style, T);
			}
		};
		v = () => {
			a = !1, I();
		}, p = mu(v, w);
		let L = () => ou(b(k.selector), k.filters), R = () => {
			if (!F) return L();
			let { selector: e, filters: t } = F.config.target;
			return ou(b(e), t);
		}, z = () => F ? F.config.target.selector : k.selector;
		r = () => {
			c &&= (c(), void 0), c = e({
				getTarget: R,
				onInserted: async () => {
					a = !1, s = !1, F && await new Promise((e) => {
						setTimeout(e, 0);
					}), await n() && (s = !0);
				}
			});
		}, i = () => {
			if (u &&= (u(), void 0), !d) return;
			let t = d, n = y, r = !1, i = [], o = () => {
				i.forEach((e) => e()), i = [];
			}, c = () => {
				r = !0, a = !1, s = !1, o(), u = void 0, S.recover({ errorId: n });
			}, l = () => {
				r || t().length !== 1 || c();
			};
			if (t().length === 1) {
				c();
				return;
			}
			i.push(e({
				getTarget: t,
				onInserted: l
			}));
			let f = () => l(), p = w().document;
			i.push(yr(p.body, f));
			let m = E?.();
			m && m !== p.body && i.push(yr(m, f)), u = o;
		}, n = async () => {
			c && c(), l && l(), u &&= (u(), void 0);
			let { matchingElements: e, rootEl: n } = f(), i = e.length === 1, o = e.length > 1, s = R(), h = s.length === 1, v = s.length > 1, b = () => {
				F || (l = t({
					getTarget: L,
					onRemoved: () => {
						a = !1, y = x(`Target got removed => ${k.selector}`), d = L, p.remove();
					}
				}));
			};
			if (i && !n) return y = x(`Could not find root element #${A} for overlay positioning.`), d = () => S.querySelector(`#${A}`), !1;
			if (o) return y = x(`Found ${e.length} elements for selector ${k.selector}.`), d = L, !1;
			if (v) return y = x(`Found ${s.length} elements for selector ${z()}.`), d = R, !1;
			if (!i || !h) {
				let e = z();
				return s.length === 0 && su(e) ? r() : (y = x(`Could not find element for selector ${e}.`), d = R), !1;
			}
			if (i) {
				let t = F ? s : null;
				if (te) {
					if (cu(e[0], w())) _ = "absolute";
					else {
						let n = t != null && t[0] != null ? Zl(t[0].parentElement, w) : !1;
						_ = Zl(e[0]?.parentElement, w) || n ? "fixed" : "absolute";
					}
					C(A, { position: _ });
				}
				return await I(), (cu(e[0], w()) || F != null && su(F.config.target.selector)) && !g && C(A, { visibility: m ?? "visible" }), b(), d = void 0, p.setElements(e[0], n, t ? t[0] : null).start(), !0;
			}
			return !1;
		};
	}), e("step.postrender", async () => {
		s || await n() && (s = !0);
	}), e("step.end", () => {
		c && c(), l && l(), u &&= (u(), void 0), p.remove(), a = !1, s = !1, o = null;
	}), e("step.error", () => {
		a = !1, s = !1, o = null, i && i();
	});
}), Z("@appcues/persistent", ({ addHook: e }) => {
	e("experience.begin", ({ steps: e }) => {
		e.map((e) => e.start());
	});
});
//#endregion
//#region src/traits/inline/inline.js
var hu = {
	left: "beforebegin",
	"inner-left": "afterbegin",
	right: "afterend",
	"inner-right": "beforeend"
}, gu = "@appcues/inline", _u = "appcues-hide", vu = `.${_u} { display: none !important; }`, yu = ({ distanceUnit: e, yOffset: t, xOffset: n, targetEl: r }) => {
	if (e !== "%" || !r) return {
		x: `${n}px`,
		y: `${t}px`
	};
	let { width: i, height: a } = r.getBoundingClientRect();
	return {
		x: `${i * n / 100}px`,
		y: `${a * t / 100}px`
	};
};
function bu({ addHook: e }) {
	let t, n, r, i = [], a = [], o = null, s = null, c = (e) => {
		if (o) return;
		let { document: t } = e();
		o = t.createElement("style"), o.textContent = vu, t.head.append(o);
	}, l = () => {
		i.forEach((e) => e.classList.remove(_u)), i = [], a.forEach((e) => {
			let t = e.firstChild;
			t && e.replaceWith(t);
		}), a = [], o &&= (o.remove(), null);
	};
	e("step.begin", ({ step: e, getTraitConfig: o, reportError: u, onElementRemoved: d, updateRootStyle: f, querySelector: p, getWindowReference: m }) => {
		let { target: h, placement: g = "right", verticalAlignment: _ = "bottom", allowOverlap: v = !1, xOffset: y = 0, yOffset: b = 0, distanceUnit: x = "px", sticky: S = !1, rootDisplay: C = "inline-block", clearContainer: w = !1 } = o();
		t && t(), n && n();
		let T = ou(p(h.selector), h.filters), E = T.length === 1, D = T.length > 1, O = T.length === 0, k = (t) => {
			let n = m().document.createElement("div");
			if (s &&= (s.remove(), null), l(), w && g.includes("inner")) if (w === "hide") {
				c(m);
				let { document: e } = m();
				Array.from(t.childNodes).forEach((t) => {
					if (t.nodeType === Node.ELEMENT_NODE) t.classList.add(_u), i.push(t);
					else if (t.nodeType === Node.TEXT_NODE && t.textContent.trim()) {
						let n = e.createElement("span");
						n.classList.add(_u), t.replaceWith(n), n.append(t), a.push(n);
					}
				});
			} else for (; t.firstChild;) t.firstChild.remove();
			if (t.insertAdjacentElement(hu[g], n) == null) {
				u(`can't insert inline container on the ${g}`);
				return;
			}
			s = n, e.setStepContainerTarget(n);
		}, A = () => ou(p(h.selector), h.filters), j = () => {
			n = d({
				getTarget: A,
				onRemoved: () => {
					r = u(`Target got removed => ${h.selector}`);
				}
			});
		};
		if (E) {
			k(T[0]);
			let e = {
				display: C,
				verticalAlign: _
			}, { x: t, y: n } = yu({
				distanceUnit: x,
				xOffset: y,
				yOffset: b,
				targetEl: T[0]
			});
			if (v) e.position = "absolute", e.transform = `translate(${t}, ${n})`;
			else {
				let r = g.includes("left") ? "right" : "left";
				e[`margin-${r}`] = t, e[`margin-${_}`] = n;
			}
			if (S) {
				e.position = "sticky";
				let t = g.includes("left") ? "top" : "bottom";
				e[t] = 0, e.zIndex = Jr;
			}
			f(e), j();
			return;
		}
		D && u(`Found ${T.length} elements for selector ${h.selector}.`), O && (r = u(`Could not find element for selector ${h.selector}.`));
	}), e("step.error", ({ step: e, getTraitConfig: n, onElementInserted: i, querySelector: a }) => {
		let { target: o } = n();
		t = i({
			getTarget: () => ou(a(o.selector), o.filters),
			onInserted: () => {
				e.recover({ errorId: r });
			}
		});
	}), e("step.end", () => {
		t && t(), n && n(), s &&= (s.remove(), null), l();
	});
}
Z(gu, bu);
//#endregion
//#region src/traits/toggle/helpers.js
var xu = (e, t, n) => {
	let { height: r, width: i, left: a, top: o } = e.getBoundingClientRect();
	return Math.floor(Math.hypot(t - (a + i / 2), n - (o + r / 2)) / 2);
}, Su = (e, t) => {
	let { height: n, width: r } = e.getBoundingClientRect(), i = Math.floor(Math.hypot(n, r) / 4);
	return Math.max(t, 0) + i;
}, Cu = (e) => e.key === "Escape", wu = (e, t) => ![...e.composedPath()].filter((e) => e.nodeType === Node.ELEMENT_NODE).some((e) => e?.contains?.(t) ?? !1), Tu = (e, t) => ({
	remove: () => {
		e.removeEventListener("keydown", t), e.removeEventListener("click", t, !0);
	},
	start: () => {
		e.addEventListener("click", t, !0), e.addEventListener("keydown", t);
	}
}), Eu = (e, t, n) => t.length === 0 ? (n("Element not found"), !1) : t.length > 1 ? (n(`More than one element found with id: ${e}`), !1) : !0, Du = "@appcues/toggle.style", Ou = ({ targetId: e, styles: t = {} }, { updateStyle: n }) => {
	n(e, t);
}, ku = { [Du]: Ou };
Z("@appcues/toggle", ({ addHook: e, registerAction: t }, { startHidden: n = !0, targetId: r, transition: i, closeOnClickOutside: a = !0, closeRadius: o }) => {
	let s, c, l, u = !1, d = [], f = null, p = [], m = () => {
		d.forEach((e) => e.remove()), d = [];
	};
	n && e("step.begin", ({ updateStyle: e, getWindowReference: t }) => {
		e(r, {
			opacity: "0",
			visibility: "hidden",
			"pointer-events": "none"
		}), p = [...t().document.querySelectorAll("iframe")];
	}), e("step.end", () => {
		a && m(), f?.remove(), f = null;
	}), e("step.error", () => {
		a && m(), f?.remove(), f = null;
	});
	let h = ({ on: e } = {}, t) => {
		let { reportError: n, step: c, updateStyle: l, getWindowReference: d } = t, f = d().document;
		if (!Eu(r, c.querySelector(`#${r}`), n)) return;
		a && m();
		let h = {};
		i || (h.visibility = "hidden", h["pointer-events"] = "none"), l(r, {
			...h,
			opacity: "0"
		}), i && setTimeout(() => {
			l(r, {
				visibility: "hidden",
				"pointer-events": "none"
			});
		}, i.duration * 1e3), o && u && (iu(f, "mousemove", s), p.forEach((e) => {
			e.contentDocument?.body && iu(e.contentDocument.body, "mousemove", s);
		}), u = !1), e?.close?.forEach((e) => ku[e.type](e.config, t));
	}, g = ({ on: e } = {}, t) => {
		let { reportError: n, step: m, updateStyle: g, getWindowReference: _ } = t, v = _().document, y = m.querySelector(`#${r}`);
		if (!Eu(r, y, n)) return;
		let b = {};
		if (i && (b.transition = `opacity ${i.duration}s ${i.easing}`), g(r, {
			...b,
			visibility: "visible",
			opacity: "1",
			"pointer-events": "auto"
		}), e?.open?.forEach((e) => ku[e.type](e.config, t)), a && d.length === 0) {
			let n = m.querySelector(":first-child")[0];
			l = (n) => {
				(Cu(n) || wu(n, y[0])) && h({ on: e }, t);
			};
			let r = p.map((e) => e.contentDocument?.body ? Tu(e.contentDocument.body, l) : null).filter(Boolean);
			d.push(Tu(v, l), Tu(n, l), ...r), d.forEach((e) => e.start());
		}
		if (f || (c = (n) => {
			if (n.type === "keydown" && !["Enter", " "].includes(n.key)) return;
			let r = [...n.composedPath()];
			["a", "button"].includes(r[0].tagName.toLowerCase()) && h({ on: e }, t);
		}, f = Tu(y[0], c), f.start()), o && !u) {
			let t = Su(y[0], o);
			s = (0, Gl.default)((r) => {
				xu(y[0], r.clientX, r.clientY) > t && h({ on: e }, {
					reportError: n,
					step: m,
					updateStyle: g,
					getWindowReference: _
				});
			}, 60), ru(v, "mousemove", s), p.forEach((e) => {
				e.contentDocument?.body && ru(e.contentDocument.body, "mousemove", s);
			}), u = !0;
		}
	};
	t("run", ({ on: e } = {}, t) => {
		let { step: n, reportError: i, getWindowReference: a } = t, o = n.querySelector(`#${r}`);
		if (Eu(r, o, i)) {
			if (a().getComputedStyle(o[0]).visibility === "hidden") {
				g({ on: e }, t);
				return;
			}
			h({ on: e }, t);
		}
	}), t("open", g), t("close", h), t("style", Ou);
}), Z("@appcues/coreEvents", ({ registerAction: e }) => {
	e("step_seen", (e, { step: t }) => {
		t.seen();
	}), e("extended_event", ({ name: e, ...t }, { step: n }) => {
		n.extendedEvent(e, t);
	}), e("step_interaction", (e, { step: t }) => {
		t.interaction(e.interactionType, e.interactionData);
	}), e("experience_dismissed", (e, { step: t }) => {
		t.dismissExperience();
	}), e("experience_snoozed", (e, { step: t }) => {
		t.snoozeExperience();
	});
});
//#endregion
//#region src/traits/store/helpers.js
var Au = (e, t = {}, n = () => window) => {
	let r = t, i = [], a = n().document, o = (e) => {
		let { el: t, callbackFn: n } = e.detail;
		i.push([t, n]), t[n].apply(e.target, [r]);
	};
	return a.addEventListener(`${e}:connect`, o), {
		getState: () => r,
		setState: (e) => {
			r = {
				...r,
				...e
			}, i.forEach(([e, t]) => {
				e[t].apply(e, [r]);
			});
		},
		destroy: () => {
			a.removeEventListener(`${e}:connect`, o);
		}
	};
};
Z("@appcues/store", ({ addHook: e, registerAction: t }, { id: n, initialState: r = {} }) => {
	let i;
	e("step.begin", ({ getWindowReference: e }) => {
		i = Au(n, r, e);
	}), e("step.end", () => {
		i && i.destroy();
	}), t("setState", ({ stateKey: e }, t, n) => {
		i && i.setState({ [e]: n?.detail });
	});
});
//#endregion
//#region src/traits/animate/animations.js
var ju = {
	slide_in_down: [{
		transform: "translate3d(0, -100%, 0)",
		visibility: "visible"
	}, { transform: "translate3d(0, 0, 0)" }],
	slide_out_down: [
		{
			transform: "translate3d(0, 0, 0)",
			offset: 0
		},
		{
			transform: "translate3d(0, 100%, 0)",
			offset: .99
		},
		{
			visibility: "hidden",
			offset: 1
		}
	],
	slide_in_up: [{
		transform: "translate3d(0, 100%, 0)",
		visibility: "visible"
	}, { transform: "translate3d(0, 0, 0)" }],
	pulse: [
		{ transform: "scale3d(1, 1, 1)" },
		{ transform: "scale3d(1.05, 1.05, 1.05)" },
		{ transform: "scale3d(1, 1, 1)" }
	]
}, Mu = "@appcues/animate", Nu = 500, Pu = "none", Fu = "button, [href], input, select, textarea, [tabindex]:not([tabindex=\"-1\"])", Iu = (e) => {
	let t = e?.activeElement;
	for (; t?.shadowRoot?.activeElement;) t = t.shadowRoot.activeElement;
	return t;
}, Lu = /* @__PURE__ */ new WeakMap(), Ru = (e) => {
	let t = ju[e?.effect] || e?.keyframes, n = Array.isArray(t) ? t[t.length - 1] : null;
	return n ? Number(n.opacity) === 0 || n.visibility === "hidden" || n.display === "none" : !1;
}, zu = (e, t) => new Promise((n) => {
	let { keyframes: r, duration: i = Nu, iterations: a, effect: o, fill: s = Pu, easing: c = "linear", composite: l } = t, u = ju[o] || r, d = {
		duration: i,
		iterations: a,
		fill: s,
		easing: c,
		...l ? { composite: l } : {}
	};
	if (!u) {
		n();
		return;
	}
	let f = e.animate(u, d);
	f?.addEventListener ? f.addEventListener("finish", n, { once: !0 }) : n();
});
Z(Mu, ({ addHook: e, registerAction: t }, n) => {
	if (n.phase === "exit") e("step.end", ({ querySelector: e }) => {
		let { target: t } = n;
		if (!t) return;
		let r = e(t.selector);
		if (r.length !== 0) return zu(r[0], n);
	});
	else {
		let t = !1;
		e("step.postrender", ({ querySelector: e }) => {
			if (t) return;
			let { target: r } = n;
			if (!r) return;
			let i = e(r.selector);
			i.length !== 0 && (t = !0, zu(i[0], n));
		});
	}
	t("toggle", ({ toggleGroupId: e, target: t, animations: n, autoFocus: r = !0 }, { querySelector: i, getWindowReference: a }) => {
		let o = i(t.selector);
		if (o.length === 0) return;
		let [s] = o, c = s.getAttribute(e) === n[0].id ? n[1] : n[0];
		if (!c) return;
		let l = Ru(c);
		l || (s.inert = !1);
		let u = r ? Iu(a?.()?.document) : null, d = zu(s, c);
		c.id && s.setAttribute(e, c.id);
		let f = () => c.id != null && s.getAttribute(e) !== c.id;
		if (!r) {
			l && d.then(() => {
				f() || (s.inert = !0);
			});
			return;
		}
		d.then(() => {
			if (!f()) if (l) {
				let e = Lu.get(s);
				e?.isConnected && e.focus({ preventScroll: !0 }), Lu.delete(s), s.inert = !0;
			} else u && Lu.set(s, u), (s.querySelector(Fu) ?? s).focus({ preventScroll: !0 });
		});
	}), t("run", async (e, t) => {
		let { querySelector: n, getAction: r } = t, { toggleGroupId: i, target: a, animation: o, ignoreToggleGroup: s = !1, onFinish: c = [] } = e;
		if (!a) return;
		let l = n(a.selector);
		if (l.length === 0) return;
		let u = l[0], d = u.getAttribute(i);
		(!d || d === o.id) && !s || (await zu(u, o ?? e), c.forEach((e) => {
			r(e.type)(e?.config ?? {}, t);
		}), s || u.setAttribute(i, o.id));
	});
});
//#endregion
//#region src/traits/floating/helpers.js
var Bu = {
	pixels: "px",
	percentage: "%"
};
function Vu(e, t, n, r) {
	let i = Bu[n] || "px";
	switch (e) {
		case "left": return {
			left: 0,
			transform: `translateX(${t}${i})`,
			...r && { right: "unset" }
		};
		case "center": return {
			left: "50%",
			transform: `translateX(calc(-50% + ${t}${i}))`,
			...r && { right: "unset" }
		};
		default: return {
			right: 0,
			transform: `translateX(-${t}${i})`,
			...r && { left: "unset" }
		};
	}
}
function Hu(e, t, n, r) {
	let i = Bu[n] || "px";
	switch (e) {
		case "top": return {
			top: 0,
			transform: `translateY(${t}${i})`,
			...r && { bottom: "unset" }
		};
		case "center": return {
			top: "50%",
			transform: `translateY(calc(-50% + ${t}${i}))`,
			...r && { bottom: "unset" }
		};
		default: return {
			bottom: 0,
			transform: `translateY(-${t}${i})`,
			...r && { top: "unset" }
		};
	}
}
Z("@appcues/floating", ({ addHook: e }) => {
	e("step.begin", ({ getTraitConfig: e, updateStyle: t, updateRootStyle: n }) => {
		let { target: r, strategy: i = "fixed", xOffset: a = 0, yOffset: o = 0, xPosition: s = "left", yPosition: c = "top", placementUnit: l = "pixels", unsetOppositeDirection: u = !1, applyToRoot: d = !1 } = e(), f = {
			position: i,
			...[Vu(s, a, l, u), Hu(c, o, l, u)].reduce((e, t) => {
				let { transform: n, ...r } = t;
				return n && (e.transform = e.transform ? `${e.transform} ${n}` : n), {
					...e,
					...r
				};
			}, {})
		};
		if (d) {
			n(f, { forceUpdate: !0 });
			return;
		}
		t(r.selector, f);
	});
});
//#endregion
//#region src/traits/dismissible/dismissible.js
var Uu = "@appcues/dismissible";
function Wu(e) {
	return `_experience_dismissed_${e}`;
}
Z(Uu, ({ addHook: e, registerAction: t }, { strategy: n = "permanent" }) => {
	function r(e, t) {
		return n === "session" ? t().sessionStorage.getItem(Wu(e)) === "1" : !1;
	}
	e("experience.begin", ({ stopExperience: e, getExperienceId: t, getWindowReference: n }) => {
		r(t(), n) && e();
	}), t("dismiss", (e, { stopExperience: t, updateUserProfile: r, getExperienceId: i, getWindowReference: a }) => {
		let o = Wu(i());
		n === "session" ? a().sessionStorage.setItem(o, "1") : n === "permanent" && r({ [o]: "permanently_dismissed" }), t();
	});
}), Z("@appcues/experienceStyle", ({ addHook: e }) => {
	e("step.begin", ({ updateRootStyle: e, getTraitConfig: t }) => {
		e(t(), { forceUpdate: !0 });
	}), e("step.container_change", ({ updateRootStyle: e, getTraitConfig: t }) => {
		e(t(), { forceUpdate: !0 });
	}), e("step.end", ({ updateRootStyle: e, getTraitConfig: t }) => {
		e(Object.keys(t()).reduce((e, t) => (e[t] = null, e), {}), { forceUpdate: !0 });
	});
});
//#endregion
//#region src/traits/rootStyle/root-style.js
var Gu = "@appcues/rootStyle", Ku = ({ getTraitConfig: e, updateRootStyle: t }) => {
	let { forceUpdate: n = !1, ...r } = e();
	t(r, { forceUpdate: n });
};
function qu({ addHook: e }) {
	e("step.begin", Ku), e("step.container_change", Ku);
}
Z(Gu, qu);
//#endregion
//#region ../sdk-middleware-events/dist/index.js
var Ju = "appcues:launchpad_close", Yu = "appcues:launchpad_search", Xu = "appcues:launchpad_search_error", Zu = "appcues:launchpad_search_response", Qu = function(e, t) {
	return window.addEventListener(e, t), function() {
		return window.removeEventListener(e, t);
	};
}, $u = function(e) {
	return Qu(Ju, e);
}, ed = function(e, t, n) {
	var r = new CustomEvent(Yu, { detail: {
		integrationId: e,
		query: t,
		experienceId: n
	} });
	window.dispatchEvent(r);
}, td = function(e, t) {
	return Qu(`${Zu}:${e}`, t);
}, nd = function(e, t) {
	return Qu(`${Xu}:${e}`, t);
};
Z("@appcues/sdk-middleware-events", ({ addHook: e }, { onLaunchpadClose: t }) => {
	let n;
	e("step.begin", (e) => {
		n = $u(() => {
			t.forEach((t) => {
				e.getAction(t.type)?.(t.config, e);
			});
		});
	}), e("step.end", () => {
		n?.();
	});
});
//#endregion
//#region src/traits/knowledgeBaseIntegration/knowledge-base-integration.js
var rd = "@appcues/knowledge-base-integration", id = (e, { querySelector: t, reportError: n }) => {
	let r = t(e), i = r.length > 1, a = r.length === 0;
	return i && n("The target element is duplicated, please provide a more specific selector"), a && n("The target element is not found"), r[0];
};
Z(rd, ({ addHook: e, registerAction: t }, n) => {
	let { integrationConnected: r = !1 } = n, i, a, o, s, c, l = () => {
		r && a?.prev();
	}, u = (e) => {
		if (!r) return;
		let { integrationId: t } = n, { inputValue: l } = e.detail;
		o.setAttribute("searchTerm", l), o.setAttribute("state", "loading"), i.setAttribute("loading", !0), s && (s.scrollTop = 0), a?.next(), ed(t, l, c);
	};
	e("step.begin", ({ getExperienceId: e }) => {
		c = e(), td(c, (e) => {
			let t = e.detail, n = t.results?.length === 0 ? "empty" : "showing_results";
			o.setAttribute("state", n), o.setAttribute("results", JSON.stringify(t.results)), i.setAttribute("loading", !1);
		}), nd(c, () => {
			o.setAttribute("state", "error"), i.setAttribute("loading", !1);
		});
	}), e("step.end", () => {
		i?.removeEventListener("onSearch", u), i?.removeEventListener("onCancel", l);
	}), t("bindListeners", (e, t) => {
		let { navigation: r } = n;
		(!a || !i) && (a = id(r.selector, t), i = id("appcues-search-header", t), o = id("appcues-search-results", t), s = id("#launchpad-container", t), i?.addEventListener("onSearch", u), i?.addEventListener("onCancel", l));
	});
});
//#endregion
//#region src/traits/sequential/sequential.js
var ad = "@appcues/sequential", od = (e, t) => e.findIndex((e) => e.getConfig()?.id === t);
Z(ad, ({ addHook: e, registerAction: t }) => {
	let n, r = "forward", i = (e, { steps: t }, i) => {
		r = "backward", n !== 0 && t[n].stop(() => {
			--n, t[n].start();
		}, i);
	}, a = (e, { steps: t }, i) => {
		if (r = "forward", n === t.length - 1) {
			t[n].stop(void 0, i);
			return;
		}
		t[n].stop(() => {
			n += 1, t[n].start();
		}, i);
	};
	e("experience.begin", ({ steps: e, getTraitConfig: t, reportError: r }) => {
		let { startStepId: i } = t() ?? {};
		if (i) {
			let t = od(e, i);
			t === -1 && r(`startStepId "${i}" did not match any step; starting at 0`), n = t === -1 ? 0 : t;
		} else n = 0;
		e[n].start();
	}), t("next", a), t("prev", i), t("goTo", (e, { step: t, steps: i }, a) => {
		let o = od(i, e.stepId);
		o !== -1 && (r = "forward", t.stop(() => {
			n = o, i[n].start();
		}, a));
	}), t("skip", (e, t, n) => r === "backward" ? i(e, t, n) : a(e, t, n));
});
//#endregion
//#region src/traits/delay/delay.js
var sd = "@appcues/delay", cd = 3e5;
Z(sd, ({ addHook: e }, t) => {
	let n = null;
	e("step.begin", () => {
		let e = t?.duration;
		if (!e) return;
		let r = Math.min(e, cd);
		return r !== e && console.warn(`[@appcues/delay] duration ${e}ms exceeds the 5-minute maximum (${cd}ms) and has been capped.`), new Promise((e) => {
			n = setTimeout(e, r);
		});
	}), e("step.end", () => {
		n !== null && (clearTimeout(n), n = null);
	});
});
//#endregion
//#region src/traits/dialog/backdrops/constants.js
var ld = "appcues-cutout-backdrop", ud = "appcues-custom-backdrop", dd = "apc-spotlight", fd = "\n  :where(dialog) { all: unset; }\n", pd = "\n  ::backdrop { backdrop-filter: var(--backdrop-blur); background-color: var(--backdrop-color); }\n", md = ({ backdropBlur: e, backdropColor: t }) => ({
	...e && { "--backdrop-blur": e },
	...t && { "--backdrop-color": t }
}), hd = ({ getWindowReference: e, backdropZIndex: t, backdropBlur: n, backdropColor: r }) => {
	if (e().document.querySelector("#appcues-custom-backdrop")) return null;
	let i = e().document.createElement("div");
	return i.id = ud, i.style.cssText = `
    z-index: ${t};
    position: fixed;
    inset: 0;
    backdrop-filter: ${n};
    background-color: ${r};
    pointer-events: none;
  `, i;
}, gd = /* @__PURE__ */ c({
	build: () => xd,
	update: () => Sd
}), _d = 1500, vd = .67, yd = (e) => {
	Object.assign(e.style, {
		position: "fixed",
		top: "0",
		left: "0",
		width: "100vw",
		height: "100vh",
		overflow: "hidden",
		pointerEvents: "none"
	});
}, bd = (e, t) => {
	let { top: n, left: r, width: i, height: a } = t;
	Object.assign(e.style, {
		position: "absolute",
		top: `${n - _d}px`,
		left: `${r - _d}px`,
		height: `${a ? a + 2 * _d : 0}px`,
		width: `${i ? i + 2 * _d : 0}px`,
		boxSizing: "border-box",
		border: `${_d}px solid transparent`,
		pointerEvents: "none",
		borderImage: `radial-gradient(transparent 2%, rgba(0,0,0,${vd}) 28%) 49% 49% 49% 49%`,
		boxShadow: `0 0 0 2500px rgba(0,0,0,${vd})`
	});
}, xd = ({ document: e, rect: t, zIndex: n }) => {
	let r = e.createElement("div");
	r.id = ld, yd(r), r.style.zIndex = n;
	let i = e.createElement("div");
	return i.className = dd, bd(i, t), r.append(i), r;
}, Sd = ({ container: e, rect: t }) => {
	let n = e.firstElementChild;
	n && bd(n, t);
}, Cd = /* @__PURE__ */ c({
	build: () => kd,
	update: () => Ad
}), wd = .5, Td = (e) => {
	Object.assign(e.style, {
		position: "fixed",
		top: "0",
		left: "0",
		width: "100vw",
		height: "100vh",
		pointerEvents: "none"
	});
}, Ed = (e, t, n) => {
	let { top: r, left: i, width: a, height: o } = n;
	Object.assign(e.style, {
		position: "absolute",
		top: `${r}px`,
		left: `${i}px`,
		width: `${a}px`,
		height: `${o}px`,
		overflow: "hidden",
		pointerEvents: "none"
	}), Object.assign(t.style, {
		position: "relative",
		width: `${a}px`,
		height: `${o}px`,
		boxShadow: `0px 0px 0px 2000px rgba(0,0,0,${wd})`,
		borderRadius: "0px",
		pointerEvents: "none"
	});
}, Dd = (e, t, n, r, i) => {
	Object.assign(e.style, {
		position: "absolute",
		top: `${t}px`,
		left: `${n}px`,
		width: `${r}px`,
		height: `${i}px`,
		background: `rgba(0,0,0,${wd})`,
		pointerEvents: "all"
	});
}, Od = ([e, t, n, r], i, a) => {
	let { top: o, left: s, right: c, bottom: l, width: u } = i, d = a.innerWidth, f = a.innerHeight;
	Dd(e, 0, s, u, Math.max(0, o)), Dd(t, 0, c, Math.max(0, d - c), f), Dd(n, l, s, u, Math.max(0, f - l)), Dd(r, 0, 0, Math.max(0, s), f);
}, kd = ({ document: e, win: t, rect: n, zIndex: r }) => {
	let i = e.createElement("div");
	i.id = ld, Td(i), i.style.zIndex = r;
	let a = e.createElement("div"), o = e.createElement("div");
	return o.className = dd, Ed(a, o, n), a.append(o), i.append(a), Od([
		"top",
		"right",
		"bottom",
		"left"
	].map((t) => {
		let n = e.createElement("div");
		return n.className = dd, n.setAttribute("aria-label", `${t}-panel`), i.append(n), n;
	}), n, t), i;
}, Ad = ({ container: e, win: t, rect: n }) => {
	let r = e.children[0], i = r?.firstElementChild;
	r && i && Ed(r, i, n);
	let a = [...e.children].slice(1);
	a.length === 4 && Od(a, n, t);
}, jd = {
	soft: gd,
	hard: Cd
}, Md = (e) => e in jd, Nd = ({ getWindowReference: e, target: t, backdropType: n, zIndex: r }) => {
	let i = e(), a;
	try {
		a = i.document.querySelector(t);
	} catch {
		a = null;
	}
	if (!a) return null;
	let o = a.getBoundingClientRect(), s = {
		document: i.document,
		win: i,
		rect: o,
		zIndex: r
	};
	return jd[n].build(s);
}, Pd = ({ container: e, getWindowReference: t, target: n, backdropType: r }) => {
	let i = t(), a;
	try {
		a = i.document.querySelector(n);
	} catch {
		a = null;
	}
	if (!a || !e) return;
	let o = a.getBoundingClientRect();
	jd[r].update({
		container: e,
		win: i,
		rect: o
	});
}, Fd = new Set([pr, mr]), Id = (e) => e.id === "appcues-cutout-backdrop" || Fd.has(e.tagName), Ld = (e, t) => {
	if (!t) return null;
	try {
		return e.querySelector(t);
	} catch {
		return null;
	}
}, Rd = (e, { targetSelector: t } = {}) => {
	let { body: n } = e.document, r = /* @__PURE__ */ new Set(), i = Ld(n, t);
	for (let e of n.children) !Id(e) && !e.inert && !e.contains(i) && (e.inert = !0, r.add(e));
	return () => {
		for (let e of r) e.inert = !1;
	};
};
Z("@appcues/dialog", ({ addHook: e }, t) => {
	let { backdrop: n, variables: r, customBackdrop: i, inlineBackdrop: a = !1, target: o, autoFocus: s = !0 } = t, { dialogZIndex: c, backdropZIndex: l, backdropBlur: u, backdropColor: d } = r || {}, f = {
		backdrop: null,
		dialog: null
	}, p, m, h, g, _, v, y = (e, t, n) => {
		f[e]?.remove();
		let r = n.document.createElement("style");
		r.textContent = t, p.prepend(r), f[e] = r;
	}, b = () => {
		g && _ && (g.removeEventListener("scroll", _, !0), g.removeEventListener("resize", _));
	};
	if (n === !0 && !i && !o) {
		let t = ({ getTraitConfig: e, updateRootStyle: t }) => {
			let { variables: n } = e();
			t(md(n || {}), { forceUpdate: !0 });
		};
		e("step.begin", t), e("step.container_change", t);
	}
	e("step.postrender", ({ step: e, getWindowReference: t, getTraitConfig: x }) => {
		let S = x(), C = S.backdrop ?? n, w = S.customBackdrop ?? i, T = S.target ?? o, E = S.autoFocus ?? s, D = S.inlineBackdrop ?? a, O = S.variables ?? r ?? {}, k = O.dialogZIndex ?? c, A = O.backdropZIndex ?? l, j = O.backdropBlur ?? u, M = O.backdropColor ?? d;
		[p] = e.querySelector("dialog") ?? [];
		let N = t();
		if (p) {
			C === !0 && w ? (m?.remove(), m = hd({
				getWindowReference: t,
				backdropZIndex: A,
				backdropBlur: j,
				backdropColor: M
			}), m && (D && p.parentNode ? p.parentNode.insertBefore(m, p) : N.document.body.append(m))) : (m?.remove(), m = void 0), C === !0 && !w && !T ? y("backdrop", pd, N) : (f.backdrop?.remove(), f.backdrop = null), y("dialog", fd, N), p.style.zIndex = k, p.removeAttribute("autofocus");
			let e = C === !0 && !w && !T ? "showModal" : "show";
			if (e === "show" && !T) return;
			let n = e === "show" ? {
				x: N.scrollX,
				y: N.scrollY
			} : null, r = p.open;
			p[e](), n && (N.scrollX !== n.x || N.scrollY !== n.y) && N.scrollTo(n.x, n.y), e === "show" && E && !r && p.focus({ preventScroll: !0 });
		}
		b(), v?.(), h?.remove(), h = void 0, T && Md(C) && (g = t(), h = Nd({
			getWindowReference: t,
			target: T,
			backdropType: C,
			zIndex: (k ?? 2) - 1
		}), h && (g.document.body.append(h), _ = () => Pd({
			container: h,
			getWindowReference: t,
			target: T,
			backdropType: C
		}), g.addEventListener("scroll", _, !0), g.addEventListener("resize", _), C === "hard" && (v = Rd(g, { targetSelector: T }))));
	}), e("step.end", () => {
		p?.close(), f.backdrop?.remove(), f.dialog?.remove(), m?.remove(), h?.remove(), b(), v?.();
	});
}), Z("@appcues/experienceTheme", ({ addHook: e }) => {
	let t = null;
	function n({ getContainer: e, getExperienceId: n, getWindowReference: r, getTraitConfig: i }) {
		let { css: a } = i(), o = e();
		if (!a || t && t.parentNode === o) return;
		let s = n();
		o && (t = r().document.createElement("style"), t.id = `appcues-experience-style-${s}`, t.textContent = a, o.prepend(t));
	}
	function r() {
		t &&= (t.remove(), null);
	}
	e("step.begin", n), e("experience.end", r);
}), Z("@appcues/navigation", ({ addHook: e }, t) => {
	e("step.begin", async ({ handleNavigation: e, reportError: n }) => {
		if (t?.type) try {
			await e(t);
		} catch (e) {
			n(e?.message ?? "Navigation failed");
		}
	});
}), Z("@appcues/scroll-into-view", ({ addHook: e }) => {
	let t = !1;
	e("step.postrender", ({ getTraitConfig: e, querySelector: n, getWindowReference: r }) => {
		if (t) return;
		let { target: i, behavior: a = "smooth", block: o = "nearest", inline: s = "nearest" } = e();
		if (!i?.selector) return;
		let c = ou(n(i.selector), i.filters);
		if (c.length === 0) return;
		let l = c[0], { innerWidth: u, innerHeight: d } = r(), { top: f, left: p, bottom: m, right: h } = l.getBoundingClientRect();
		if (f >= 0 && p >= 0 && m <= d && h <= u) {
			t = !0;
			return;
		}
		l.scrollIntoView({
			behavior: a,
			block: o,
			inline: s
		}), t = !0;
	}), e("step.end", () => {
		t = !1;
	});
});
//#endregion
//#region src/traits/advance-on-error/advance-on-error.js
var zd = "@appcues/advance-on-error", Bd = 3e5, Vd = "@appcues/sequential.next", Hd = "@appcues/sequential.skip", Ud = (e) => e === Vd ? Hd : e;
Z(zd, ({ addHook: e }, t) => {
	let n = null, r = () => {
		n !== null && (clearTimeout(n), n = null);
	};
	e("step.error", (e) => {
		r();
		let { getAction: i } = e, a = Number(t?.duration ?? 500), o = Number.isFinite(a) ? a : 500, s = t?.action;
		s?.type && (n = setTimeout(() => {
			n = null;
			let t = i(Ud(s.type));
			t && t(s.config ?? {}, e, X.ERROR);
		}, Math.min(Math.max(o, 0), Bd)));
	}), e("step.prebegin", r), e("step.end", r);
});
//#endregion
//#region src/core/components/appcues-container.js
var Wd = (e) => class extends e.HTMLElement {
	constructor() {
		super();
		let t = this.ownerDocument || e.document;
		this.hideContentStyles = t.createElement("style"), this.hideContentStyles.innerHTML = "\n        * {\n          visibility: hidden;\n        }\n      ";
		try {
			this.attachShadow({ mode: "open" });
		} catch {}
		this.webComponentStyles = t.createElement("style"), this.webComponentStyles.innerHTML = "\n        :host {\n          all: initial;\n          font-family: inherit;\n          display: inline;\n        }\n      ";
	}
	async connectedCallback() {
		this.shadowRoot.append(this.hideContentStyles), this.shadowRoot.append(...this.childNodes), this.getAttribute("themeId") && await ri(this), this.shadowRoot.prepend(this.webComponentStyles), this.hideContentStyles.remove();
	}
}, Gd = /* @__PURE__ */ new WeakMap(), Kd = (e = () => window) => {
	let t = e();
	if (Gd.has(t)) return Gd.get(t);
	if (!t.customElements.get("appcues-experience-container")) {
		let e = Wd(t);
		t.customElements.define(fr, e);
	}
	let n = t.customElements.whenDefined(fr);
	return Gd.set(t, n), n;
};
//#endregion
//#region src/core/index.js
function qd({ runningExperiences: e = /* @__PURE__ */ new Map(), sendEvent: t = () => {}, sendCustomEvent: n = () => {}, showFlow: r = () => {}, updateUserProfile: i = () => {}, handleNavigation: a = () => {}, createRenderListener: o = ms, vNodeHandlers: s = xs, accessibilityHandlers: c = Fs, getWindowReference: l = () => window, apiOverrides: u = {} } = {}) {
	Xr(u);
	let d = /* @__PURE__ */ new Map(), f = /* @__PURE__ */ new Map(), p = {
		sendEvent: t,
		sendCustomEvent: n,
		showFlow: r,
		updateUserProfile: i,
		handleNavigation: a,
		createRenderListener: o,
		vNodeHandlers: s,
		accessibilityHandlers: c,
		getWindowReference: l,
		apiOverrides: u,
		getExperienceSend: (e) => f.get(e)
	}, m = (e) => e ? p?.[e] ? p[e] : () => {
		throw Error(`can't find external dependency called ${e}`);
	} : p, h = (e, t) => {
		f.set(e, (e) => t.send(e));
	}, g = ({ reason: t = X.NAVIGATION } = {}) => {
		e.forEach((e) => {
			e.experienceService.send({
				type: kn,
				reason: t
			}), e.experienceService.subscribe((t) => {
				t.matches("end-final") && e.experienceService.stop();
			});
		}), e.clear(), f.clear();
	}, _ = (t, { reason: n = X.NAVIGATION } = {}) => {
		e.has(t) && (e.get(t).experienceService.send({
			type: kn,
			reason: n
		}), e.delete(t), f.delete(t));
	};
	return {
		registerAction: ki,
		registerTrait: Z,
		show: async (t) => {
			Kd(l), await l().customElements.whenDefined(fr);
			let n = yn(yn(t, "traits", (e) => (e ?? []).map((e, t) => ({
				...e,
				id: e.id || `${e.type}:${t}`
			}))), "steps", (e) => (e ?? []).map((e) => yn(e, "traits", (e) => (e ?? []).map((e, t) => ({
				...e,
				id: e.id || `${e.type}:${t}`
			}))))), r = e.get(t.id)?.experienceService ?? ce(ds(n, m)).start();
			h(t.id, r), r.send({
				type: On,
				experience: n
			}), e.set(t.id, {
				experienceService: r,
				experience: n
			});
		},
		stopAll: g,
		stop: _,
		pause: (t) => {
			if (d.get(t)) return;
			let n = e.get(t);
			n && (_(t), d.set(t, {
				experienceService: n.experienceService,
				experience: n.experience
			}));
		},
		resume: (t) => {
			let n = d.get(t);
			n && (n.experienceService.send({ type: On }), e.set(t, {
				experienceService: n.experienceService,
				experience: n.experience
			}), h(t, n.experienceService), d.delete(t));
		},
		getRunningExperiences: () => [...e].map(([, { experience: e }]) => e),
		isExperiencePaused: (e) => d.has(e)
	};
}
//#endregion
export { qd as default };
